import * as da from "casual-browserify";
import * as la from "graphql-tag";
import * as ua from "graphql";
import * as ga from "currency-codes";
import * as pa from "apollo-client";
import * as ma from "apollo-cache-inmemory";
import * as Sa from "apollo-link-schema";
import * as ya from "graphql-tools";
import * as Ca from "@mqd/mqd-constants";
function Ta(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function B(t) {
  if (t.__esModule)
    return t;
  var n = t.default;
  if (typeof n == "function") {
    var a = function u() {
      return this instanceof u ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    a.prototype = n.prototype;
  } else
    a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(t).forEach(function(u) {
    var S = Object.getOwnPropertyDescriptor(t, u);
    Object.defineProperty(a, u, S.get ? S : {
      enumerable: !0,
      get: function() {
        return t[u];
      }
    });
  }), a;
}
const Ia = {
  boxFolderInfo: `
    fragment boxFolderInfo on BoxFolder {
      total_count
      limit
      offset
    }
  `,
  boxFolderItemInfo: `
    fragment boxFolderItemInfo on BoxFolderItem {
      id
      type
      name
      content_created_at
      content_modified_at
      created_at
      description
    }
  `,
  boxFolderItemSharedLinkInfo: `
    fragment boxFolderItemSharedLinkInfo on BoxFolderItemSharedLink {
      download_url
      url
      vanity_url
    }
  `,
  boxFolderOrderInfo: `
    fragment boxFolderOrderInfo on BoxOrderObject {
      by
      direction
    }
  `
};
var fa = Ia;
const Da = {
  caseBaseInfo: `
    fragment caseBaseInfo on Case {
      assignee
      business_token
      cardholder_token
      created_time
      folder_access_token
      folder_id
      folder_shared_link
      last_modified_time
      memo
      network_comment
      program_short_code
      state
      token
      type
      type_change_time
    }
  `,
  disputeDetailsInfo: `
    fragment disputeDetailsInfo on DisputeDetails {
      associated_transaction_selection_required
      cardholder_contact_date
      currency_code
      dispute_amount
      dispute_amount_change_reason
      dispute_reason
      dispute_reason_code
      dispute_state
      chargeback_token
      fraud_dispute_type_details {
        general_fraud_type_dispute_details {
          chip_on_card
        }
      }
      fraud_category_type_dispute_details {
        fraud_type
      }
      fraud_classification_type_dispute_details {
        fraud_type_classification
      }
      partial_dispute_resolution {
        final_resolution_type
        final_cardholder_resolution_amount
        amount_reversed
      }
      network_case_number
      network_failure_response
      original_transaction_token
      account_status
      original_transaction_type
      provisional_credit_granted
      regulation_details {
         pc_grant_days_to_act
         pc_perm_days_to_act
         pc_reversed_coms_days_to_act
         pc_reversed_days_to_act
      }
      regulation_type
    }
  `,
  caseDocumentInfo: `
    fragment caseDocumentInfo on CaseDocument {
      token
      case_token
      document_category
      document_name
      created_time
      last_modified_time
      document_content_type
      download_link
      network_process_phase
    }
  `,
  caseEventInfo: `
    fragment caseEventInfo on CaseEvent {
      created_by
      category
      event_date
      name
      created_time
    }
  `,
  caseMilestoneInfo: `
    fragment caseMilestoneInfo on Milestone {
      case_token
      category
      sub_category
      milestone
      next_milestone_due_date
      created_time
      last_modified_time
    }
  `,
  networkCaseStatusDetailsInfo: `
    fragment networkCaseStatusDetailsInfo on NetworkCaseStatusDetails {
      allowable_actions
      network
      network_case_number
      case_status
      current_case_amount
      next_actor
      days_to_act
      last_action_date
      case_opened_date
      last_refresh_date
      created_time
      last_modified_time
    }
  `,
  caseTransitionInfo: `
  fragment caseTransitionInfo on CaseTransition {
      token
      case_token
      action
      reason_code
      created_by
      memo
      assignee
      reason_description
      failure_reason
      state
    }
  `,
  associatedTransactionInfo: `
    fragment associatedTransactionInfo on AssociatedTransaction {
      network_type
      token
      case_token
      transaction_date
      transaction_amount
      transaction_currency
      transaction_currency_alpha
      merchant_name
      network_associated_transaction_group_id
      transaction_type
      transaction_id
      auth_code
      arn
      retrieval_reference_number
      matching_pass
      matching_score
      network_submission_status
      network_reject_reason
      first_network_submission_time
      last_network_submission_time
      created_time
      last_modified_time
      network_submission_failure_reason
      associated
    }
  `,
  networkSelectionFormInfo: `
    fragment networkSelectionFormInfo on NetworkSelectionForm {
      network_type
      credit_change_reason
      auth_change_reason
      associated
    }
  `,
  /* ConsumerDisputeTypeDisputeDetails QUESTIONNAIRE FRAGMENTS */
  serviceNotProvidedMerchandiseNotReceivedDetailsInfo: `
    fragment serviceNotProvidedMerchandiseNotReceivedDetailsInfo on ServiceNotProvidedMerchandiseNotReceivedDetails {
      what_is_the_amount_on_the_cardholders_receipt
      does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token
      what_is_the_currency_on_the_cardholders_receipt
      detailed_description_of_what_was_purchased_and_explanation_of_the_dispute
      is_merchant_in_bankruptcy_liquidation
      merchandise_delivered_late
      non_fiat_currency_not_delivered
      did_the_cardholder_return_the_merchandise
      expected_receipt_date
      expected_receipt_time
      did_cardholder_cancel_prior_to_the_expected_date
      cancellation_date
      cancellation_reason
      did_cardholder_attempt_to_resolve_dispute_with_merchant
      is_attempt_to_resolve_prohibited_by_local_law_or_regulations
      provide_details_of_local_law_or_regulations
      merchandise_or_services
      was_merchandise_delivered_to_wrong_location
      address_of_agreed_location
      did_cardholder_return_merchandise
      date_cardholder_returned_merchandise
      date_merchant_received_returned_merchandise
      did_cardholder_attempt_to_return_merchandise
      date_of_attempted_return
      explain_how_merchandise_was_returned
      third_party_gift_card_indicator
      visa_commercial_card_virtual_account_indicator
      did_virtual_account_holder_suffer_financial_loss
      did_merchant_cancel_services
      date_merchant_cancelled_services
      did_merchant_cancel_merchandise
      date_merchant_cancelled_merchandise
      explanation_dispute_prior_expected_delivery_date
      agreed_delivery_date_or_service_date
      date_of_return
      cash_over_indicator
    }
  `,
  cancelledRecurringTransactionDetailsInfo: `
    fragment cancelledRecurringTransactionDetailsInfo on CancelledRecurringTransactionDetails {
      cancellation_date
      cancellation_reason
      date_issuer_informed_merchant_of_account_closure
      contact_merchant_details
      other_form_of_payment_ind
      other_form_of_payment_desc
      contact_method_with_merchant_ind
      contact_method_merchant_email_ind
      contact_merchant_details_email_address
      contact_method_merchant_call_center_ind
      contact_method_merchant_mail_ind
      contact_method_merchant_SMS_ind
      contact_merchant_details_phone_number
      contact_method_merchant_in_person_ind
      contact_merchant_details_physical_address
      contact_method_merchant_webform_ind
      contact_merchant_details_application_name
      cancelled_recurring_payment_date
      recurring_payment_plan_expiry_date
      is_dispute_impacted_by_local_law_or_regulation
    }
  `,
  notAsDecribedOrDefectiveMerchandiseDetailsInfo: `
    fragment notAsDecribedOrDefectiveMerchandiseDetailsInfo on NotAsDecribedOrDefectiveMerchandiseDetails {
      cancellation_date
      cancellation_reason
      cardholder_merchant_previous_negotiation_evidence
      date_cardholder_returned_the_merchandise
      date_merchandise_or_service_was_received
      date_merchandise_was_received
      date_merchant_received_the_returned_merchandise
      date_of_attempted_return
      date_the_cardholder_first_notified_the_issuer_of_the_dispute
      did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant
      did_the_cardholder_attempt_to_return_the_merchandise
      did_the_cardholder_cancel_the_services
      did_the_cardholder_return_the_merchandise
      did_the_merchandise_or_services_differ_from_what_was_described_on_the_receipt
      does_the_dispute_involve_merchandise_or_services_provided_that_do_not_match_the_merchants_verbal_description
      explain_how_the_merchandise_was_returned
      explain_prev_negotiation
      is_attempt_to_resolve_prohibited_by_local_law_or_regulations
      merchandise_or_services
      merchant_refuse_advise
      not_as_described_or_defective
      what_is_the_disposition_of_the_merchandise
      provide_a_detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise
      provide_details_of_local_law_or_regulations
      provide_details_of_what_was_ordered_and_not_as_described
      return_method
      tracking_number
      what_was_ordered_and_how_it_was_damaged_or_defective
      when_negotiations_begin
      motive_code
      merchandise_counterfeit_confirmation_date
      promised_delivery_date
      cash_over_indicator
    }
  `,
  creditNotProcessedDetailsInfo: `
    fragment creditNotProcessedDetailsInfo on CreditNotProcessedDetails {
      credit_voucher_transaction_receipt_or_refund_acknowledgement_date
      date_cardholder_returned_cancelled_merchandise
      is_the_credit_voucher_transaction_receipt_or_refund_acknowledgement_dated
      was_a_credit_voucher_voided_transaction_receipt_or_refund_acknowledgement_given
      date_of_cancellation
      date_of_return
      cash_over_indicator
    }
  `,
  cancelledMerchandiseOrServicesDetailsInfo: `
    fragment cancelledMerchandiseOrServicesDetailsInfo on CancelledMerchandiseOrServicesDetails {
      merchandise_or_services
      describe_what_was_purchased
      date_cardholder_received_or_expected_to_receive_merchandise
      did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant
      provide_details_of_local_law_or_regulations
      did_the_cardholder_return_the_merchandise
      date_of_return
      date_merchant_received_returned_merchandise
      return_method
      tracking_number
      explain_how_the_merchandise_was_returned
      did_the_cardholder_attempt_to_return_the_merchandise
      date_of_attempted_return
      detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise
      did_cardholder_cancel
      cancellation_date
      cancellation_reason
      was_cancellation_policy_provided
      type_of_service
      date_of_service_or_expected_service
      cancelled_guaranteed_reservation_certification_selection
      is_attempt_to_resolve_prohibited_by_local_law_or_regulations
      merchant_refuse_advise
      what_is_the_disposition_of_the_merchandise
    }
  `,
  misrepresentationDetailsInfo: `
    fragment misrepresentationDetailsInfo on MisrepresentationDetails {
      did_cardholder_cancel
      cancellation_date
      cancellation_reason
      cardholder_attempt_to_resolve
      attempt_to_resolve_proh_local_law
      merchandise_or_services
      how_merchandise_service_misrepresented
      describe_what_was_purchased
      service_received_date
      merchandise_received_date
      cardholder_return_merchandise_ind
      shipping_tracking_number
      cardholder_attempt_return_merchandise
      attempted_return_date
      how_ch_attempt_return_and_disp_of_merchandise
      merchant_refuse_ind
      cardholder_returned_merchandise_date
      merchant_received_returned_merchandise_date
      return_method
      how_merchandise_returned
    }
  `,
  originalCreditNotAcceptedDetailsInfo: `
    fragment originalCreditNotAcceptedDetailsInfo on OriginalCreditNotAcceptedDetails {
      explain_reason
    }
  `,
  counterfeitMerchDetailsInfo: `
    fragment counterfeitMerchDetailsInfo on CounterfeitMerchDetails {
      what_was_ordered
      provide_information_about_the_entity_that_indicated_the_merchandise_to_be_counterfeit
      describe_the_disposition_of_counterfeit_merchandise
      describe_the_counterfeit_merchandise
      date_the_cardholder_received_the_merchandise_or_notification
      certification_the_merchandise_was_identified_as_counterfeit_by_one_of_the_following
    }
  `,
  /* ProcessingErrorTypeDisputeDetails QUESTIONNAIRE FRAGMENTS */
  duplicateProcessingDetailsInfo: `
    fragment duplicateProcessingDetailsInfo on DuplicateProcessingDetails {
      error_type
      both_transactions_in_same_account
      other_transaction_reference_token
      other_visa_transaction_reference_id
      other_visa_transaction_mcsn
      transaction_in_different_visa_account
      is_other_transaction_with_same_merchant
      provided_proof_of_other_means_type
      is_evidence_of_merchant_passed_funds_provided
      cardholder_attempted_to_resolve
      is_attempt_to_resolve_prohibited_by_local_law
      other_visa_transaction_arn
      other_visa_transaction_information 
    }
  `,
  latePresentmentDetailsInfo: `
    fragment latePresentmentDetailsInfo on LatePresentmentDetails {
      account_status
      cash_over_indicator
    }
  `,
  noAuthorizationDetailsInfo: `
    fragment noAuthorizationDetailsInfo on NoAuthorizationDetails {
      cash_over_indicator
    }
  `,
  invalidDataDetailsInfo: `
    fragment invalidDataDetailsInfo on InvalidDataDetails {
      authorization_request_declined_valid_data
      explain_why_valid_data_inclusion_reason
    }
  `,
  incorrectTransactionCodeDetailsInfo: `
    fragment incorrectTransactionCodeDetailsInfo on IncorrectTransactionCodeDetails {
      how_is_transaction_code_incorrect
      explain_why_the_credit_refund_was_processed_in_error
      credit_confirmation_number
      date_of_return
      return_method
    }
  `,
  incorrectCurrencyDetailsInfo: `
    fragment incorrectCurrencyDetailsInfo on IncorrectCurrencyDetails {
      incorrect_currency_reason
      what_was_the_correct_currency
      certification_that_the_cardholder_did_not_agree_to_dynamic_currency_conversion_and_did_not_make_an_active_choice
    }
  `,
  incorrectAccountNumberDetailsInfo: `
    fragment incorrectAccountNumberDetailsInfo on IncorrectAccountNumberDetails {
      is_the_account_number_on_the_issuers_master_file
      does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token
    }
  `,
  incorrectTransactionAmountDetailsInfo: `
    fragment incorrectTransactionAmountDetailsInfo on IncorrectTransactionAmountDetails {
      what_is_the_amount_on_the_cardholders_receipt
      what_is_the_currency_on_the_cardholders_receipt
      is_the_dispute_due_to_the_difference_between_quoted_price_and_actual_charges_made_by_the_merchant
      cash_over_indicator
    }
  `,
  disputeTransitionDetailsInfo: `
    fragment disputeTransitionDetailsInfo on DisputeTransition {
      case_token
      action
      created_by
      created_time
      last_modified_time
      memo
      from_network_status
      to_network_status
      network_dispute_id
      system_error_message
      network_error_message
    }
  `,
  networkDetailsInfo: `
    fragment networkDetailsInfo on NetworkDetails {
      dispute_state
      created_time
      network_attached_contents
    }
  `,
  arbitrationDetailsInfo: `
    fragment arbitrationDetailsInfo on ArbitrationDetails {
      attached_contents
    }
  `,
  caseCloseDetailsInfo: `
    fragment caseCloseDetailsInfo on CaseCloseDetails {
      write_off
      write_off_actor
    }
  `,
  representmentDetailsInfo: `
   fragment representmentDetailsInfo on RepresentmentDetails {
      attached_contents
      amount
    }
  `,
  prearbitrationResponseDetailsInfo: `
   fragment prearbitrationResponseDetailsInfo on PrearbitrationResponseDetails {
      amount
      attached_contents
      prearb_response_decision
      partial_acceptance_amount
      why_are_you_not_accepting_liability
      certify_that_cardholder_continues_dispute
      explanation_cardholder_continues_dispute
      certify_cardholder_details_dont_match_issuer_records
      explanation_continuing_the_dispute
    }
  `,
  prearbitrationDetailsInfo: `
    fragment prearbitrationDetailsInfo on PrearbitrationDetails {
      attached_contents
      amount
      why_are_you_initiating_prearbitration
      are_you_providing_new_information
      summary_of_new_information
      filed_against_ica
      filing_ica
      network_memo
      merchant_name
      comment
      prearbitration_response_decision
      why_are_you_not_accepting_liability
      certify_that_you_have_contacted_cardholder_and_reviewed_the_compelling_evidence_with_them_and_cardholder_continues_dispute
      explanation_of_why_cardholder_continues_dispute
      certify_that_cardholder_name_and_address_provided_by_acquirer_does_not_match_issuer_records
      explanation_of_why_you_are_continuing_the_dispute
    }
  `,
  networkStateDetailsInfo: `
    fragment networkStateDetailsInfo on NetworkStateDetails {
      recall_ind
      liability_not_accepted_fully
      dispute_amount_change_ind
      initiate_pre_arb_reason
      dispute_invalid_reason
      dispute_amount {
        value
        currency
      }
      comp_evidence_ip_address_ind
      comp_evidence_email_address_ind
      comp_evidence_physical_address_ind
      comp_evidence_phone_number_ind
      comp_evidence_cust_acc_login_id_ind
      comp_evidence_device_id_fingerprinting_ind
      merchandise_or_services
      merchandise_or_services_desc
      shipping_delivery_status
      merchandise_or_services_provided_date
      disputed_transaction {
        device_id_details
        device_fingerprinting_details
        device_type_details
        ip_address_details
        customer_account_login_id_details
        delivery_address_details {
          address
          address2
          city
          state_region
          postal_code
          country
        }
      }
      undisputed_transactions {
        historical_tran_amount
        historical_tran_date
        historical_transaction_id
        historical_ARN
        rol_transaction_id
        merchandise_or_services_desc
        device_id_details
        device_fingerprinting_details
        device_type_details
        ip_address_details
        customer_account_login_id_details
        delivery_address_details {
          address
          address2
          city
          state_region
          postal_code
          country
        }
      }
      not_listed_dispute_invalid_reason
      requesting_member_bin
      requestor_name
      opposer_member_bin
      opposer_name
      comments
      appeal_ind
      filing_reason
      exception_cpd
      dispute_response
      dispute_response_reason
      pre_arb_response
      reason_code
      member_message_text
      status
      creation_date
      source_amount
      currency_conversion_assessment_cca_included
      currency_conversion_assessment_cca_amount
      document_indicator
      chargeback_reference_number
      reject_reason
      case_filing_id
      case_type
      case_status
      filling_ica
      filed_against_ica
      case_filing_status
      merchant_name
    }
  `,
  issuerAcquirerContactInfo: `
    fragment issuerAcquirerContactInfo on IssuerAcquirerContactInfo {
      contact_name
      contact_phone
      contact_other
      contact_email
    }
  `,
  amountObjectInfo: `
    fragment amountObjectInfo on AmountObject {
      value
      currency
    }
  `,
  serviceIntegrations: `
    fragment serviceIntegrations on ServiceIntegrations {
      VISA {
        dispute_reasons
        transaction_types
      }
      MASTERCARD {
        dispute_reasons
        transaction_types
      }
      PULSE {
        dispute_reasons
        transaction_types
      }
    }
  `
};
var Aa = Da;
const ka = {
  bulkUploadInfo: `
    fragment bulkUploadInfo on BulkUpload {
      created_time
      failure_reason
      file_name
      last_modified_time
      original_file_link
      reject_report_link
      status
      token
    }
  `
};
var ha = ka;
const Ea = fa, $a = Aa, Pa = ha, va = {
  ...Ea,
  ...$a,
  ...Pa,
  accountHolderGroupBaseInfo: `
    fragment accountHolderGroupBaseInfo on AccountHolderGroup {
      token
      name
      config {
        is_reloadable
        kyc_required
        real_time_fee_group_token
        pre_kyc_controls {
          balance_max
          cash_access_enabled
          enable_non_program_loads
          international_enabled
          is_reloadable_pre_kyc
        }
      }
    }
  `,
  cardholderBaseInfo: `
    fragment cardholderBaseInfo on Cardholder {
      active
      status
      token
      first_name
      middle_name
      last_name
      email
      phone
      address1
      address2
      city
      state
      postal_code
      country
      gender
      honorific
      title
      birth_date
      birth_place
      uses_parent_account
      parent_token
      corporate_card_holder
      company
      nationality
      ip_address
      notes_string
      business_token
      account_holder_group_token
      created_time
      last_modified_time
      ssn
      passport_number
      passport_expiration_date
      id_card_expiration_date
      id_card_number
      metadata      
      cards {
        data {
          card_product_token
        }
      }
    }
  `,
  cardBaseInfo: `
    fragment cardBaseInfo on Card {
      state
      fulfillment_status
      pin_is_set
      token
      last_four
      pan
      cvv_number
      chip_cvv_number
      expiration
      expiration_time
      instrument_type
      card_product_token
      bulk_issuance_token
      reissue_pan_from_card_token
      translate_pin_from_card_token
      state_reason
      barcode
      metadata
      created_time
      last_modified_time
      cardholder_token
      expedite
    }
  `,
  binBaseInfo: `
    fragment binBaseInfo on Bin {
      token
      bank {
        token
        active
        name
        created_time
        last_modified_time
      }
      bin
      active
      network
      type
      classification
      emv
      notes
      created_time
      last_modified_time
      unaffiliated_pin_debit_network
      active_at_network
      marqeta_role
    }
  `,
  binDataBaseInfo: `
    fragment binDataBaseInfo on Bin {
      active
      active_at_network
      bank {
        active
        created_time
        last_modified_time
        name
        token
      }
      bin
      classification
      created_time
      ica
      emv
      last_modified_time
      marqeta_role
      network
      notes
      token
      type
      unaffiliated_pin_debit_network
      region
    }
  `,
  binDataPrefixBaseInfo: `
    fragment binDataPrefixBaseInfo on BinPrefix {
      active
      active_at_network
      approval_number
      bin_prefix
      bin {
        active
        active_at_network
        bank {
          token
          active
          name
          created_time
          last_modified_time
        }
        bin
        classification
        created_time
        emv
        ica
        last_modified_time
        marqeta_role
        network
        region
        token
        type
      }
      card_category
      created_time
      currency
      emv
      issuing_country
      last_modified_time
      network_product {
        created_time
        is_premium
        last_modified_time
        network
        platform
        product_code
        product_name
        token
      }
      program {
        active
        created_time
        last_modified_time
        long_code
        name
        processor_only
        program_id
        short_code
        solution
        token
        uai_prefix
      }
      program_construct
      reloadable
      reporting_id
      routing_id
      token
      tokenization_bin_prefix
    }
  `,
  cardProductFulfillmentBaseInfo: `
    fragment cardProductFulfillmentBaseInfo on CardProductFulfillment {
      payment_instrument
      fulfillment_provider
      package_id
      bin_prefix
      bulk_ship
      shipping {
        method
        return_address {
          first_name
          middle_name
          last_name
          address1
          address2
          city
          state
          postal_code
          zip
          country
          phone
        }
        recipient_address {
          first_name
          middle_name
          last_name
          address1
          address2
          city
          state
          postal_code
          zip
          country
          phone
        }
        care_of_line
      }
    }
  `,
  cardProductJitFundingBaseInfo: `
    fragment cardProductJitFundingBaseInfo on CardProductConfigJitFunding {
      paymentcard_funding_source {
        enabled
        refunds_destination
      }
      programgateway_funding_source {
        enabled
        funding_source_token
        refunds_destination
      }
      program_funding_source {
        enabled
        funding_source_token
        refunds_destination
      }
    }
  `,
  cardProductCardLifeCycleBaseInfo: `
    fragment cardProductCardLifeCycleBaseInfo on CardLifeCycle {
      activate_upon_issue
      expiration_offset {
        unit
        value
        min_offset {
          unit
          value
        }
      }
      card_service_code
      update_expiration_upon_activation
    }
  `,
  cardProductBaseInfo: `
    fragment cardProductBaseInfo on CardProduct {
      token
      name
      active
      start_date
      end_date
      created_time
      last_modified_time
    }
  `,
  digitalWalletTokenBaseInfo: `
    fragment digitalWalletTokenBaseInfo on DigitalWalletToken {
      token
      created_time
      last_modified_time
      state
      state_reason
      fulfillment_status
      issuer_eligibility_decision
      token_service_provider{
        token_reference_id
        token_pan
        token_expiration
        pan_reference_id
        token_requestor_name
      }
      device{
        name
        type
        device_id
        phone_number
        language_code
        location
        ip_address
      }
      wallet_provider_profile{
        reason_code
        pan_source
        risk_assessment {
          score
        }
      }
    }
  `,
  digitalWalletTokenTransitionBaseInfo: `
    fragment digitalWalletTokenTransitionBaseInfo on DigitalWalletTokenTransition {
      token
      card_swap {
        previous_card_token
        new_card_token
      }
      type
      channel
      state
      fulfillment_status
      reason
      reason_code
      created_time
      last_modified_time
    }
  `,
  tokenizationDigitalWalletTokenBaseInfo: `
    fragment tokenizationDigitalWalletTokenBaseInfo on TokenizationDigitalWalletToken {
      token
      created_time
      last_modified_time
      state
      state_reason
      fulfillment_status
      issuer_eligibility_decision
      token_service_provider {
        token_reference_id
        token_pan
        token_expiration
        pan_reference_id
        token_requestor_name
      }
      device {
        name
        type
        device_id
        phone_number
        language_code
        location
        ip_address
      }
      wallet_provider_profile {
        reason_code
        pan_source
        risk_assessment {
          score
        }
      }
    }
  `,
  tokenizationDigitalWalletTransitionBaseInfo: `
    fragment TokenizationDigitalWalletTransitionBaseInfo on TokenizationDigitalWalletTransition {
      token
      digital_wallet_token {
        token
      }
      state
      reason
      reason_code
      fulfillment_status
      channel
      card_swap {
        previousCardToken
        newCardToken
      }
      created_time
    }
  `,
  transactionBaseInfo: `
    fragment transactionBaseInfo on Transaction {
      token
      type
      state
      acting_cardholder_token
      card_token
      cardholder_token
      business_token
      duration
      created_time
      card_acceptor {
        address
        street_address
        name
        city
        state
        postal_code
        zip
        country
        country_code
        poi {
          tid
          partial_approval_capable
          cardholder_presence
          card_presence
          channel
          processing_type
          pin_present
        }
        mid
        mcc
        network_mid
        mcc_name
      }
      card_security_code_verification
      cardholder_authentication_data {
        acquirer_exemption
        authentication_method
        authentication_status
        electronic_commerce_indicator
        three_ds_message_version
        verification_result
        verification_value_created_by
      }
      cardholder_transaction_time
      settlement_date
      request_amount
      amount
      issuer_interchange_amount
      currency_code
      approval_code
      preceding_related_transaction_token
      incremental_authorization_transaction_tokens
      program_transfer
      fee_transfer
      peer_transfer
      offer_orders
      rewards
      polarity
      response {
        code
        memo
        additional_information
      }
      gpa_order {
        memo
        token
        amount
        tags
      }
      gpa {
        available_balance
        cached_balance
        credit_balance
        currency_code
        impacted_amount
        ledger_balance
        pending_credits
      }
      real_time_fee_group
      chargeback {
        amount
        reason_description
        reason_code
        memo
        state
      }
      network
      subnetwork
      atm_subnetwork
      standin_approved_by
      acquirer {
        retrieval_reference_number
      }
      acquirer_fee_amount
      pos {
        pan_entry_mode
        pin_entry_mode
        pin_present
        terminal_id
        terminal_attendance
        terminal_location
        card_holder_presence
        cardholder_authentication_method
        card_presence
        terminal_type
        card_data_input_capability
        country_code
        zip
        partial_approval_capable
        purchase_amount_only
        is_recurring
        is_installment
      }
      avs
      transaction_metadata
      electronic_commerce_indicator
      verification_result
      verification_value_created_by
      digital_wallet_token {
        token
        token_service_provider {
          token_requestor_name
        }
      }
      acquirer_reference_data
      currencyConversionNetworkOriginalAmount
      currencyConversionNetworkOriginalCurrencyCode
    }
  `,
  exampleBaseInfo: `
    fragment exampleBaseInfo on ExampleResource {
      token
    }
  `,
  noteBaseInfo: `
    fragment noteBaseInfo on Note {
      token
      description
      created_by
      created_by_user_role
      private
      created_time
      last_modified_time
    }
  `,
  auditLogBaseInfo: `
    fragment auditLogBaseInfo on AuditLog {
      id
      app_name
      app_server_name
      record_type
      record_id
      record_operation
      remote_ip_address
      user_name
      event_type
      program
      http_path
      http_method
      http_params
      http_status_code
      user_role
      created_time
      last_modified_time
      old_value
      new_value
      notes
      extra_info
    }
  `,
  businessBaseInfo: `
    fragment businessBaseInfo on Business {
      active
      status
      token
      business_name_legal
      business_name_dba
      business_type
      ip_address
      password
      phone
      account_holder_group_token
      notes_string
      in_current_location_since
      website
      date_established
      general_business_description
      history
      international_office_locations
      duns_number
      taxpayer_id
      proprietor_is_beneficial_owner
      metadata
      created_time
      last_modified_time
    }
  `,
  directorBaseInfo: `
    fragment directorBaseInfo on Director {
      token
      active
      first_name
      middle_name
      last_name
      email
      phone
      birth_date
      title
      nationality
      place_of_birth
      created_time
      last_modified_time
    }
  `,
  businessTransitionInfo: `
    fragment businessTransitionInfo on BusinessTransition {
      token
      status
      reason_code
      reason
      channel
      business_token
      created_time
      last_modified_time
    }
  `,
  cardTransitionInfo: `
    fragment cardTransitionInfo on CardTransition {
      token
      card_token
      cardholder_token
      state
      reason
      reason_code
      channel
      fulfillment_status
      type
      created_time
      last_modified_time
      card_product_token
      last_four
      pan
      expiration
      expiration_time
      barcode
      pin_is_set
      bulk_issuance_token
      reissue_pan_from_card_token
      expedite
    }
  `,
  cardholderTransitionInfo: `
    fragment cardholderTransitionInfo on CardholderTransition {
      token
      status
      reason_code
      reason
      channel
      cardholder_token
      created_time
      last_modified_time
    }
  `,
  balanceBaseInfo: `
    fragment balanceBaseInfo on Balance {
      currency_code
      ledger_balance
      available_balance
      credit_balance
      pending_credits
    }
  `,
  fulfillmentProviderBaseInfo: `
    fragment fulfillmentProviderBaseInfo on FulfillmentProvider {
      token
      active
      name
      created_time
      last_modified_time
    }
  `,
  skuBaseInfo: `
    fragment skuBaseInfo on Sku {
      token
      active
      description
      image_url
      program
      provider {
        token
        active
        name
        created_time
        last_modified_time
      }
      name
      sku_id
      type
      created_time
      last_modified_time
    }
  `,
  cardPackageBaseInfo: `
    fragment cardPackageBaseInfo on CardPackage {
      token
      active
      package_id
      card_stock_sku {
        token
        active
        image_url
        description
        program
        provider {
          token
          active
          name
          created_time
          last_modified_time
        }
        name
        sku_id
        type
        created_time
        last_modified_time
      }
      carrier_sku {
        token
        active
        image_url
        description
        program
        provider {
          token
          active
          name
          created_time
          last_modified_time
        }
        name
        sku_id
        type
        created_time
        last_modified_time
      }
      label_sku {
        token
        active
        image_url
        description
        program
        provider {
          token
          active
          name
          created_time
          last_modified_time
        }
        name
        sku_id
        type
        created_time
        last_modified_time
      }
      envelope_sku {
        token
        active
        image_url
        description
        program
        provider {
          token
          active
          name
          created_time
          last_modified_time
        }
        name
        sku_id
        type
        created_time
        last_modified_time
      }
      created_time
      last_modified_time
    }
  `,
  inventoryAdjustmentBaseInfo: `
    fragment inventoryAdjustmentBaseInfo on InventoryAdjustment {
      token
      amount
      layer
      sku {
        token
        active
        description
        program
        provider {
          token
          active
          name
          created_time
          last_modified_time
        }
        name
        sku_id
        type
        created_time
        last_modified_time
      }
      reason
      created_time
      last_modified_time
    }
  `,
  inventoryLevelBaseInfo: `
    fragment inventoryLevelBaseInfo on InventoryLevel {
      token
      backordered_count
      ordered_count
      processed_count
      scrapped_count
      shipped_count
      stocked_count
      date
      created_time
      last_modified_time
    }
  `,
  inventoryOrderBaseInfo: `
    fragment inventoryOrderBaseInfo on InventoryOrder {
      token
      amount
      sku {
        token
        active
        description
        program
        provider {
          token
          active
          name
          created_time
          last_modified_time
        }
        name
        sku_id
        type
        created_time
        last_modified_time
      }
      reason
      created_time
      last_modified_time
    }
  `,
  fundingSourceBaseInfo: `
    fragment fundingSourceBaseInfo on FundingSource {
      account_number
      account_suffix
      account_type
      active
      bank_name
      created_time
      date_sent_for_verification
      date_verified
      is_default_account
      last_modified_time
      name_on_account
      routing_number
      token
      verification_notes
      verification_override
      verification_status
      verify_amount1
      verify_amount2
      exp_date
    }
  `,
  addressBaseInfo: `
    fragment addressBaseInfo on Address {
      first_name
      middle_name
      last_name
      address1
      address2
      city
      state
      postal_code
      zip
      country
      phone
    }
  `,
  incorporationBaseInfo: `
    fragment incorporationBaseInfo on Incorporation {
      is_public
      is_regulated_entity
      incorporation_type
      stock_symbol
      state_of_incorporation
      name_registered_under
    }
  `,
  primaryContactBaseInfo: `
    fragment primaryContactBaseInfo on PrimaryContact {
      full_name
      title
      department
      phone
      extension
      fax
      mobile
      email
    }
  `,
  identificationBaseInfo: `
    fragment identificationBaseInfo on Identification {
      type
      value
      expiration_date
    }
  `,
  fullIdentificationNumber: `
    fragment fullIdentificationNumberBaseInfo on FullIdentificationNumber {
      ssn
      tin
      nin
      sin
    }
  `,
  commandoModeBaseInfo: `
    fragment commandoModeBaseInfo on CommandoMode {
      token
      enabled
      enabled_reason
      enabled_channel
      enabled_username
      ignore_card_suspended_state
      real_time_standin_enabled
      real_time_standin_include_connection_errors
      real_time_standin_inclue_response_timeouts
      real_time_standin_include_application_errors
      created_time
      last_modified_time
    }
  `,
  commandoModeTransitionBaseInfo: `
    fragment commandoModeTransitionBaseInfo on CommandoModeTransition {
      token
      type
      commando_mode_token
      enabled
      enabled_reason
      enabled_channel
      enabled_username
      created_time
      name
    }
  `,
  programGatewayFundingSourceBaseInfo: `
    fragment programGatewayFundingSourceBaseInfo on ProgramGatewayFundingSource {
      name
      url
      version
      active
      token
      created_time
      last_modified_time
      account
      timeout_millis
    }
  `,
  programFundingSourceBaseInfo: `
    fragment programFundingSourceBaseInfo on ProgramFundingSource {
      name
      active
      token
      created_time
      last_modified_time
      account
    }
  `,
  velocityControlBaseInfo: `
    fragment velocityControlBaseInfo on VelocityControl {
      token
      name
      association {
        cardholder_token
        card_product_token
        business_token
      }
      merchant_scope {
        mid
        mcc_name
        mcc
        mcc_group
        mcc_group_data {
          token
          name
          mcc_names
          mccs
          active
          config {
            authorization_controls {
              hold_increase {
                type
                value
              }
            }
            hold_expiration_days
          }
        }
      }
      usage_limit
      approvals_only
      include_purchases
      include_withdrawals
      include_transfers
      include_cashback
      currency_code
      amount_limit
      velocity_window
      number_of_days
      active
    }
  `,
  authControlBaseInfo: `
    fragment authControlBaseInfo on AuthControl {
      token
      name
      active
      association {
        cardholder_token
        card_product_token
        business_token
      }
      merchant_scope {
        mid
        mcc_name
        mcc
        mcc_group
        mcc_group_data {
          token
          name
          mcc_names
          mccs
          active
          config {
            authorization_controls {
              hold_increase {
                type
                value
              }
            }
            hold_expiration_days
          }
        }
      }
      start_time
      end_time
    }
  `,
  associationBaseInfo: `
    fragment associationBaseInfo on Association {
      cardholder_token
      card_product_token
      business_token
    }
  `,
  merchantScopeBaseInfo: `
    fragment merchantScopeBaseInfo on MerchantScope {
      mid
      mcc
      mcc_group
    }
  `,
  caseBaseInfo: `
    fragment caseBaseInfo on Case {
      action
      assignee
      cardholder_token
      created_time
      folder_access_token
      folder_id
      folder_shared_link
      last_modified_time
      memo
      program_short_code
      state
      token
      type
    }
  `,
  disputeDetailsBaseInfo: `
    fragment disputeDetailsBaseInfo on Case {
      chargeback_token
      currency_code
      dispute_amount
      dispute_reason
      dispute_state
      gpaorder_token
      original_transaction_token
      account_status
    }
  `,
  reinstateDetailsBaseInfo: `
    fragment reinstateDetailsBaseInfo on Case {
      cardholder_token
      business_token
      status
      reason_code
      reason
    }
  `,
  kycDetailsBaseInfo: `
    fragment kycDetailsBaseInfo on Case {
      kyc_token
      kyc_failure_reason
    }
  `,
  userInfo: `
    fragment userInfo on User {
      token
      first_name
      last_name
      phone
      email
      customer_token
      ttl_in_seconds
      active
      password_updated_time
      failed_login_attempts
      last_failed_login_attempt_time
      last_signed_in_time
      last_signed_in_ip_address
      email_verified_time
      email_opt_in
      terms_of_service
      hub_spot_sync_id
      mfa_enabled
      mfa_totp_enabled
      mfa_totp_revealed
      mfa_last_challenge_time
      has_additional_auth_factor
      device_token
      scopes
      roles {
        domain_type
        domain_id
        role_token
        environment
      }
      created_time
      last_modified_time
    }
  `,
  proprietorOrOfficerBaseInfo: `
    fragment proprietorOrOfficerBaseInfo on ProprietorOrOfficer {
      first_name
      middle_name
      last_name
      alternative_names
      title
      dob
      birth_place
      nationality
      phone
      email
      ssn
    }
  `,
  beneficialOwnerBaseInfo: `
    fragment beneficialOwnerBaseInfo on BeneficialOwner {
      first_name
      middle_name
      last_name
      title
      getdob
      birth_place
      nationality
      ownership_percentage
      email
      phone
      ssn
    }
  `,
  serverInfoBaseInfo: `
    fragment serverInfoBaseInfo on ServerInfo {
      version
      commit_hash
      deploy_time
    }
  `,
  s3BatchObjectBaseInfo: `
    fragment s3BatchObjectBaseInfo on S3BatchObject {
      signedUrl
      Bucket
      Key
      LastModified
      ContentType
    }
  `,
  s3BatchMetadataBaseInfo: `
    fragment s3BatchMetadataBaseInfo on S3BatchMetadata {
      program
      uploadedBy
      description
    }
  `,
  kycReviewDetailsInfo: `
    fragment kycReviewDetailsInfo on KycReviewDetails {
      token
      status
      last_modified_time
      created_time
      alert {
        program_short_code
        decision
        user_token
        kyc_status
        kyc_identity {
          first_name {
            value
            status
          }
          middle_name {
            value
            status
          }
          last_name {
            value
            status
          }
          address1 {
            value
            status
          }
          address2 {
            value
            status
          }
          city {
            value
            status
          }
          state {
            value
            status
          }
          postal_code {
            value
            status
          }
          country {
            value
            status
          }
          ssn {
            value
            status
          }
          birth_date {
            value
            status
          }
          ofac {
            value
            status
          }
        }
      }
      assignment {
        team
        marqeta_agent {
          token
          email
          first_name
          last_name
        }
        customer_agent {
          token
          email
          first_name
          last_name
        }
      }
      available_values {
        transition_reason_codes
        disposition_reason_codes
        dispositions
        statuses
        teams
        transition_reason_codes
      }
      history {
        header
        body
        modify_time
        user_channel
        modify_user {
          token
          first_name
          last_name
          email_address
        }
      }
      notes {
        token
        text
      }
      programs {
        short_code
        name
      }
    }
  `,
  s3BatchMetadataResponseBaseInfo: `
    fragment s3BatchMetadataResponseBaseInfo on S3BatchMetadataResponse {
      code
      description
      total
      success
      failure
      users_processed
      cards_processed
      funds_processed
    }
  `,
  programConfigBaseInfo: `
    fragment programConfigBaseInfo on ProgramConfigs {
      USER_CARD_STATE_VERSION
      GL_ISSUERS_ACCT
      TZ
      PROGRAM_RESERVE_LOAD_RESTRICTION_ENABLED
      MC_SMS_FILE_ENABLED
      BALANCE_INQUIRY_TO_JIT_GATEWAY
      ENABLE_ITC_REWRITE
      TRANSACTION_MODEL_VERSION
      MAX_CARDS_ON_AUTO_RELOAD
      USE_LOCAL_TRANCACHE
      DB_CONNECTION_RELEASE_ENABLED
      ISSUER_COUNTRY
      TERMINATE_ACTIVE_CARDS_ON_NEW_CARD_ACTIVATION
      ARROWEYE_DATASET_ID
      AUTH_CONTROL_DEFAULT
      ACH_REJECT_PROCESSING_ENABLED
      PUSH_TO_CARD_BYPASS_VERIFICATION_FOR_MC
      REST_CHECK_METHOD
      KYC_BUSINESS_MERCHANT_ID
      EVENTS_USE_OLD_PAYLOAD
      TRANSITION_EXPIRED_CARDS_JOB_ENABLED
      CAN_MOVE_ACTIVE_CARDS
      ACH_TRACE_NUMBER
      VISA_SMS_FILE_ENABLED
      WEBHOOKS_SERVICE
      AUTHORIZATION_DIGEST_PERCENTAGE_SWITCH
      ENQUEUE_EVENTS
      CHARGEBACK_ALLOCATION_FLOW_ENABLED
      INTERNATIONAL_RESPONSE_FORMAT_VERSION
      DIRECT_DEPOSIT_REVIEW_REQUIRED
      PTC_SUPPORT_PENDING_TRANSACTION
      SHOW_ISSUER_FEE
      GL_JOURNAL
      ACH_LAST_FILE_SENT
      REAL_TIME_FEES_ENABLED
      PROGRAM_CURRENCIES
      PUSHTOCARD_TABAPAY_SUBCLIENT_ID
      GL_CHART
      SCHEMA_REVISION
      KYC_MERCHANT_ID
      ALLOW_ACCOUNT_FUNDING
      FUNDING_GATEWAY_MERCHANT_ID
      BULK_CARD_ORDER_BATCH_PROCESS_RETRY_ENABLED
      USE_TXN_MICRO_SERVICE
      MAX_ACTIVE_CARDS_PER_USER
      HSM_GATEWAY_ENABLED
      LOCAL_BALANCE_FEATURE_SWITCH
      MAX_CARD_ORDERS_PER_DAY
      REL_19_11_DWT_ENHANCED_FINDORIGINAL_FEATURE_FLAG
      DIRECT_DEPOSIT_BANK_PROVIDER
      PTC_MERCHANT_ID
      DEFAULT_CURRENCY
      defaultLayers
      LEGACY_CARDTRANSITION_EVENTS
      EXPIRED_CARD_TRANSITION_JOB_LIMIT
      STIP_DECLINE_WEBHOOKS_REASONCODE_LIST
      DIRECT_DEPOSIT_ACCOUNT_LOOKUP_LEGACY
      PTC_FETCH_PENDING_TRANSACTION_DURATION
      SLAVE_DB_ENABLED
      PUSHTOCARD_TABAPAY_SETTLEMENT_ACCOUNT
      ALLOW_NETWORK_LOAD
    }
  `
};
var Qn = va;
const _ = /* @__PURE__ */ B(da);
function Ra(t) {
  return t[Math.floor(Math.random() * t.length)];
}
var l = { randomFromArray: Ra };
const te = _, { randomFromArray: De } = l;
let W = {};
W.get = (t) => ({
  token: t,
  status: De(["UNVERIFIED", "LIMITED", "ACTIVE", "SUSPENDED", "CLOSED"]),
  reason: te.sentence,
  reason_code: De([
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21"
  ]),
  channel: De(["API", "IVR", "FRAUD", "ADMIN", "SYSTEM"]),
  business_token: te.uuid,
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  last_modified_time: (/* @__PURE__ */ new Date()).toISOString()
});
W.createTransition = (t) => ({
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  last_modified_time: (/* @__PURE__ */ new Date()).toISOString(),
  ...t,
  token: te.uuid
});
W.getList = (t = 100) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(W.get(te.uuid));
  return n;
};
var ba = W;
const C = _, { randomFromArray: L } = l;
let ne = {};
ne.get = (t) => ({
  token: t,
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  last_modified_time: (/* @__PURE__ */ new Date()).toISOString(),
  cardholder_token: C.uuid,
  card_product_token: C.uuid,
  last_four: C.integer(1e3, 9999),
  pan: `${C.integer(1e3, 9999)} ${C.integer(1e3, 9999)} ${C.integer(
    1e3,
    9999
  )} ${C.integer(1e3, 9999)}`,
  expiration: (/* @__PURE__ */ new Date()).toISOString(),
  expiration_time: (/* @__PURE__ */ new Date()).toISOString(),
  cvv_number: C.integer(100, 999),
  chip_cvv_number: C.integer(100, 999),
  pin_is_set: L([!0, !1]),
  state: L(["UNACTIVATED", "SUSPENDED", "TERMINATED", "ACTIVE", "ACTIVE"]),
  state_reason: L(["Fraud", "", "", ""]),
  fulfillment_status: L(["Fulfilled", "Unfilfilled"]),
  reissue_pan_from_card_token: C.coin_flip,
  bulk_issuance_token: C.uuid,
  translate_pin_from_card_token: C.coin_flip,
  instrument_type: L(["Guitar", "Piano", "Banjo"]),
  expedite: C.coin_flip,
  metadata: JSON.stringify({
    metadataOne: "Value One",
    metadataTwo: "Value Two"
  })
});
ne.getList = (t = 100) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(ne.get(C.uuid));
  return n;
};
var Jn = ne;
const Ve = _, { randomFromArray: Na } = l;
let ie = {};
ie.get = (t) => ({
  token: t,
  name: Ve.company_name,
  active: Ve.coin_flip,
  start_date: (/* @__PURE__ */ new Date()).toISOString(),
  end_date: (/* @__PURE__ */ new Date()).toISOString(),
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  modified_time: Na([(/* @__PURE__ */ new Date()).toISOString(), null])
});
ie.getList = (t) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(ie.get(Ve.uuid));
  return n;
};
var Ba = ie;
const f = _, { randomFromArray: w } = l;
let K = {};
K.get = (t) => ({
  token: t,
  card_token: f.uuid,
  cardholder_token: f.uuid,
  state: w(["ACTIVE", "SUSPENDED", "TERMINATED"]),
  reason: f.sentence,
  reason_code: w([
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21"
  ]),
  channel: w(["API", "IVR", "FRAUD", "ADMIN", "SYSTEM"]),
  fulfillment_status: w([
    "ISSUED",
    "ORDERED",
    "REJECTED",
    "SHIPPED",
    "DELIVERED",
    "DIGITALLY_PRESENTED"
  ]),
  type: w([
    "fulfillment.issued",
    "state.activated",
    "state.suspended",
    "state.reinstated",
    "state.terminated",
    "fulfillment.ordered",
    "fulfillment.rejected",
    "fulfillment.shipped",
    "fulfillment.delivered",
    "fulfillment.digitally_presented"
  ]),
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  card_product_token: f.uuid,
  pan: f.integer(1e5, 999999) + "______" + f.integer(1e3, 9999),
  last_four: f.integer(1e3, 9999),
  expiration: f.integer(1e3, 9999),
  expiration_time: (/* @__PURE__ */ new Date()).toISOString(),
  barcode: f.integer(1e19, 1e20),
  bulk_issuance_token: f.uuid,
  reissue_pan_from_card_token: f.uuid,
  last_modified_time: (/* @__PURE__ */ new Date()).toISOString(),
  pin_is_set: w([!0, !1]),
  expedite: w([!0, !1])
});
K.createTransition = (t) => ({
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  last_modified_time: (/* @__PURE__ */ new Date()).toISOString(),
  ...t,
  token: f.uuid
});
K.getList = (t = 100) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(K.get(f.uuid));
  return n;
};
var Oa = K;
const o = _, { randomFromArray: $ } = l, re = {}, Fa = [
  "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED",
  "CANCELLED_RECURRING_TRANSACTION",
  "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE",
  "FRAUD_MULTIPLE_TRANSACTIONS",
  "FRAUD_TRANSACTION",
  "NO_AUTHORIZATION",
  "LATE_PRESENTMENT",
  "TRANSACTION_NOT_RECOGNIZED +",
  "INCORRECT_CURRENCY_OR_TRANSACTION_CODE",
  "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER",
  "NOT_AUTHORIZED_CARD_PRESENT",
  "NOT_AUTHORIZED_CARD_ABSENT",
  "CREDIT_NOT_PROCESSED",
  "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM"
], wa = {
  MasterCard: [
    "4801",
    "4802",
    "4807",
    "4808",
    "4812",
    "4831",
    "4834",
    "4835",
    "4837",
    "4840",
    "4841",
    "4842",
    "4846",
    "4847",
    "4849",
    "4850",
    "4853",
    "4854",
    "4855",
    "4857",
    "4859",
    "4860",
    "4862",
    "4863"
  ],
  Visa: [
    "10.1",
    "10.2",
    "10.3",
    "10.4",
    "10.5",
    "11.1",
    "11.2",
    "11.3",
    "12.1",
    "12.2",
    "12.3",
    "12.4",
    "12.5",
    "12.6",
    "12.7",
    "13.1",
    "13.2",
    "13.3",
    "13.4",
    "13.5",
    "13.6",
    "13.7",
    "13.8",
    "13.9"
  ],
  Discover: [
    "AL",
    "AP",
    "AW",
    "CA",
    "CD",
    "CR",
    "DA",
    "DP",
    "DP1",
    "EX",
    "IC",
    "IN",
    "IS",
    "LP",
    "N",
    "NC",
    "P",
    "RG",
    "RM",
    "RN1",
    "RN2",
    "SV",
    "TF",
    "TNM",
    "UA01",
    "UA02",
    "UA32",
    "UA99",
    "UA03",
    "UA10",
    "UA11",
    "UA12",
    "UA18",
    "UA20",
    "UA21",
    "UA22",
    "UA23",
    "UA28",
    "UA30",
    "UA31",
    "UA38"
  ],
  Pulse: [
    "1000",
    "1001",
    "1002",
    "1004",
    "1005",
    "1006",
    "1010",
    "1011",
    "1020",
    "1021",
    "1079",
    "1080",
    "1089",
    "1090",
    "1091",
    "3000",
    "3001"
  ],
  Marqeta: ["123"]
}, ln = $(["Discover", "MasterCard", "Pulse", "Visa", "Marqeta"]);
re.get = (t) => ({
  token: t,
  type: $([
    "authorization",
    "billpayment",
    "directdeposit",
    "fee",
    "gpa",
    "msa",
    "pindebit"
  ]),
  state: $(["PENDING", "CLEARED", "COMPLETION", "DECLINED"]),
  acting_user_token: o.uuid,
  card_token: o.uuid,
  user_token: o.uuid,
  acting_cardholder_token: o.uuid,
  duration: o.integer(1, 500),
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  user_transaction_time: (/* @__PURE__ */ new Date()).toISOString(),
  settlement_date: (/* @__PURE__ */ new Date()).toISOString(),
  request_amount: `$${o.integer(1, 1e3)}.${o.integer(0, 99)}`,
  amount: `${o.integer(1, 1e3)}.${o.integer(0, 99)}`,
  issuer_interchange_amount: $(["$.05", "$.08", "", ""]),
  currency_code: o.currency_code,
  approval_code: o.uuid,
  preceding_related_transaction_token: o.uuid,
  incremental_authorization_transaction_tokens: o.uuid,
  program_transfer: o.word,
  fee_transfer: o.word,
  peer_transfer: o.word,
  offer_orders: [o.word, o.word],
  rewards: [o.word, o.word],
  polarity: $(["Credit", "Debit"]),
  real_time_fee_group: o.word,
  card_acceptor: {
    name: o.word
  },
  chargeback: {
    token: o.uuid,
    state: $([
      "INITIATED",
      "REPRESENTMENT",
      "PREARBITRATION",
      "ARBITRATION",
      "CASE_WON",
      "CASE_LOST",
      "NETWORK_REJECTED"
    ]),
    memo: o.sentence,
    reason_code: $(wa[ln]),
    reason_description: $(Fa),
    amount: `${o.integer(1, 1e3)}.${o.integer(0, 99)}`
  },
  response: {
    code: o.integer(0, 9999),
    memo: o.sentence
  },
  gpa_order: {
    token: o.uuid,
    memo: o.sentence
  },
  network: ln,
  subnetwork: $(["VisaNet", "VisaNetDebit", "Maestro", "Cirrus", "Managed_JIT"]),
  standin_approved_by: o.company_name,
  acquirer_fee_amount: o.double(0.01, 10).toFixed(2),
  card_security_code_verification: $(["CVV1", "CVV2", "ICVV", "DCVV"]),
  pos: {
    pan_entry_mode: o.word,
    pin_entry_mode: o.word,
    pin_present: o.word,
    terminal_id: o.word,
    terminal_attendance: o.word,
    terminal_location: o.word,
    card_holder_presence: o.boolean,
    cardholder_authentication_method: o.word,
    card_presence: o.boolean,
    terminal_type: o.word,
    card_data_input_capability: o.word,
    country_code: o.country_code,
    zip: o.zip,
    partial_approval_capable: o.boolean,
    purchase_amount_only: o.boolean,
    is_recurring: o.boolean,
    is_installment: o.boolean
  },
  avs: o.word,
  transaction_metadata: o.word,
  fraud: o.word,
  cardholder_authentication_data: o.word
});
re.getList = (t = 100) => {
  const n = [];
  for (let a = 0; a < t; a++)
    n.push(re.get(o.uuid));
  return n;
};
var qa = re;
const s = _, { randomFromArray: x } = l;
let ae = {};
ae.get = (t) => ({
  token: s.uuid,
  active: s.coin_flip,
  notes_string: x([s.sentence, "", ""]),
  ip_address: s.ip,
  password: s.password,
  phone: s.phone,
  account_holder_group_token: s.uuid,
  card_token: s.uuid,
  honorific: s.name_prefix,
  gender: x(["M", "F"]),
  first_name: s.first_name,
  middle_name: s.last_name,
  last_name: s.last_name,
  email: s.email,
  address1: s.address1,
  address2: x([null, null, null, s.address2]),
  city: s.city,
  state: s.state_abbr,
  country: s.country,
  birth_date: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
  corporate_card_holder: s.coin_flip,
  nationality: s.country,
  company: s.company_name,
  uses_parent_account: s.coin_flip,
  parent_token: s.uuid,
  business_token: s.uuid,
  postal_code: s.zip,
  zip: s.zip,
  ssn: s.numerify("###-##-####"),
  status: x(["ACTIVE", "ACTIVE", "UNVERIFIED", "LIMITED", "SUSPENDED", "CLOSED"]),
  passport_number: s.numerify("#########"),
  passport_expiration_date: (/* @__PURE__ */ new Date()).toISOString(),
  id_card_number: s.numerify("####-#####"),
  id_card_expiration_date: (/* @__PURE__ */ new Date()).toISOString(),
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  last_modified_time: x([(/* @__PURE__ */ new Date()).toISOString(), null]),
  metadata: JSON.stringify({
    metadataOne: "Value One",
    metadataTwo: "Value Two"
  })
});
ae.getList = (t = 50) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(ae.get(s.uuid));
  return n;
};
var Zn = ae;
const oe = _, { randomFromArray: Ae } = l;
let z = {};
z.get = (t) => ({
  token: t,
  status: Ae(["UNVERIFIED", "LIMITED", "ACTIVE", "SUSPENDED", "CLOSED"]),
  reason: oe.sentence,
  reason_code: Ae([
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21"
  ]),
  channel: Ae(["API", "IVR", "FRAUD", "ADMIN", "SYSTEM"]),
  cardholder_token: oe.uuid,
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  last_modified_time: (/* @__PURE__ */ new Date()).toISOString()
});
z.createTransition = (t) => ({
  created_time: (/* @__PURE__ */ new Date()).toISOString(),
  last_modified_time: (/* @__PURE__ */ new Date()).toISOString(),
  ...t,
  token: oe.uuid
});
z.getList = (t = 100) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(z.get(oe.uuid));
  return n;
};
var Ma = z;
const X = _;
let se = {};
se.get = (t) => ({
  token: t,
  description: X.sentence,
  created_by: X.word,
  created_by_user_role: "USER",
  private: X.coin_flip,
  created_time: `${(/* @__PURE__ */ new Date()).toLocaleDateString()}, 9:00 AM`,
  last_modified_time: `${(/* @__PURE__ */ new Date()).toLocaleDateString()}, 9:00 AM`
});
se.getList = (t = 10) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(se.get(X.uuid));
  return n;
};
var Ua = se;
const g = _, { randomFromArray: T } = l;
let ce = {};
ce.get = (t) => ({
  id: g.integer(0, 999999),
  app_name: T([
    "Unify",
    "Monterey",
    "Program Dashboard",
    "IVR",
    "PaymentsAPI",
    "CFP"
  ]),
  app_server_name: g.word,
  record_type: T(["Cardholder", "Business", "Card", "Transaction"]),
  record_id: g.uuid,
  record_operation: T(["UPDATE", "INSERT", "DELETE"]),
  remote_ip_address: g.ip,
  user_name: g.email,
  event_type: T(["user_event", "system_event"]),
  program: T(["ict", "sqr", "ddh", "abc", "der"]),
  http_path: g.url,
  http_method: T(["GET", "POST", "PUT", "DELETE"]),
  http_params: T([
    JSON.stringify({
      paramOne: g.word,
      paramTwo: g.word
    }),
    "",
    ""
  ]),
  http_status_code: T(["200", "300", "301", "400", "404", "500"]),
  user_role: T(["admin", "viewer", "support", "dev"]),
  created_time: `${g.date("YYYY-MM-DD")} ${g.time("HH:mm:ss")}`,
  last_modified_time: `${g.date("YYYY-MM-DD")} ${g.time("HH:mm:ss")}`,
  old_value: T([
    JSON.stringify({
      paramOne: g.word,
      paramTwo: g.word
    }),
    "",
    ""
  ]),
  new_value: T([
    JSON.stringify({
      paramOne: g.word,
      paramTwo: g.word
    }),
    "",
    ""
  ]),
  notes: T([g.sentence, "", ""]),
  extra_info: T([
    JSON.stringify({
      infoOne: g.word,
      infoTwo: g.word
    }),
    "",
    ""
  ])
});
ce.getList = (t = 100) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(ce.get(g.uuid));
  return n;
};
var La = ce;
const p = _, { randomFromArray: xa } = l;
let _e = {};
_e.get = (t) => ({
  active: p.coin_flip,
  token: p.uuid,
  status: xa(["ACTIVE", "SUSPENDED", "CLOSED", "LIMITED", "UNVERIFIED"]),
  business_name_legal: p.company_name,
  business_name_dba: p.company_name,
  business_type: p.word,
  notes_string: p.sentence,
  ip_address: p.ip,
  password: p.password,
  phone: p.phone,
  account_holder_group_token: p.uuid,
  in_current_location_since: p.date("YYYY-MM-DD"),
  website: p.url,
  created_time: p.date("YYYY-MM-DD"),
  last_modified_time: p.date("YYYY-MM-DD"),
  date_established: p.date("YYYY-MM-DD"),
  general_business_description: p.sentence,
  history: p.sentence,
  international_office_locations: p.month_number,
  duns_number: p.month_number,
  taxpayer_id: "123-12-1234",
  metadata: JSON.stringify({
    metadataOne: "Value One",
    metadataTwo: "Value Two"
  })
});
_e.getList = (t = 100) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(_e.get(p.uuid));
  return n;
};
var Xn = _e;
const Q = _, { randomFromArray: Ga } = l;
let de = {};
de.get = () => ({
  currency_code: Ga(["USD", "CAD"]),
  ledger_balance: Q.double(-1e3, 1e5),
  available_balance: Q.double(-1e3, 1e5),
  credit_balance: Q.double(-1e3, 1e5),
  pending_credits: Q.double(-1e3, 1e5)
});
de.getList = (t = 10) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(de.get());
  return n;
};
var Ha = de;
let le = {};
le.get = () => ({
  links: []
});
le.getList = (t = 10) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(le.get());
  return n;
};
var Va = le;
const P = _, { randomFromArray: ke } = l;
let ue = {};
ue.get = (t) => ({
  token: t,
  account_suffix: `${P.integer(1e3, 9999)}`,
  account_type: ke(["checking", "savings", "program", "ach"]),
  active: P.coin_flip,
  is_default_account: P.coin_flip,
  exp_date: P.date("YYYY-MM-DD"),
  verification_status: ke(["ACH_VERIFIED", "UNVERIFIED"]),
  date_verified: ke([P.date("YYYY-MM-DD"), null]),
  name_on_account: P.first_name,
  date_sent_for_verification: P.date("YYYY-MM-DD"),
  verification_override: P.coin_flip,
  verification_notes: P.sentence
});
ue.getList = (t = 10) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(ue.get(P.uuid));
  return n;
};
var Ya = ue;
const U = _, { randomFromArray: Wa } = l;
let ei = {};
ei.get = () => ({
  is_public: U.coin_flip,
  incorporation_type: Wa([
    "C Corporation",
    "Partnership",
    "Joint Venture",
    "LLC",
    "LLP",
    "S Corporation"
  ]),
  stock_symbol: `${U.letter}${U.letter}${U.letter}`.toUpperCase(),
  state_of_incorporation: U.state_abbr,
  name_registered_under: U.name
});
var Ka = ei;
const A = _, { randomFromArray: za } = l;
let ti = {};
ti.get = () => ({
  first_name: A.first_name,
  middle_name: A.name,
  last_name: A.last_name,
  address1: A.address1,
  address2: za([A.address2, "", ""]),
  city: A.city,
  state: A.state,
  postal_code: A.zip,
  zip: A.zip,
  country: A.country,
  phone: A.phone
});
var ja = ti;
const q = _, { randomFromArray: he } = l;
let ni = {};
ni.get = (t) => ({
  full_name: `${q.first_name} ${q.last_name}`,
  title: he(["Manager", "CEO", "VP", "SWE"]),
  department: he(["Tech", "Customer Success", "Analytics"]),
  phone: q.phone,
  extension: he([`${q.integer(100, 999)}`, "", ""]),
  fax: q.phone,
  mobile: q.phone,
  email: q.email
});
var Qa = ni;
const O = _;
let ii = {};
ii.get = (t) => ({
  first_name: O.first_name,
  middle_name: O.last_name,
  last_name: O.last_name,
  alternative_names: O.word,
  title: O.name_suffix,
  dob: O.date("YYYY-MM-DD"),
  phone: O.phone,
  email: O.email
});
var Ja = ii;
const un = _, { randomFromArray: Ee } = l;
let ge = {};
ge.get = (t = "business") => {
  let n;
  return t === "business" ? n = Ee(["BUSINESS_TAX_ID", "BUSINESS_NUMBER", "TAXPAYER_REFERENCE"]) : t === "cardholder" ? n = Ee(["SSN", "TIN", "SIN", "NIN", "PASSPORT_NUMBER", "DRIVERS_LICENSE"]) : t === "proprietorOrOfficer" && (n = Ee(["SSN", "SIN", "TIN", "NIN"])), {
    type: n,
    value: un.zip,
    expiration_date: un.date("YYYY-MM-DD")
  };
};
ge.getList = (t = 10, n) => {
  let a = [];
  for (let u = 0; u < t; u++)
    a.push(ge.get(n));
  return a;
};
var Za = ge;
const y = _, { randomFromArray: Xa } = l;
let pe = {};
pe.get = () => ({
  token: `Commando Mode Token ${y.integer(1, 100)}`,
  program_gateway_funding_source_token: y.uuid,
  enabled: y.coin_flip,
  enabled_reason: y.word,
  enabled_channel: Xa(["API", "SYSTEM"]),
  enabled_username: y.username,
  program_funding_source: y.uuid,
  ignore_card_suspended_state: y.coin_flip,
  real_time_standin_enabled: y.coin_flip,
  real_time_standin_include_connection_errors: y.coin_flip,
  real_time_standin_inclue_response_timeouts: y.coin_flip,
  real_time_standin_include_application_errors: y.coin_flip,
  created_time: `${y.date("YYYY-MM-DD")} ${y.time("HH:mm:ss")}`,
  last_modified_time: `${y.date("YYYY-MM-DD")} ${y.time("HH:mm:ss")}`
});
pe.getList = (t = 10) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(pe.get());
  return n;
};
var eo = pe;
const v = _, { randomFromArray: to } = l;
let me = {};
me.get = () => ({
  token: v.uuid,
  type: v.word,
  commando_mode_token: v.uuid,
  enabled: v.coin_flip,
  enabled_reason: v.word,
  enabled_channel: to(["API", "SYSTEM"]),
  enabled_username: v.username,
  created_time: `${v.date("YYYY-MM-DD")} ${v.time("HH:mm:ss")}`,
  name: v.word
});
me.getList = (t = 20) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(me.get(v.uuid));
  return n;
};
var no = me;
const M = _;
let Se = {};
Se.get = () => ({
  token: M.uuid,
  name: M.word,
  start_time: `${M.date("YYYY-MM-DD")} ${M.time("HH:mm:ss")}`,
  end_time: `${M.date("YYYY-MM-DD")} ${M.time("HH:mm:ss")}`,
  active: M.coin_flip
});
Se.getList = (t = 10) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(Se.get());
  return n;
};
var io = Se;
const k = _, { randomFromArray: ro } = l;
let ye = {};
ye.get = () => ({
  token: k.uuid,
  name: k.word,
  usage_limit: k.integer(1, 1e4),
  approvals_only: k.coin_flip,
  include_purchases: k.coin_flip,
  include_withdrawals: k.coin_flip,
  include_transfers: k.coin_flip,
  include_cashback: k.coin_flip,
  currency_code: k.currency_code,
  amount_limit: k.integer(10, 100),
  velocity_window: ro(["DAY", "WEEK", "MONTH", "LIFETIME", "TRANSACTION"]),
  active: k.coin_flip
});
ye.getList = (t = 10) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(ye.get());
  return n;
};
var ao = ye;
const F = _;
let ri = {};
ri.get = (t) => ({
  name: F.word,
  active: F.coin_flip,
  token: F.uuid,
  created_time: `${F.date("YYYY-MM-DD")} ${F.time("HH:mm:ss")}`,
  last_modified_time: `${F.date("YYYY-MM-DD")} ${F.time("HH:mm:ss")}`,
  account: F.ip
});
var oo = ri;
const h = _, { randomFromArray: so } = l;
let ai = {};
ai.get = (t) => ({
  name: so(["Main API", "Microservice 1432", "XYZ Service"]),
  url: h.url,
  version: h.month_number,
  active: h.coin_flip,
  token: h.uuid,
  created_time: `${h.date("YYYY-MM-DD")} ${h.time("HH:mm:ss")}`,
  last_modified_time: `${h.date("YYYY-MM-DD")} ${h.time("HH:mm:ss")}`,
  account: h.ip,
  timeout_millis: h.integer(1e3, 1e4)
});
var co = ai;
const $e = _;
let oi = {};
oi.get = () => ({
  cardholder_token: $e.uuid,
  card_product_token: $e.uuid,
  business_token: $e.uuid
});
var _o = oi;
const Pe = _;
let si = {};
si.get = () => ({
  mid: Pe.file_extension,
  mcc: Pe.integer(1e3, 9999),
  mcc_group: Pe.catch_phrase
});
var lo = si;
const I = _, { randomFromArray: uo } = l;
let ci = {};
ci.get = () => ({
  text: {
    name_line_1: { value: I.first_name },
    name_line_2: { value: I.last_name }
  },
  images: {
    card: {
      name: I.first_name,
      thermal_color: I.color_name
    },
    carrier: {
      name: I.first_name,
      message_1: I.word
    },
    signature: {
      name: I.first_name
    },
    carrier_return_window: {
      name: I.first_name
    }
  },
  carrier: {
    template_id: I.uuid,
    logo_file: I.url,
    logo_thumbnail_file: I.url,
    message_file: I.url,
    message_line: I.word
  },
  perso_type: uo(["EMBOSS", "LASER", "FLAT"])
});
var go = ci;
const gn = Xn, pn = Zn, mn = Jn, { randomFromArray: po } = l;
let _i = {};
_i.globalTokenAndAccountSearch = ({ token: t, resourceType: n }) => {
  switch (n) {
    case "business":
      return { business: gn.get(t) };
    case "cardholder":
      return { cardholder: pn.get(t) };
    case "card":
      return { card: mn.get(t) };
    case "all":
      return po([
        { business: gn.get(t) },
        { cardholder: pn.get(t) },
        { card: mn.get(t) }
      ]);
    default:
      return {};
  }
};
var mo = _i;
const So = _, { randomFromArray: yo } = l;
let Ce = {};
Ce.get = (t) => ({
  token: t,
  name: "Credit product name",
  description: "Credit product description",
  status: yo(["DRAFT", "ACTIVE", "ARCHIVED"]),
  createdTime: (/* @__PURE__ */ new Date()).toISOString(),
  updatedTime: (/* @__PURE__ */ new Date()).toISOString()
});
Ce.getList = (t = 100) => {
  let n = [];
  for (let a = 0; a < t; a++)
    n.push(Ce.get(So.uuid));
  return n;
};
var Co = Ce;
const To = ba, Io = Jn, fo = Ba, Do = Oa, Ao = qa, ko = Zn, ho = Ma, Eo = Ua, $o = La, Po = Xn, vo = Ha, Ro = Va, bo = Ya, No = Ka, Bo = ja, Oo = Qa, Fo = Ja, wo = Za, qo = eo, Mo = no, Uo = io, Lo = ao, xo = oo, Go = co, Ho = _o, Vo = lo, Yo = go, Wo = mo, Ko = Co;
var zo = {
  BusinessTransitionsMock: To,
  CardMock: Io,
  CardProductMock: fo,
  CardTransitionsMock: Do,
  TransactionMock: Ao,
  CardholderMock: ko,
  CardholderTransitionsMock: ho,
  NoteMock: Eo,
  AuditLogMock: $o,
  BusinessMock: Po,
  BalanceMock: vo,
  GpaBalanceMock: Ro,
  FundingSourceMock: bo,
  IncorporationMock: No,
  AddressMock: Bo,
  PrimaryContactMock: Oo,
  ProprietorOrOfficerMock: Fo,
  IdentificationMock: wo,
  CommandoModeMock: qo,
  CommandoModeTransitionMock: Mo,
  AuthControlMock: Uo,
  VelocityControlMock: Lo,
  ProgramFundingSourceMock: xo,
  ProgramGatewayFundingSourceMock: Go,
  AssociationMock: Ho,
  MerchantScopeMock: Vo,
  CardPersonalizationMock: Yo,
  SearchMock: Wo,
  CreditProductMock: Ko
};
const {
  BusinessTransitionsMock: Sn,
  CardholderMock: ve,
  CardholderTransitionsMock: yn,
  CardMock: Re,
  CardProductMock: jo,
  TransactionMock: J,
  NoteMock: be,
  AuditLogMock: Ne,
  BusinessMock: Cn,
  GpaBalanceMock: Qo,
  BalanceMock: Jo,
  FundingSourceMock: Be,
  IncorporationMock: Zo,
  AddressMock: G,
  PrimaryContactMock: Xo,
  ProprietorOrOfficerMock: es,
  IdentificationMock: Oe,
  CardTransitionsMock: Tn,
  CommandoModeMock: In,
  CommandoModeTransitionMock: fn,
  AuthControlMock: Dn,
  VelocityControlMock: An,
  ProgramFundingSourceMock: ts,
  ProgramGatewayFundingSourceMock: ns,
  AssociationMock: kn,
  MerchantScopeMock: hn,
  CardPersonalizationMock: is,
  SearchMock: rs,
  CreditProductMock: as
} = zo, { randomFromArray: En } = l, d = (t, n) => {
  let { count: a = 0, start_index: u = 0, end_index: S = 0 } = n;
  const R = u === 0 ? !0 : Math.random() >= 0.5;
  return S = u + a, R || (S -= Math.round(Math.random() * a)), {
    data: t,
    count: a,
    start_index: u,
    end_index: S,
    is_more: R
  };
}, os = {
  Query: {
    cardholder: (t, { token: n }) => ve.get(n),
    cardholders: (t, n) => d(ve.getList(n.count), n),
    card: (t, { token: n }) => Re.get(n),
    cards: (t, n) => d(Re.getList(n.count), n),
    cardProduct: (t, { token: n }) => jo.get(n),
    case: (t, { token: n }) => CaseMock.get(n),
    transaction: (t, { token: n }) => J.get(n),
    transactions: (t, n) => d(J.getList(n.count), n),
    notes: (t, n) => d(be.getList(n.count), n),
    auditLogs: (t, n) => d(Ne.getList(n.count), n),
    business: (t, { token: n }) => Cn.get(n),
    businesses: (t, n) => d(Cn.getList(n.count), n),
    fundingSources: (t, n) => d(Be.getList(n.count), n),
    commandoMode: (t, n) => In.get(),
    commandoModes: (t, n) => d(In.getList(3), n),
    commandoModeTransitions: (t, n) => d(fn.getList(n.count), n),
    globalTokenAndAccountSearch: (t, n) => rs.globalTokenAndAccountSearch(n),
    creditProduct: (t, { token: n }) => as.get(n)
  },
  Mutation: {
    createBusinessTransition: (t, n) => Sn.createTransition(n),
    createCardholderTransition: (t, n) => yn.createTransition(n),
    createCardTransition: (t, n) => Tn.createTransition(n)
  },
  Cardholder: {
    cards: (t, n) => d(Re.getList(n.count), n),
    notes: (t, n) => d(be.getList(n.count), n),
    audit_logs: () => d(Ne.getList()),
    identifications: () => Oe.getList(5, "cardholder"),
    transactions: () => d(J.getList(25)),
    funding_sources: () => d(Be.getList()),
    transitions: (t, n) => d(yn.getList(n.count), n),
    velocity_controls: (t, n) => d(An.getList(2), n),
    auth_controls: (t, n) => d(Dn.getList(2), n)
  },
  Business: {
    gpa_balance: () => Qo.get(),
    funding_sources: () => d(Be.getList()),
    notes: (t, n) => d(be.getList(n.count), n),
    audit_logs: () => d(Ne.getList()),
    transactions: () => d(J.getList(25)),
    transitions: (t, n) => d(Sn.getList(n.count), n),
    identifications: () => Oe.getList(1, "business"),
    incorporation: () => Zo.get(),
    primary_contact: () => Xo.get(),
    office_location: () => G.get(),
    children: () => d(ve.getList(10)),
    proprietor_or_officer: () => es.get()
  },
  GpaBalance: {
    gpa: (t) => Jo.get()
  },
  Incorporation: {
    address_registered_under: () => G.get()
  },
  CommandoMode: {
    transitions: () => d(fn.getList()),
    velocity_controls: () => An.getList(3),
    auth_controls: () => Dn.getList(2),
    program_gateway_funding_source: () => ns.get(),
    program_funding_source: () => ts.get()
  },
  Card: {
    transitions: (t, n) => d(Tn.getList(n.count), n),
    fulfillment: () => ({})
  },
  CardFulfillment: {
    shipping: () => ({}),
    card_fulfillment_reason: () => En(["NEW", "REORDER", "LOST"]),
    card_personalization: () => is.get()
  },
  CardFulfillmentShipping: {
    method: () => En([
      "USPS_REGULAR",
      "USPS_EXPEDITED",
      "UPS_REGULAR",
      "UPS_EXPEDITED",
      "FEDEX_EXPEDITED"
    ]),
    return_address: () => G.get(),
    recipient_address: () => G.get(),
    care_of_line: () => "Carey From Corporate"
  },
  VelocityControl: {
    association: () => kn.get(),
    merchant_scope: () => hn.get()
  },
  AuthControl: {
    association: () => kn.get(),
    merchant_scope: () => hn.get()
  },
  ProprietorOrOfficer: {
    home: () => G.get(),
    identifications: () => Oe.getList(1, "proprietorOrOfficer")
  }
};
var di = os;
const ss = /* @__PURE__ */ B(la), cs = /* @__PURE__ */ B(ua), { Kind: _s, GraphQLScalarType: ds, GraphQLError: li } = cs;
function Fe(t) {
  if (typeof t != "number")
    throw new TypeError(`Value is not a number: ${t}`);
  if (!Number.isInteger(t))
    throw new TypeError(`Value is not an integer: ${t}`);
  if (!(t >= 1 && t <= 31))
    throw new li(`Value is not in required range: ${t}`);
  return t;
}
const ls = new ds({
  name: "Day",
  description: "Day number in month",
  parseValue(t) {
    return Fe(t);
  },
  serialize(t) {
    return Fe(t);
  },
  parseLiteral(t) {
    if (t.kind !== _s.INT)
      throw new li(`Can only validate numbers but got a: ${t.kind}`);
    return Fe(t.value);
  }
});
var us = ls;
const gs = us;
var ps = {
  Day: gs
};
function ms() {
  var t = arguments[0], n = Array.prototype.slice.call(arguments, 1);
  return t.reduce(function(a, u, S) {
    return a + u + (n[S] ? n[S] : "");
  }, "");
}
var e = { gql: ms };
const { gql: Ss } = e, ys = Ss`
  interface AbstractAddress {
    first_name: String
    last_name: String
    address1: String
    address2: String
    city: String
    state: String
    phone: String
  }
`;
var Cs = { types: ys };
const { gql: Ts } = e, Is = Ts`
  interface AbstractBalance {
    currency_code: String
    ledger_balance: Float
    available_balance: Float
    credit_balance: Float
    pending_credits: Float
  }
`;
var fs = { types: Is };
const { gql: Ds } = e, As = Ds`
  interface AbstractCollection {
    count: Int
    start_index: Int
    end_index: Int
    is_more: Boolean
  }
`;
var ks = { types: As };
const { gql: hs } = e, Es = hs`
  interface AbstractFundingSource {
    token: ID!
    active: Boolean
  }
`;
var $s = { types: Es };
const { gql: Ps } = e, vs = Ps`
  interface AbstractTransition {
    token: ID!
    channel: String
    reason_code: String
    reason: String
    created_time: String
  }
`;
var Rs = { types: vs };
const bs = "sort_by: String, count: Int, start_index: Int", Ns = (t, n = "data", a = "") => `
    type ${t}Collection implements AbstractCollection {
      ${n}: [${t}]
      count: Int
      total: Int
      start_index: Int
      end_index: Int
      is_more: Boolean
      ${a}
    }
  `;
var r = { paginationParams: bs, generateCollectionType: Ns };
const { gql: Ye } = e, { generateCollectionType: Bs, paginationParams: Os } = r, Fs = Ye`
  type AcceptedCountries {
    token: ID!
    name: String
    is_whitelist: Boolean
    country_codes: [String]
    created_time: String
    last_modified_time: String
  }
  ${Bs("AcceptedCountries")}
`, ws = Ye`
  acceptedCountry(token: ID!): AcceptedCountries
  acceptedCountries(
    ${Os},
  ): AcceptedCountriesCollection 
`, qs = Ye`
  createAcceptedCountry(
    token: String
    name: String
    is_whitelist: Boolean
    country_codes: [String]
  ): AcceptedCountries
  updateAcceptedCountry(
    token: ID!
    name: String
    is_whitelist: Boolean
    country_codes: [String]
  ): AcceptedCountries
`;
var Ms = { types: Fs, queries: ws, mutations: qs };
const { gql: ui } = e, { paginationParams: Us, generateCollectionType: Ls } = r, xs = ui`
  type PreKycControls {
    cash_access_enabled: Boolean
    international_enabled: Boolean
    balance_max: String
    enable_non_program_loads: Boolean
    is_reloadable_pre_kyc: Boolean
  }

  type AccountHolderGroupConfig {
    kyc_required: String
    is_reloadable: Boolean
    real_time_fee_group_token: String
    pre_kyc_controls: PreKycControls
  }

  type AccountHolderGroup {
    token: String!
    name: String
    config: AccountHolderGroupConfig
  }

  ${Ls("AccountHolderGroup")}
`, Gs = ui`
  accountHolderGroup(token: String!): AccountHolderGroup
  accountHolderGroups(${Us}): AccountHolderGroupCollection
`;
var Hs = { types: xs, queries: Gs };
const { gql: We } = e, { paginationParams: E, generateCollectionType: we } = r, Vs = We`
  type MonitoringAlertAggregation {
    account_name: String
    account_token: ID!
    alerted_rules: String
    acting_user_name: String
    acting_user_token: String
    card_product_tokens: String
    card_tokens: String
    currency_code: String
    earliest_created_time: String
    earliest_unreviewed_time: String
    entities_alerted: String
    existing_review: Boolean
    highest_network_risk_score: Float
    highest_transaction_amount: Float
    is_business: Boolean
    mccs: String
    merchant_names: String
    number_of_open_alerts: Int
    number_of_pending_alerts: Int
    program_short_code: String
    program: ProgramDetails
    review_token: ID
    transaction_times: String
    transaction_types: String
    triggered_rules: String
  }

  type MonitoringAlert {
    accountholder_token: ID
    alerted_rules: String
    alert_status: String
    alert_type: String
    business_token: String
    card_product_token: ID
    card_token: ID
    cardholder_token: ID
    created_by: String
    currency_code: String
    date_created: String
    date_deleted: String
    date_of_transaction: String
    decision: String
    disposition: Disposition
    entities_alerted: String
    last_updated: String
    mcc: String
    merchant_name: String
    network_risk_score: Int
    network: String
    program_short_code: String
    program: ProgramDetails
    review_token: ID
    rules_triggered: String
    rule_tags: String
    token: ID
    transaction_amount: Float
    transaction_type: String
    unit_token: String
    user_channel: String
    user_token: ID
  }

  type ProgramDetails {
    name: String
    short_code: String
  }

  type TransactionAndAlerts {
    transaction: Transaction
    alert: MonitoringAlert
  }

  type MonitoringTransactionsAndAlerts {
    number_of_open_alerts: Int
    txns_and_alerts: [TransactionAndAlerts]
  }

  type Instrument {
    type: String
    category: String
  }

  type AssociatedCard {
    token: ID
    card_product_token: ID
    instrument: Instrument
    status: String
    fulfillment_status: String
    expiration_time: String
    last_four_of_pan: String
    last_modified_time: String
    created_time: String
  }

  type AssociatedCards {
    token: ID
    cards: [AssociatedCard]
  }

  type MonitoringAssociatedCards {
    parent: AssociatedCards
    children: [AssociatedCards]
  }

  type AssociatedAccount {
    token: ID
    type: String
    status: String
    account_number: String
    routing_number: String
    last_modified_time: String
    created_time: String
  }

  type AssociatedAccounts {
    token: ID
    status: String
    created_time: String
    last_modified_time: String
    uses_parent_account: Boolean
    deposit_accounts: [AssociatedAccount]
  }

  type MonitoringAssociatedAccounts {
    parent: AssociatedAccounts
    children: [AssociatedAccounts]
  }

  scalar Disposition
  {
    disposition_value: String
    disposition_note: String
  }

  type DispositionResult {
    disposition_note: String
    disposition_value: String
    has_transition_errors: Boolean
    has_transition_warnings: Boolean
    alerts: [DispositionedAlert]
  }

  type DispositionedAlert {
    token: String
    disposition_success: Boolean
    transition_errors: [DispositionErrors]
    transition_warnings: [DispositionErrors]
  }

  type DispositionErrors {
    error_code: String
    error_message: String
    token: String
  }

  type TransitionedAlerts {
    alerts: [MonitoringAlert]
  }

  ${we("MonitoringAlertAggregation", "accounts")}
  ${we("MonitoringAlert", "alerts")}
  ${we("TransactionAndAlerts", "transactions", "number_of_open_alerts: Int")}
`, Ys = We`
  monitoringAlertAgreggationsByAccountholder(
    ${E},
    account_name: String,
    account_token: String,
    acting_user_name: String
    acting_user_token: String
    card_product_token: String,
    card_product_tokens: String
    card_token: String,
    card_tokens: String
    created_time: String,
    entities_alerted: String,
    last_modified_time: String
    mcc: String,
    mccs: String
    merchant_name: String,
    merchant_names: String
    network_risk_score: String,
    program_short_code: String,
    program: ProgramInput,
    review_token: String,
    transaction_amount: String,
    transaction_times: String
    transaction_type: String,
    transaction_types: String
    triggered_rules: String,
    alerted_rules: String,
  ): MonitoringAlertAggregationCollection
  
  monitoringAlertAgreggationsByCardholder(
    ${E},
    account_name: String,
    account_token: String,
    acting_user_name: String
    acting_user_token: String
    card_product_token: String,
    card_product_tokens: String
    card_token: String,
    card_tokens: String
    created_time: String,
    entities_alerted: String,
    last_modified_time: String
    mcc: String,
    mccs: String
    merchant_name: String,
    merchant_names: String
    network_risk_score: String,
    program_short_code: String,
    program: ProgramInput,
    review_token: String,
    transaction_amount: String,
    transaction_times: String
    transaction_type: String,
    transaction_types: String
    triggered_rules: String,
    alerted_rules: String,
  ): MonitoringAlertAggregationCollection
  
  monitoringAlertsByAccountholder(
    ${E},
    account_token: ID!,
    program_short_code: String,
  ): MonitoringAlertCollection
  
  monitoringAlertsByCardholder(
    ${E},
    account_token: ID!,
    program_short_code: String,
    status: String,    
  ): MonitoringAlertCollection

  monitoringAssociatedCardsByBusiness(
    ${E},
    account_token: ID!,
    program_short_code: String,
  ): MonitoringAssociatedCards
  
  monitoringAssociatedCardsByUser(
    ${E},
    account_token: ID!,
    program_short_code: String,
  ): MonitoringAssociatedCards
  
  monitoringAssociatedAccountsByBusiness(
    ${E},
    account_token: ID!,
    program_short_code: String,
  ): MonitoringAssociatedAccounts

  monitoringAssociatedAccountsByUser(
    ${E},
    account_token: ID!,
    program_short_code: String,
  ): MonitoringAssociatedAccounts

  monitoringTransactionsByAccountholder(
    ${E},
    account_token: String,
    acting_user_token: String,
    has_alert: String, # alert_status
    alert_time: String, # date_created
    account_monitoring_alert_disposition: String, # disposition
    card_product_token: String,
    card_token: String,
    entities_alerted: String,
    network_risk_score: String,
    mcc: String,
    merchant_name: String,
    merchant_id: String,
    merchant_city: String,
    merchant_state: String,
    merchant_country_code: String,
    pan_entry_mode: String,
    terminal_id: String,
    transaction_amount: String,
    transaction_token: String, #token
    transaction_timestamp: String, #date_of_transaction
    transaction_type: String,
    triggered_rules: String,
    alerted_rules: String,
    program_short_code: String,
    transaction_states: String,
    rule_tags: String
  ): TransactionAndAlertsCollection
  
  monitoringTransactionsByCardholder(
    ${E},
    account_token: String,
    acting_user_token: String,
    has_alert: String, # alert_status
    alert_time: String, # date_created
    account_monitoring_alert_disposition: String, # disposition
    card_product_token: String,
    card_token: String,
    entities_alerted: String,
    network_risk_score: String,
    mcc: String,
    merchant_name: String,
    merchant_id: String,
    merchant_city: String,
    merchant_state: String,
    merchant_country_code: String,
    pan_entry_mode: String,
    status: String,
    terminal_id: String,
    transaction_amount: String,
    transaction_token: String, #token
    transaction_timestamp: String, #date_of_transaction
    transaction_type: String,
    triggered_rules: String,
    alerted_rules: String,
    program_short_code: String,
    transaction_states: String,
    rule_tags: String
  ): TransactionAndAlertsCollection
`, Ws = We`
  alertTransactions(
    program_short_code: String
    transaction_tokens: [String]
  ): TransitionedAlerts

  bulkDispositionAlerts(
    alert_tokens: [String]
    disposition_note: String
    disposition_value: String
    transition: String
  ): DispositionResult
`;
var Ks = { types: Vs, queries: Ys, mutations: Ws };
const { gql: gi } = e, zs = gi`
  type InterestRate {
    type: String
    rate: Int
    effective_date: String
    created_time: String
    updated_time: String
  }
`, js = gi`
  getInterestRate(
    type: String
  ): InterestRate
`;
var Qs = { types: zs, queries: js }, pi = {};
const { gql: Js } = e;
pi.achBankTransferBaseInfo = Js`
  token: ID
  amount: Float
  batch_number: String
  created_time: String
  last_modified_time: String
  currency_code: String
  memo: String
  return_code: String
  return_reason: String
  funding_source_token: String
  statement_descriptor: String
  transfer_speed: TransferSpeed
  standard_entry_class_code: EntryClassCode
  status: String
  type: AchBankTransferType
  transitions: [AchBankTransferTransition]
  channel: AchBankTransferChannel
  created_by: String
`;
const { gql: Ke } = e, Zs = ({
  account_number: t,
  account_type: n,
  name_on_account: a,
  routing_number: u,
  amount: S,
  currency_code: R
}) => Ke`
    mutation createCardResources(
      $first_name: String
      $last_name: String
      $existing_cardholder_token: ID
      $token: ID
      $fundingSources: [FundingSourceInput!]
      $authControls: [AuthControlInput!]
      $velocityControls: [VelocityControlInput!]
      $parent_token: ID
      ${Xs({
  account_number: t,
  account_type: n,
  name_on_account: a,
  routing_number: u,
  amount: S,
  currency_code: R
})}
    ) {
      createCardResources {
        cardholder(
          first_name: $first_name
          last_name: $last_name
          existing_cardholder_token: $existing_cardholder_token
          parent_token: $parent_token
          token: $token
        ) {
          token
          first_name
          last_name
          ${ec({
  account_number: t,
  account_type: n,
  name_on_account: a,
  routing_number: u,
  amount: S,
  currency_code: R
})}
          funding_sources(
            fundingSources: $fundingSources
          ) {
            account_number
            account_type
            name_on_account
            token
          }
          velocity_controls(
            velocityControls: $velocityControls
          ){
            amount_limit
            usage_limit
            velocity_window
            number_of_days
            token
          }
          auth_controls(
            authControls: $authControls
          ){
            token
            merchant_scope {
              mcc
              mcc_group
              mcc_group_data {
                mcc_names
                mccs
              }
              mcc_name
            }
            name
          }
        }
      }
    }
  `, Xs = ({
  account_number: t,
  account_type: n,
  name_on_account: a,
  routing_number: u,
  amount: S,
  currency_code: R
}) => t && n && a && u ? `
      $account_number: String
      $account_type: String
      $name_on_account: String
      $routing_number: String
      $verification_override: Boolean
      ${S ? "$amount: Float" : ""}
      ${R ? "$currency_code: String" : ""}
    ` : "", ec = ({
  account_number: t,
  account_type: n,
  name_on_account: a,
  routing_number: u,
  amount: S,
  currency_code: R
}) => t && n && a && u ? Ke`
      active_funding_source(
        account_number: $account_number
        account_type: $account_type
        name_on_account: $name_on_account
        routing_number: $routing_number
        verification_override: $verification_override
      ) {
        account_type
        name_on_account
        ${tc({ amount: S, currency_code: R })}
      }
    ` : "", tc = ({ amount: t, currency_code: n }) => t && n ? Ke`
      gpa_order(
        amount: $amount
        currency_code: $currency_code
      ) {
        token
        amount
      }
    ` : "";
var nc = { composeCardResourceMutation: Zs }, mi = {};
const { gql: ic } = e;
mi.cardProductExpandedBaseInfo = ic`
  token
  name
  active
  start_date
  end_date
  created_time
  last_modified_time
  config {
    card_life_cycle {
      ...cardProductCardLifeCycleBaseInfo
    }
    fulfillment {
      ...cardProductFulfillmentBaseInfo
      bins {
        data {
          ...binBaseInfo
        }
      }
    }
    jit_funding {
      ...cardProductJitFundingBaseInfo
    }
  }
  # Temporarily disable auth/velocity until https://marqeta.atlassian.net/browse/PS-16029 is implemented
  # to prevent over fetching data which leads to CP index page timeout
  # auth/velocity data will still appear on CP detail page just not on the index page
  # auth_controls {
  #   data {
  #     ...authControlBaseInfo
  #   }
  # }
  # velocity_controls {
  #   data {
  #     ...velocityControlBaseInfo
  #   }
  # }
`;
const { gql: c } = e, i = Qn, rc = c`
  dispute_details {
    ...disputeDetailsInfo
    network_case_status_details {
      ...networkCaseStatusDetailsInfo
    }
    additional_dispute_details {
      explanation_of_credit
      regulation_subcategory
      exception_reason_apply
      regulation_conditions_met_date
      reject_reason
    }
  }
`, ac = c`
  dispute_details {
    ...disputeDetailsInfo
    network_case_status_details {
      ...networkCaseStatusDetailsInfo
    }
    additional_dispute_details {
      explanation_of_credit
      regulation_subcategory
      exception_reason_apply
      regulation_conditions_met_date
      reject_reason
    }
    processing_error_type_dispute_details {
      duplicate_processing_or_paid_by_other_means_details {
        ...duplicateProcessingDetailsInfo
      }
      late_presentment_details {
        ...latePresentmentDetailsInfo
      }
      no_authorization_details {
        ...noAuthorizationDetailsInfo
      }
      invalid_data_details {
        ...invalidDataDetailsInfo
      }
      incorrect_transaction_code_details {
        ...incorrectTransactionCodeDetailsInfo
      }
      incorrect_currency_details {
        ...incorrectCurrencyDetailsInfo
      }
      incorrect_account_number_details {
        ...incorrectAccountNumberDetailsInfo
      }
      incorrect_transaction_amount_details {
        ...incorrectTransactionAmountDetailsInfo
      }
    }
    consumer_dispute_type_dispute_details {
      service_not_provided_merchandise_not_received_details {
        ...serviceNotProvidedMerchandiseNotReceivedDetailsInfo
      }
      cancelled_recurring_transaction_details {
        ...cancelledRecurringTransactionDetailsInfo
      }
      counterfeit_merch_details {
        ...counterfeitMerchDetailsInfo
      }
      not_as_described_or_defective_merchandise_details {
        ...notAsDecribedOrDefectiveMerchandiseDetailsInfo
      }
      credit_not_processed_details {
        ...creditNotProcessedDetailsInfo
      }
      cancelled_merchandise_or_services_details {
        ...cancelledMerchandiseOrServicesDetailsInfo
      }
      misrepresentation_details {
        ...misrepresentationDetailsInfo
      }
      original_credit_not_accepted_details {
        ...originalCreditNotAcceptedDetailsInfo
      }
    }
  }
`, Si = c`
  cardholder {
    token
    first_name
    last_name
    address1
    address2
    city
    state
    postal_code
    country
    birth_date
    email
    phone
  }
`, oc = c`
  query caseDocuments($case_token: ID!) {
    caseDocuments(case_token: $case_token) {
      count
      data {
        ...caseDocumentInfo
      }
    }
  }
  ${i.caseDocumentInfo}
`, sc = c`
  query events($case_token: ID!) {
    events(case_token: $case_token) {
      count
      data {
        ...caseEventInfo
      }
    }
  }
  ${i.caseEventInfo}
`, cc = c`
  query chargeback($token: ID!) {
    chargeback(token: $token) {
      token
      transaction_token
      amount
      reason_code
      state
      channel
      network
      network_case_id
      credit_user
      created_time
      last_modified_time
    }
    chargebackTransitions(token: $token) {
      count
      data {
        token
        state
        channel
        created_time
        last_modified_time
      }
    }
  }
`, _c = c`
  query milestones($case_token: ID!) {
    milestones(case_token: $case_token) {
      count
      data {
        ...caseMilestoneInfo
      }
    }
  }
  ${i.caseMilestoneInfo}
`, dc = c`
  query networkCaseStatusDetails($case_token: ID!) {
    networkCaseStatusDetails(case_token: $case_token) {
      ...networkCaseStatusDetailsInfo
    }
  }
  ${i.networkCaseStatusDetailsInfo}
`, lc = c`
  assignee
  business_token
  cardholder_token
  created_time
  folder_access_token
  folder_id
  folder_shared_link
  last_modified_time
  memo
  network_comment
  program_short_code
  state
  token
  type
  ${rc}
  ${Si}
`, uc = c`
  assignee
  business_token
  cardholder_token
  created_time
  folder_access_token
  folder_id
  folder_shared_link
  last_modified_time
  memo
  network_comment
  program_short_code
  state
  token
  type
  type_change_time
  zendesk_ticket_id
  ${ac}
  ${Si}
`, yi = c`
  ...disputeTransitionDetailsInfo
  network_details {
    dispute_transition_token
    dispute_state
    created_time
    ...networkDetailsInfo
    arbitration_details {
      ...arbitrationDetailsInfo
    }
    case_close_details {
      ...caseCloseDetailsInfo
    }
    prearbitration_details {
      ...prearbitrationDetailsInfo
    }
    representment_details {
      ...representmentDetailsInfo
    }
    prearbitration_response_details {
      ...prearbitrationResponseDetailsInfo
    }
    network_state_details {
      ...networkStateDetailsInfo
      issuer_acquirer_contact_info {
        ...issuerAcquirerContactInfo
      }
      dispute_amount {
        ...amountObjectInfo
      }
      case_filing_amount {
        ...amountObjectInfo
      }
      acceptance_amount {
        ...amountObjectInfo
      }
    }
  }
`, Ie = c`
  ${uc}
  transitions {
    count
    data {
      action
      assignee
      case_token
      created_by
      memo
      reason_code
      reason_description
      failure_reason
      state
      created_date
      token
      transition_details {
        review_details {
          attached_contents
        }
        chargeback_details {
          attached_contents
        }
      }
    }
  }
  transaction {
    ...transactionBaseInfo
    related_authorization {
      ...transactionBaseInfo
    }
    business {
      ...businessBaseInfo
    }
    card {
      expiration
      last_four
      state
    }
  }
  documents {
    count
    data {
      ...caseDocumentInfo
    }
  }
  associated_transactions {
    count
    data {
      ...associatedTransactionInfo
      network_selection_form {
        ...networkSelectionFormInfo
      }
    }
  }
  dispute_transitions {
    count
    data {
      ${yi}
    }
  }
`, gc = c`
  mutation createAndAssignCase(
    $dispute_details: DisputeDetailsInput
    $assignee: String
    $memo: String
    $network_comment: String
    $created_by: String
    $type: String
    $zendesk_ticket_id:ID
  ) {
    createAndAssignCase(
      dispute_details: $dispute_details
      type: $type
      assignee: $assignee
      memo: $memo
      network_comment: $network_comment
      created_by: $created_by
      zendesk_ticket_id: $zendesk_ticket_id
    ) {
      ${Ie}
    }
  }
  ${i.amountObjectInfo}
  ${i.arbitrationDetailsInfo}
  ${i.caseCloseDetailsInfo}
  ${i.associatedTransactionInfo}
  ${i.businessBaseInfo}
  ${i.cancelledMerchandiseOrServicesDetailsInfo}
  ${i.counterfeitMerchDetailsInfo}
  ${i.cancelledRecurringTransactionDetailsInfo}
  ${i.caseDocumentInfo}
  ${i.creditNotProcessedDetailsInfo}
  ${i.disputeDetailsInfo}
  ${i.disputeTransitionDetailsInfo}
  ${i.incorrectAccountNumberDetailsInfo}
  ${i.incorrectCurrencyDetailsInfo}
  ${i.incorrectTransactionAmountDetailsInfo}
  ${i.incorrectTransactionCodeDetailsInfo}
  ${i.issuerAcquirerContactInfo}
  ${i.duplicateProcessingDetailsInfo}
  ${i.latePresentmentDetailsInfo}
  ${i.noAuthorizationDetailsInfo}
  ${i.invalidDataDetailsInfo}
  ${i.misrepresentationDetailsInfo}
  ${i.networkCaseStatusDetailsInfo}
  ${i.networkDetailsInfo}
  ${i.networkSelectionFormInfo}
  ${i.networkStateDetailsInfo}
  ${i.notAsDecribedOrDefectiveMerchandiseDetailsInfo}
  ${i.prearbitrationDetailsInfo}
  ${i.representmentDetailsInfo}
  ${i.prearbitrationResponseDetailsInfo}
  ${i.originalCreditNotAcceptedDetailsInfo}
  ${i.serviceNotProvidedMerchandiseNotReceivedDetailsInfo}
  ${i.transactionBaseInfo}
`, pc = c`
  mutation createAndWithdrawCase(
    $dispute_details: DisputeDetailsInput
    $memo: String
    $type: String
  ) {
    createAndWithdrawCase(dispute_details: $dispute_details, type: $type, memo: $memo) {
      ...caseBaseInfo
    }
  }
  ${i.caseBaseInfo}
`, mc = c`
  mutation updateCase($token: ID!, $dispute_details: DisputeDetailsInput, $type: String) {
    updateCase(dispute_details: $dispute_details, type: $type, token: $token) {
      dispute_details {
        network_case_number
      }
    }
  }
`, Sc = c`
  mutation updateCase($token: ID!, $zendesk_ticket_id: String, $type: String) {
    updateCase(zendesk_ticket_id: $zendesk_ticket_id, type: $type, token: $token) {
      zendesk_ticket_id
    }
  }
`, yc = c`
  mutation createCaseAction($case_token: ID!, $action_type: String, $created_by: String!) {
    createCaseAction(action_type: $action_type, case_token: $case_token, created_by: $created_by) {
      action_type
    }
  }
`, Cc = c`
  mutation createCaseEvent(
    $case_token: ID!
    $event_date: String
    $created_by: String!
    $name: String!
  ) {
    createCaseEvent(
      case_token: $case_token
      event_date: $event_date
      created_by: $created_by
      name: $name
    ) {
      name
      event_date
    }
  }
`, Tc = c`
  mutation updateAndAssignCase(
    $token: ID!
    $dispute_details: DisputeDetailsInput
    $assignee: String
    $memo: String
    $created_by: String
    $type: String
    $replace_questionnaire: Boolean
  ) {
    updateAndAssignCase(
      token: $token
      dispute_details: $dispute_details
      type: $type
      memo: $memo
      assignee: $assignee
      created_by: $created_by
      replace_questionnaire: $replace_questionnaire
    ) {
      ${Ie}
    }
  }
  ${i.transactionBaseInfo}
  ${i.businessBaseInfo}
  ${i.disputeDetailsInfo}
  ${i.networkCaseStatusDetailsInfo}
  ${i.associatedTransactionInfo}
  ${i.networkSelectionFormInfo}
  ${i.caseDocumentInfo}
  ${i.duplicateProcessingDetailsInfo}
  ${i.latePresentmentDetailsInfo}
  ${i.noAuthorizationDetailsInfo}
  ${i.invalidDataDetailsInfo}
  ${i.misrepresentationDetailsInfo}
  ${i.incorrectTransactionCodeDetailsInfo}
  ${i.incorrectCurrencyDetailsInfo}
  ${i.incorrectAccountNumberDetailsInfo}
  ${i.incorrectTransactionAmountDetailsInfo}
  ${i.originalCreditNotAcceptedDetailsInfo}
  ${i.serviceNotProvidedMerchandiseNotReceivedDetailsInfo}
  ${i.cancelledRecurringTransactionDetailsInfo}
  ${i.notAsDecribedOrDefectiveMerchandiseDetailsInfo}
  ${i.creditNotProcessedDetailsInfo}
  ${i.cancelledMerchandiseOrServicesDetailsInfo}
  ${i.counterfeitMerchDetailsInfo}
  ${i.disputeTransitionDetailsInfo}
  ${i.arbitrationDetailsInfo}
  ${i.caseCloseDetailsInfo}
  ${i.prearbitrationDetailsInfo}
  ${i.representmentDetailsInfo}
  ${i.prearbitrationResponseDetailsInfo}
  ${i.networkStateDetailsInfo}
  ${i.networkDetailsInfo}
  ${i.issuerAcquirerContactInfo}
  ${i.amountObjectInfo}
`, Ic = c`
  mutation createCaseTransition(
    $case_token: ID!
    $action: String!
    $reason_code: String!
    $created_by: String
    $memo: String
    $created_date: String
    $transition_details: TransitionDetailsInput
  ) {
    createCaseTransition(
      case_token: $case_token
      action: $action
      reason_code: $reason_code
      created_by: $created_by
      memo: $memo
      created_date: $created_date
      transition_details: $transition_details
    ) {
      ...caseTransitionInfo
    }
  }
  ${i.caseTransitionInfo}
`, fc = c`
  count
  start_index
  end_index
  is_more
  data {
    ...bulkUploadInfo
`, Dc = c`
  mutation createCaseDocument(
    $case_token: ID!
    $file: FileInput
    $token: ID
    $document_category: String!
  ) {
    createCaseDocument(
      file: $file
      token: $token
      case_token: $case_token
      document_category: $document_category
    ) {
      token
      case_token
      document_category
      document_name
      created_time
      last_modified_time
    }
  }
`, Ac = c`
  mutation deleteCaseDocument($document_token: ID!, $case_token: ID!) {
    deleteCaseDocument(document_token: $document_token, case_token: $case_token) {
      status
    }
  }
`, kc = c`
  mutation updateCaseDocument(
    $case_token: ID!
    $document_category: String
    $document_name: String
    $document_token: ID!
  ) {
    updateCaseDocument(
      case_token: $case_token
      document_category: $document_category
      document_token: $document_token
      document_name: $document_name
    ) {
      ...caseDocumentInfo
    }
  }
  ${i.caseDocumentInfo}
`, hc = c`
  mutation submitATRAndTransition(
    $updateCase: UpdateAndAssignInput
    $createAssociatedTransactionsSelection: ATRSubmissionInput
    $updateAssociatedTransactionsSelection: ATRSubmissionInput
    $createCaseTransition: CaseTransitionInput!
  ) {
    submitATRAndTransition(
      updateCase: $updateCase
      createAssociatedTransactionsSelection: $createAssociatedTransactionsSelection
      updateAssociatedTransactionsSelection: $updateAssociatedTransactionsSelection
      createCaseTransition: $createCaseTransition
    ) {
      updateCase {
        ${Ie}
      }
      createAssociatedTransactionsSelection {
        ...associatedTransactionInfo
        network_selection_form {
          ...networkSelectionFormInfo
        }
      }
      updateAssociatedTransactionsSelection {
        ...associatedTransactionInfo
        network_selection_form {
          ...networkSelectionFormInfo
        }
      }
      createCaseTransition {
        ...caseTransitionInfo
      }
    }
  }
  ${i.caseTransitionInfo}
  ${i.businessBaseInfo}
  ${i.disputeDetailsInfo}
  ${i.networkCaseStatusDetailsInfo}
  ${i.transactionBaseInfo}
  ${i.associatedTransactionInfo}
  ${i.networkSelectionFormInfo}
  ${i.caseDocumentInfo}
  ${i.misrepresentationDetailsInfo}
  ${i.duplicateProcessingDetailsInfo}
  ${i.latePresentmentDetailsInfo}
  ${i.noAuthorizationDetailsInfo}
  ${i.invalidDataDetailsInfo}
  ${i.incorrectTransactionCodeDetailsInfo}
  ${i.incorrectCurrencyDetailsInfo}
  ${i.incorrectAccountNumberDetailsInfo}
  ${i.incorrectTransactionAmountDetailsInfo}
  ${i.originalCreditNotAcceptedDetailsInfo}
  ${i.serviceNotProvidedMerchandiseNotReceivedDetailsInfo}
  ${i.cancelledRecurringTransactionDetailsInfo}
  ${i.notAsDecribedOrDefectiveMerchandiseDetailsInfo}
  ${i.creditNotProcessedDetailsInfo}
  ${i.cancelledMerchandiseOrServicesDetailsInfo}
  ${i.counterfeitMerchDetailsInfo}
  ${i.disputeTransitionDetailsInfo}
  ${i.arbitrationDetailsInfo}
  ${i.caseCloseDetailsInfo}
  ${i.prearbitrationDetailsInfo}
  ${i.representmentDetailsInfo}
  ${i.prearbitrationResponseDetailsInfo}
  ${i.networkStateDetailsInfo}
  ${i.networkDetailsInfo}
  ${i.issuerAcquirerContactInfo}
  ${i.amountObjectInfo}
`, Ec = c`
  mutation submitATR(
    $createAssociatedTransactionsSelection: ATRSubmissionInput
    $updateAssociatedTransactionsSelection: ATRSubmissionInput
  ) {
    submitATR(
      createAssociatedTransactionsSelection: $createAssociatedTransactionsSelection
      updateAssociatedTransactionsSelection: $updateAssociatedTransactionsSelection
    ) {
      createAssociatedTransactionsSelection {
        ...associatedTransactionInfo
        network_selection_form {
          ...networkSelectionFormInfo
        }
      }
      updateAssociatedTransactionsSelection {
        ...associatedTransactionInfo
        network_selection_form {
          ...networkSelectionFormInfo
        }
      }
    }
  }
  ${i.associatedTransactionInfo}
  ${i.networkSelectionFormInfo}
`, $c = c`
  mutation createDisputeTransition(
    $case_token: ID!
    $action: String!
    $created_by: String
    $memo: String
    $network_details: NetworkDetailsInput
    $withWriteOff: Boolean
  ) {
    createDisputeTransition(
      case_token: $case_token
      action: $action
      created_by: $created_by
      memo: $memo
      network_details: $network_details
      withWriteOff: $withWriteOff
    ) {
      ${yi}
    }
  }
  ${i.disputeTransitionDetailsInfo}
  ${i.arbitrationDetailsInfo}
  ${i.caseCloseDetailsInfo}
  ${i.prearbitrationDetailsInfo}
  ${i.representmentDetailsInfo}
  ${i.prearbitrationResponseDetailsInfo}
  ${i.networkStateDetailsInfo}
  ${i.networkDetailsInfo}
  ${i.issuerAcquirerContactInfo}
  ${i.amountObjectInfo}
`, Pc = `query getApplicationProperties {
  applicationPropertiesProgramCountryCode {
    application_properties_country_code
  }
}`, vc = c`
  query caseProgramConfigs($count: Int) {
    caseProgramConfigs(count: $count) {
      count
      is_more
      data {
        type
        enabled
        filter_constraint {
          category
          values {
            min_days
            max_days
          }
        }
        template_criteria {
          dispute_reason
          country_code
        }
        template_values {
          on_board_date
        }
      }
    }
  }
`, Rc = c`
  mutation retrieveCaseDocuments($case_token: ID!) {
    retrieveCaseDocuments(case_token: $case_token) {
      status
    }
  }
`;
var bc = {
  bulkUploadListInfo: fc,
  caseProgramConfigsQuery: vc,
  caseTransitionCreationMutation: Ic,
  createAndAssignCaseMutation: gc,
  createCaseActionMutation: yc,
  createCaseEventMutation: Cc,
  createDisputeTransitionMutation: $c,
  createAndWithdrawCaseMutation: pc,
  deleteDisputeDocument: Ac,
  disputeBaseInfo: lc,
  disputeDocuments: oc,
  eventsQuery: sc,
  expandedCompleteDisputeInfo: Ie,
  milestones: _c,
  refreshNetworkCaseStatus: dc,
  retrieveCaseDocuments: Rc,
  submitATR: Ec,
  submitATRAndTransitionMutation: hc,
  updateAndAssignCaseMutation: Tc,
  updateDisputeDocumentMutation: kc,
  updateNetworkCaseNumberMutation: mc,
  updateZendeskTicketIdMutation: Sc,
  uploadDisputeDocument: Dc,
  applicationPropertiesQuery: Pc,
  chargebackQuery: cc
};
const Nc = pi, Bc = nc, Oc = mi, Fc = bc;
var Ci = {
  ...Nc,
  ...Fc,
  ...Bc,
  ...Oc
};
const { gql: ze } = e, { paginationParams: qe, generateCollectionType: Me } = r, { achBankTransferBaseInfo: Ue } = Ci, wc = ze`
  enum TransferSpeed {
    STANDARD
    SAME_DAY
  }

  enum EntryClassCode {
    WEB
    PPD
    CCD
  }

  enum AchBankTransferType {
    PULL
    PUSH
  }

  enum AchBankTransferChannel {
    API
    SYSTEM
    ADMIN
  }

  type AchBankTransfer {
    ${Ue}
    achFundingSource: FundingSource
  }
  
  type AchProgramBankTransferGranular {
    ${Ue}
    achProgramFundingSource: FundingSource
  },
  
  type AchProgramBankTransfer {
    ${Ue}
    achProgramFundingSource: AchProgramFundingSource
  }

  ${Me("AchBankTransfer")}
  ${Me("AchProgramBankTransfer")}
  ${Me("AchProgramBankTransferGranular")}
`, qc = ze`
  achBankTransfer(token: ID!): AchBankTransfer
  achBankTransfers(
    ${qe},
    user_token: String,
    business_token: String,
    funding_source_token: String,
    statuses: String
  ): AchBankTransferCollection
  achProgramBankTransfer(token: ID!): AchProgramBankTransfer
  achProgramBankTransfers(
    ${qe},
    user_token: String,
    business_token: String,
    funding_source_token: String,
    statuses: String
  ): AchProgramBankTransferCollection
  achProgramBankTransferGranular(token: ID!): AchProgramBankTransferGranular
  achProgramBankTransfersGranular(
    ${qe},
    user_token: String,
    business_token: String,
    funding_source_token: String,
    statuses: String
  ): AchProgramBankTransferGranularCollection
`, Mc = ze`
  createAchBankTransfer(
    amount: Float!,
    currency_code: String,
    funding_source_token: String!,
    memo: String,
    standard_entry_class_code: EntryClassCode,
    statement_descriptor: String,
    transfer_speed: TransferSpeed,
    type: AchBankTransferType
    channel: AchBankTransferChannel
    created_by: String
  ): AchBankTransfer
  createAchBankTransferGranular(
    amount: Float!,
    currency_code: String,
    funding_source_token: String!,
    memo: String,
    standard_entry_class_code: EntryClassCode,
    statement_descriptor: String,
    transfer_speed: TransferSpeed,
    type: AchBankTransferType
    channel: AchBankTransferChannel
    created_by: String
  ): AchBankTransfer
`;
var Uc = { types: wc, queries: qc, mutations: Mc };
const { gql: Ti } = e, { generateCollectionType: Lc } = r, xc = Ti`
  type AchBankTransferTransition {
    bank_transfer_token: ID!
    batch_number: String
    channel: String
    program_reserve_token: ID
    reason_code: String
    reason: String
    status: String
    token: ID
    transaction_jit_token: ID
    transaction_token: ID
    created_time: String
    last_modified_time: String
  }
  ${Lc("AchBankTransferTransition")}
`, Gc = Ti`
  createAchBankTransferTransition(
    bank_transfer_token: ID!
    batch_number: String
    channel: String!
    program_reserve_token: ID
    reason_code: String
    reason: String
    status: String!
    token: ID
  ): AchBankTransferTransition
`;
var Hc = { types: xc, mutations: Gc };
const { gql: je } = e, Vc = je`
  type AcsConfig {
    active: Boolean
    authentication_type: String
    created_time: String
    last_modified_time: String
    long_code: String
    message_version: String
    program_customer_care_number: String
    program_email_address: String
    program_endpoint_url: String
    program_name: String
    short_code: String
    token: String
    verified_email: Boolean
    logo: File
    program_attributes: [ProgramAttribute]
    supported_message_versions: String
    authentication_preference: String
    decision_preference: String
  }
`, Yc = je`
  acsConfig: AcsConfig
`, Wc = je`
  createThreeDSLogo(
    file: String!
    filename: String!
    mimetype: String!
  ): File
  downloadThreeDSLogo(
    ID: String!
  ): File
  updateAcsConfig(
    active: Boolean
    authentication_type: String
    long_code: String
    message_version: String
    program_customer_care_number: String
    program_email_address: String
    program_endpoint_url: String
    program_name: String
    token: String!
    program_attributes: [ProgramAttributeUpdateInput]
    supported_message_versions: String
    authentication_preference: String
    decision_preference: String
  ): AcsConfig
  createAcsConfig(
    active: Boolean
    authentication_type: String
    long_code: String
    message_version: String
    program_customer_care_number: String
    program_email_address: String
    program_endpoint_url: String
    program_name: String
    program_attributes: [ProgramAttributeCreateInput]
    supported_message_versions: String
    authentication_preference: String
    decision_preference: String
  ): AcsConfig
  deleteThreeDSLogo(
    ID: String!
  ): File
`;
var Kc = { types: Vc, queries: Yc, mutations: Wc };
const { gql: Ii } = e, { paginationParams: zc, generateCollectionType: jc } = r, Qc = Ii`
  enum ENTITY_TYPE {
    CreditBundle
    CreditProduct
    Card
    User
    Accountholder
    Account
  }

  type ActivityLog {
    token: String
    userInitials: String
    email: String
    description: String
    createdTime: String
    note: String
  }

  ${jc("ActivityLog")}
`, Jc = Ii`
    activityLogs(
      token: ID!,
      entityType: ENTITY_TYPE!,
      account_token: ID,
      ${zc}
    ): ActivityLogCollection
`;
var Zc = { types: Qc, queries: Jc };
const { gql: Xc } = e, e_ = Xc`
  type Address implements AbstractAddress {
    first_name: String
    middle_name: String
    last_name: String
    address1: String
    address2: String
    city: String
    state: String
    postal_code: String
    zip: String
    country: String
    phone: String
  }

  input AddressInput {
    first_name: String
    middle_name: String
    last_name: String
    address1: String
    address2: String
    city: String
    state: String
    postal_code: String
    zip: String
    country: String
    phone: String
  }
`;
var t_ = { types: e_ };
const { gql: Qe } = e, n_ = Qe`
  type ApplicationData {
    json: String
  }
`, i_ = Qe`
  applicationData: ApplicationData
`, r_ = Qe`
  updateApplicationData(
    json: String!
  ): ApplicationData
`;
var a_ = { types: n_, queries: i_, mutations: r_ };
const { gql: fi } = e, o_ = fi`
  type ApplicationPropertiesCountryCode {
    application_properties_country_code: String
  }
  
  type ApplicationPropertiesResponse {
    allowable_dispute_itc: [String]
    invalid_transaction_states: [String]
    api_enabled_program_short_codes: [String]
    programs_required_crm_ticket_input: [String]
  }
`, s_ = fi`
  applicationPropertiesProgramCountryCode: ApplicationPropertiesCountryCode
  refreshApplicationProperties: ApplicationPropertiesResponse
`;
var c_ = { types: o_, queries: s_ };
const { gql: __ } = e, d_ = __`
  type ApprovalQueueAction {
    base_url: String
    created_time: String
    endpoint: String
    headers: String
    last_modified_time: String
    method: RestMethodEnum
    name: String
    payload: String
    previous_values: String
    service: String
    state: ApprovalQueueActionStateEnum
    token: String
  }
`;
var l_ = { types: d_ };
const { gql: Je } = e, u_ = Je`
  type ApprovalQueueRequest {
    actions: [ApprovalQueueAction]
    notes: [ApprovalQueueNote]
    created_by: String
    created_by_user: User
    created_time: String
    last_modified_by: String
    last_modified_by_user: User
    last_modified_time: String
    name: String
    program_short_code: String
    state: ApprovalQueueRequestStateEnum
    token: String
    type: String
  }

  input ActionInput {
    name: String
    payload: String
    previous_values: String
  }
`, g_ = Je`
  approvalQueueRequest(token: String!): ApprovalQueueRequest
`, p_ = Je`
  createApprovalQueueRequest(
    actions: [ActionInput]
    note: String
    type: String
    name: String
  ): ApprovalQueueRequest
  updateApprovalQueueRequest(
    token: String!
    state: String!
    note: String
    actions: [ActionInput]
    program_short_code: String!
  ): ApprovalQueueRequest
`;
var m_ = { types: u_, queries: g_, mutations: p_ };
const { gql: S_ } = e, y_ = S_`
  type ApprovalQueueNote {
    content: String
    created_by: String
    created_by_user: User
    created_time: String
    last_modified_time: String
    request_state: String
  }
`;
var C_ = { types: y_ };
const { gql: Di } = e, { generateCollectionType: T_, paginationParams: I_ } = r, f_ = Di`
  ${T_("ApprovalQueueRequest")}
`, D_ = Di`
  approvalQueueRequests(
    ${I_},
    end_last_modified_time: String
    program_short_code: String,
    sort_by: String,
    state: [ApprovalQueueRequestStateEnumInput],
    start_last_modified_time: String
    type: [String],
  ): ApprovalQueueRequestCollection
`;
var A_ = { types: f_, queries: D_ };
const { gql: k_ } = e, h_ = k_`
  enum ApprovalQueueRequestStateEnum {
    APPROVED
    CANCELLED
    OPEN
    REJECTED
  }
`;
var E_ = { types: h_ };
const { gql: $_ } = e, P_ = $_`
  enum ApprovalQueueRequestStateEnumInput {
    REJECTED
    OPEN
    APPROVED
    CANCELLED
  }
`;
var v_ = { types: P_ };
const { gql: R_ } = e, b_ = R_`
  enum ApprovalQueueActionStateEnum {
    OPEN
    COMPLETE
    ERROR
  }
`;
var N_ = { types: b_ };
const B_ = E_, O_ = v_, F_ = N_;
var w_ = {
  ApprovalQueueRequestStateEnumInput: O_,
  ApprovalQueueStateEnum: B_,
  ApprovalQueueActionStateEnum: F_
};
const q_ = l_, M_ = m_, U_ = C_, L_ = A_, {
  ApprovalQueueRequestStateEnumInput: x_,
  ApprovalQueueStateEnum: G_,
  ApprovalQueueActionStateEnum: H_
} = w_;
var V_ = [
  H_,
  q_,
  M_,
  x_,
  G_,
  L_,
  U_
];
const { gql: Ze } = e, { paginationParams: $n, generateCollectionType: Y_ } = r, W_ = Ze`
  input APRPolicyPurchaseTierInput {
    marginRate: Float
  }

  type APRPolicyPurchaseTier {
    marginRate: Float
    apr: Float
  }

  input APRPolicyPurchaseInput {
    externalToken: String
    name: String
    tiers: [APRPolicyPurchaseTierInput]
  }

  type APRPolicyPurchase {
    externalToken: String
    name: String
    tiers: [APRPolicyPurchaseTier]
  }

  type APRPolicy {
    token: String
    name: String
    description: String
    purchases: APRPolicyPurchase
    createdTime: String
    updatedTime: String
    effectiveDate: String
  }

  ${Y_("APRPolicy")}
`, K_ = `
  token: ID
  name: String!
  description: String
  purchases: APRPolicyPurchaseInput!
`, z_ = `
  token: ID!,
  name: String!,
  description: String,
  purchases: APRPolicyPurchaseInput!
`, j_ = Ze`
  aprPolicy(token: ID!): APRPolicy
  aprPolicies(${$n}): APRPolicyCollection
  aprPolicySchedules(token: ID!, ${$n}): APRPolicyCollection
`, Q_ = Ze`
  aprPolicyCreate(${K_}): APRPolicy
  aprPolicyClone(token: ID!): APRPolicy
  aprPolicyUpdate(${z_}): APRPolicy
`;
var J_ = { types: W_, queries: j_, mutations: Q_ };
const { gql: Ai } = e, { paginationParams: pv, generateCollectionType: Z_ } = r, X_ = Ai`
  type AssociatedTransaction {
    network_type: String
    token: ID
    case_token: String
    transaction_date: String
    transaction_amount: String
    transaction_currency: String
    transaction_currency_alpha: String
    merchant_name: String
    network_associated_transaction_group_id: String
    transaction_type: String
    transaction_id: String
    auth_code: String
    arn: String
    retrieval_reference_number: String
    matching_pass: String
    matching_score: String
    network_submission_status: String
    network_reject_reason: String
    first_network_submission_time: String
    last_network_submission_time: String
    network_selection_form: NetworkSelectionForm
    created_time: String
    last_modified_time: String
    network_submission_failure_reason: String
    associated: Boolean
  }

  type NetworkSelectionForm {
    network_type: String
    credit_change_reason: String
    auth_change_reason: String
    associated: Boolean
  }

  input AssociatedTransactionSelectionInput {
    associated_transaction_token: ID
    credit_change_reason: String
    auth_change_reason: String
    associated: Boolean!
  }

  input ATRSubmissionInput {
    case_token: ID!
    network_type: String!
    credit_change_reason: String
    auth_change_reason: String
    associated_transactions: [AssociatedTransactionSelectionInput]
  }

  ${Z_("AssociatedTransaction")}
`, ed = Ai`
  createAssociatedTransactionsSelection(
    case_token: ID!
    network_type: String!
    credit_change_reason: String
    auth_change_reason: String
    associated_transactions: [AssociatedTransactionSelectionInput]
  ): [AssociatedTransaction]
  updateAssociatedTransactionsSelection(
    case_token: ID!
    network_type: String!
    credit_change_reason: String
    auth_change_reason: String
    associated_transactions: [AssociatedTransactionSelectionInput]
  ): [AssociatedTransaction]
`;
var td = { types: X_, mutations: ed };
const { gql: ki } = e, { paginationParams: nd, generateCollectionType: id } = r, rd = ki`
  type AuditLog {
    id: ID!
    app_name: String
    app_server_name: String
    record_type: String
    record_id: String
    record_operation: String
    remote_ip_address: String
    user_name: String
    event_type: String
    program: String
    http_path: String
    http_method: String
    http_params: String
    http_status_code: String
    user_role: String
    created_time: String
    last_modified_time: String
    old_value: String
    new_value: String
    notes: String
    extra_info: String
  }

  ${id("AuditLog")}
`, ad = ki`
  auditLogs(
    ${nd},
    app_name: String,
    end_date: String,
    program: String,
    record_id: String,
    record_operation: String,
    record_type: String,
    start_date: String,
    user_name: String,
  ): AuditLogCollection
`;
var od = { types: rd, queries: ad };
const { gql: Xe } = e, { paginationParams: sd, generateCollectionType: cd } = r, _d = Xe`
  type AuthControl {
    token: ID!
    name: String
    active: Boolean
    association: Association
    merchant_scope: MerchantScope
    start_time: String
    end_time: String
  }

  input AuthControlInput {
    token: ID
    name: String!
    active: Boolean
    association: AssociationInput
    merchant_scope: MerchantScopeInput
    start_time: String
    end_time: String
  }

  ${cd("AuthControl")}
`, dd = Xe`
  authControl(token: ID!): AuthControl
  authControls(
    business_token: String
    cardholder_token: String
    card_product_token: String
    ${sd}
  ): AuthControlCollection
`, ld = Xe`
  createAuthControl(
    token: ID
    name: String!
    active: Boolean
    association: AssociationInput
    merchant_scope: MerchantScopeInput
    start_time: String
    end_time: String
  ): AuthControl

  updateAuthControl(
    token: ID!
    name: String
    active: Boolean
    association: AssociationInput
    merchant_scope: MerchantScopeInput
    start_time: String
    end_time: String
  ): AuthControl
`;
var ud = { types: _d, queries: dd, mutations: ld };
const { gql: hi } = e, { generateCollectionType: gd } = r, pd = hi`
  type Balance implements AbstractBalance {
    available_balance: Float
    credit_balance: Float
    currency_code: String
    impacted_amount: Float
    ledger_balance: Float
    pending_credits: Float
    cached_balance: Float
    last_updated_time: String
  }

  type BalanceByCurrency {
    USD: Balance
    EUR: Balance
    GBP: Balance
  }

  type BalanceLink {
    rel: String
    method: String
    href: String
  }

  type GpaBalance {
    gpa: Balance
    links: [BalanceLink]
  }

  type GpaObject {
    available_balance: Float
    balances: BalanceByCurrency
    cached_balance: Float
    credit_balance: Float
    currency_code: String
    impacted_amount: Float
    ledger_balance: Float
    pending_credits: Float
  }

  type MsaBalance implements AbstractBalance {
    currency_code: String
    ledger_balance: Float
    available_balance: Float
    credit_balance: Float
    pending_credits: Float
    impacted_amount: Float
    balances: BalanceByCurrency
    name: String
    campaign_token: String
  }
  ${gd("MsaBalance")}
`, md = hi`
  balance: Balance
`;
var Sd = { types: pd, queries: md };
const { gql: et } = e, { paginationParams: yd } = r, Cd = et`
  type BankReport {
    report_name: String
    type: String
    reporting_month: String
    uploaded_date: String
    processed_date: String
    submit_date: String
    program_short_code: String
    created_by: String
    status: STATUS
    original_file_url: String
    failed_file_url: String
    counts: Counts
  }
  type BankReportResponse {
    count: Int
    start_index: Int
    end_index: Int
    is_more: Boolean
    data: [BankReport]
    error: BankReportsError
  }
  type BankReportsError {
    code: ID
    message: String
  }
  type Counts {
    total: Int
    failed: Int
    processed: Int
  }
  enum STATUS {
    PENDING
    PROCESSING
    PROCESSED
    FAILED
    COMPLETED
    SUBMITTED
  }
  type ReportUploadResponse {
    error: ReportUploadError
    id: ID
    report_name: String
    token: String
    uploaded_date: String
    created_by: String
    program_short_code: String
    status: STATUS
    original_file_url: String
    failed_file_url: String
    message: String
  }
  type ReportUploadError {
    code: ID
    message: String
  }
`, Td = et`
  bankReports(${yd}, type: String, sort_by: String): BankReportResponse
`, Id = et`
  uploadBankReport(
    type: String,
    report_name: String,
    multi_program_code: String,
    report_data: String,
    created_by: String
    ): ReportUploadResponse
`;
var fd = { types: Cd, queries: Td, mutations: Id };
const { gql: Ei } = e, { generateCollectionType: Dd } = r, Ad = Ei`
  type BankTransferInformation {
    accountOwner: String
    accountNumber: String
    accountName: String
    financialInstitution: String
    financialInstitutionCityState: String
    wireTransferRoutingTransitNumber: String
    wireTransferSwiftCode: String
    achTransacctionBankRoutingNumber: String
  }

  ${Dd("BankTransferInformation")}
`, kd = Ei`
  bankTransferInformation(webToken: String!): BankTransferInformation
`;
var hd = { types: Ad, queries: kd };
const { gql: $i } = e, { paginationParams: Ed, generateCollectionType: $d } = r, Pd = $i`
  scalar AddressToken
  {
    address_token: String
  }

  scalar Biller
  {
    biller_token: String
    name: String
    logo_type: String
    address: AddressToken
  }

  type BillPayment {
    payment_token: String
    user_token: String
    payee_token: String
    payment_account_type: String
    payment_type: String
    payment_account_token: String
    card_token: String
    amount: Float
    convenience_fee: Float
    biller: Biller
    status: String
    processing_date: String
    delivery_date: String
    created_time: String
    last_modified_time: String
  }

  ${$d("BillPayment")}
`, vd = $i`
    billPayments(
    ${Ed}
    user_token: ID!,
    start_date: String,
    end_date: String,
    ): BillPaymentCollection
`;
var Rd = { types: Pd, queries: vd };
const { gql: tt } = e, { paginationParams: bd, generateCollectionType: Nd } = r, Bd = tt`
  input BankInput {
    token: ID!
    active: Boolean
    name: String
  }
  type Bin {
    active_at_network: Boolean
    active: Boolean
    bank: Bank
    bin: Int
    classification: String
    created_time: String
    emv: String
    ica: String
    last_modified_time: String
    marqeta_role: String
    network: String
    notes: String
    token: ID!
    type: String
    unaffiliated_pin_debit_network: String
    region: String
  }
  ${Nd("Bin")}
`, Od = tt`
  bins(
    active_at_network: Boolean
    active: Boolean
    bank_token: String
    bin: Int
    classification: String
    created_time: String
    emv: String
    expand: String
    last_modified_time: String
    marqeta_role: String
    network: String
    notes: String
    token: String
    type: String
    unaffiliated_pin_debit_network: String
    ${bd}
  ): BinCollection

  bin(token: ID!): Bin
`, Fd = tt`
  createBin(
    active_at_network: Boolean
    active: Boolean
    bank: BankInput
    bin: Int
    classification: String
    created_time: String
    emv: String
    ica: String
    last_modified_time: String
    marqeta_role: String
    network: String
    notes: String
    region: String
    type: String
    unaffiliated_pin_debit_network: String
  ): Bin

  updateBin(
	  active_at_network: Boolean
	  active: Boolean
	  bank: BankInput
	  bin: Int
	  classification: String
	  created_time: String
	  emv: String
    ica: String
	  last_modified_time: String
	  marqeta_role: String
	  network: String
	  notes: String
	  type: String
	  unaffiliated_pin_debit_network: String
  	token: ID!
    region: String
  ): Bin
`;
var wd = { types: Bd, queries: Od, mutations: Fd };
const { gql: nt } = e, { paginationParams: Pn, generateCollectionType: vn } = r, qd = nt`
  type BinPrefixBin {
    active_at_network: Boolean
    active: Boolean
    bank: Bank
    bin: Int
    classification: String
    created_time: String
    emv: String
    ica: String
    last_modified_time: String
    marqeta_role: String
    network: String
    region: String
    token: ID!
    type: String
  }
  type BinPrefixProgram {
    active: Boolean
    created_time: String
    last_modified_time: String
    long_code: String
    name: String
    processor_only: Boolean
    program_id: Int
    short_code: String
    solution: String
    token: ID!
    uai_prefix: String
  }
  type BinPrefixNetworkProduct {
    created_time: String
    is_premium: Boolean
    last_modified_time: String
    network: String
    platform: String
    product_code: String
    product_name: String
    token: ID!
  }
  input BinInput {
    token: ID
  }
  input NetworkInput {
    token: ID
  }
  input ProductInput {
    token: ID
  }
  type BinPrefix {
    active: Boolean
    active_at_network: Boolean
    approval_number: String
    bin_prefix: String
    bin: BinPrefixBin
    card_category: String
    created_time: String
    currency: String
    emv: String
    issuing_country: String
    last_modified_time: String
    network_product: BinPrefixNetworkProduct
    program: BinPrefixProgram
    program_construct: String
    reloadable: Boolean
    reporting_id: String
    routing_id: String
    token: ID!
    tokenization_bin_prefix: Int
  }
  type BinPrefixProduct {
    network: String
    token: String
    platform: String
    created_time: String
    last_modified_time: String
    product_code: String
    product_name: String
    is_premium: Boolean
  }
  ${vn("BinPrefix")}
  ${vn("BinPrefixProduct")}
`, Md = nt`
  binprefixes(
    active: Boolean
    active_at_network: Boolean
    approval_number: String
    bin_prefix: String
    bin: Int
    bin_token: String
    card_category: String
    created_time: String
    currency: String
    emv: String
    expand: String
    issuing_country: String
    last_modified_time: String
    network_product: String
    program_token: String
    reloadable: Boolean
    routing_id: String
    token: String
    tokenization_bin_prefix: Int
    ${Pn}
  ): BinPrefixCollection

  binprefix(
    token: ID!
  ): BinPrefix
  
  binPrefixesByTokens(
    tokens: [ID!]
    expand: String
  ): [BinPrefix]

  binPrefixProducts(
    network: String
    platform: String
    ${Pn}
  ): BinPrefixProductCollection
`, Ud = nt`
  createBinprefix(
    active: Boolean
    active_at_network: Boolean
    approval_number: String
    bin: BinInput
    bin_prefix: String
    card_category: String
    currency: String
    issuing_country: String
    network_product: NetworkInput
    program_construct: String
    reloadable: Boolean
    reporting_id: String
    tokenization_bin_prefix: Int
  ): BinPrefix

  updateBinprefix(
    active: Boolean
    active_at_network: Boolean
    approval_number: String
    bin: BinInput
    bin_prefix: String
    card_category: String
    currency: String
    issuing_country: String
    network_product: NetworkInput
    program_construct: String
    program_short_code: String
    reloadable: Boolean
    reporting_id: String
    tokenization_bin_prefix: Int
    token: ID!
  ): BinPrefix
  `;
var Ld = { types: qd, queries: Md, mutations: Ud };
const { gql: Pi } = e, xd = Pi`
  type BoxFolderItem {
    id: ID!
    type: String
    name: String
    content_created_at: String
    content_modified_at: String
    created_at: String
    created_by: BoxFolderItemCreatedBy
    description: String
    shared_link: BoxFolderItemSharedLink
  }

  type BoxFolderItemCreatedBy {
    id: ID
    type: String
    login: String
    name: String
  }

  type BoxFolderItemSharedLink {
    download_url: String
    url: String
    vanity_url: String
  }

  type BoxFolder {
    id: ID
    total_count: Int
    entries: [BoxFolderItem]
    order: BoxOrderObject
    limit: Int
    offset: Int
  }

  type BoxOrderObject {
    by: String
    direction: String
  }
`, Gd = Pi`
  disputeFile(
    id: ID
    fields: String # Comma separated list
  ): BoxFolderItem
  getDisputeItems(
    id: ID!
    sort: String # One of id,name,date,size
    direction: String
    limit: Int
    fields: String # Comma separated list
    offset: Int
  ): BoxFolder
`;
var Hd = { types: xd, queries: Gd };
const { gql: it } = e, { generateCollectionType: Vd, paginationParams: Yd } = r, Wd = it`
  type BulkUpload {
    created_time: String
    failure_reason: String
    file_name: String
    last_modified_time: String
    original_file_link: String
    reject_report_link: String
    status: String
    token: ID!
  }

  ${Vd("BulkUpload")}
`, Kd = it`
  bulkUploadList(
    ${Yd}
    status: String,
    exclude_multiprogram: String
  ): BulkUploadCollection
`, zd = it`
  uploadBulkDisputeFile(
    file_data: String,
    file_name: String,
    ): BulkUpload
`;
var jd = { types: Wd, queries: Kd, mutations: zd };
const { gql: rt } = e, { paginationParams: Rn, generateCollectionType: Qd } = r, H = `
  name: String
  createdTime: String
  updatedTime: String
  token: ID
  description: String
`, Jd = rt`
  enum BUNDLE_STATUS {
    PENDING_APPROVAL
    SENT_FOR_REVISION
    ACTIVE
    REJECTED
    ARCHIVED
    APPROVED
  }

  type PolicyPayment {
    defaultMethod: String
    defaultValue: Int
  }

  type PolicyPeriodicFee {
      feeAmount: Float
      numberOfDaysPostActivation: Int
      excludeFromInterestCalculation: Boolean
  }

  type PolicyForeignTransactionFee {
    defaultMethod: String
    defaultValue: Float
  }

  type PolicyAccount { 
    latePayment: PolicyPayment
    returnedPayment: PolicyPayment
    foreignTransactionFee: PolicyForeignTransactionFee
    monthlyFee: PolicyPeriodicFee
    annualFee: PolicyPeriodicFee
  }

  type OfferPolicyDetail {
    ${H}
  }

  type RewardPolicyDetail {
    ${H}

    rules: [RewardRule]
  }
 
  type FeePolicyDetail {
    account: PolicyAccount

    ${H}
  }
    
  type AprPolicyDetail {
    purchases: APRPolicyPurchase
    effectiveDate: String
    ${H}
  }

  type DocumentPolicyDetail {
    summaryOfCreditTerms: DocumentPolicyTemplateAndAsset
    rewardsDisclosure: DocumentPolicyTemplateAndAsset
    privacyPolicy: DocumentPolicyAsset
    eDisclosure: DocumentPolicyAsset
    cardMemberAgreement: DocumentPolicyAsset
    benefitsDisclosureTraditional: DocumentPolicyAsset
    benefitsDisclosurePremium: DocumentPolicyAsset

    termsSchedule: DocumentPolicyTemplate
    noaaSingleReason: DocumentPolicyTemplate
    noaaSingleReasonWithDoddFrank: DocumentPolicyTemplate
    noaaMultipleReasonWithDoddFrank: DocumentPolicyTemplate
    ${H}
  }

  type Bundle {
    token: ID
    parentToken: String
    name: String
    status: BUNDLE_STATUS
    description: String
    createdTime: String
    updatedTime: String
    aprPolicyToken: ID
    rewardPolicyToken: ID
    creditProductPolicyToken: ID
    documentPolicyToken: ID
    feePolicyToken: ID
    offerPolicyToken: ID
    offerPolicyDetail: OfferPolicyDetail
    rewardPolicyDetail: RewardPolicyDetail
    feePolicyDetail: FeePolicyDetail
    aprPolicyDetail: AprPolicyDetail
    creditProductPolicyDetail: CreditProductPolicy
    documentPolicyDetail: DocumentPolicyDetail
  }
  
  type BundleTransition {
    token: String
    bundleToken: String
    originalStatus: BUNDLE_STATUS
    status: BUNDLE_STATUS
    createdTime: String
  }

  ${Qd("Bundle")}
`, Zd = rt`
    bundle(token: ID!): Bundle
    bundles(${Rn}, status: [BUNDLE_STATUS]): BundleCollection
    bundleLineage(token: ID!, ${Rn}): BundleCollection
`, Xd = `
  token: ID,
  name: String!
  description: String
  status: BUNDLE_STATUS
  creditProductPolicyToken: String!
  feePolicyToken: String!
  aprPolicyToken: String!
  offerPolicyToken: String
  rewardPolicyToken: String
  documentPolicyToken: String!
  comment: String!
`, el = `
  name: String!
  status: BUNDLE_STATUS!
  description: String!
  creditProductPolicyToken: ID!
  feePolicyToken: ID!
  aprPolicyToken: ID!
  documentPolicyToken: ID!
  offerPolicyToken: ID
  rewardPolicyToken: ID
  token: ID!
  comment: String!
`, tl = rt`
  bundleCreate(${Xd}): Bundle
  bundleClone(token: ID!): Bundle
  bundlePromote(token: ID!): Bundle
  bundleTransitionCreate(bundleToken: ID!, status: BUNDLE_STATUS!, comment: String!): BundleTransition
  bundleUpdate(${el}): Bundle
`;
var nl = { types: Jd, queries: Zd, mutations: tl };
const { gql: at } = e, { paginationParams: D, generateCollectionType: il } = r, rl = at`
  type Business {
    token: ID
    active: Boolean
    attester_name: String
    attestation_consent: Boolean
    attester_title: String
    attestation_date: String
    status: String
    business_name_legal: String
    business_name_dba: String
    notes(${D}): NoteCollection
    business_type: String
    notes_string: String
    ip_address: String
    password: String
    phone: String
    account_holder_group_token: String
    identifications: [Identification]
    office_location: Address
    in_current_location_since: String
    website: String
    date_established: String
    general_business_description: String
    history: String
    international_office_locations: String
    primary_contact: PrimaryContact
    duns_number: String
    taxpayer_id: String
    metadata: String
    incorporation: Incorporation
    proprietor_or_officer: ProprietorOrOfficer
    proprietor_is_beneficial_owner: Boolean
    created_time: String
    last_modified_time: String
    transitions(${D}): BusinessTransitionCollection
    direct_deposit_account: DirectDepositAccount
    kyc(${D}): KycCollection
    funding_sources(${D}): FundingSourceCollection
    funding_source_addresses(${D}): FundingSourceAddressCollection
    autoreloads(${D}): AutoReloadCollection
    transactions(
      ${D}
      type: String
      state: String
    ): TransactionCollection
    gpa_balance: GpaBalance
    msa_balance(${D}): MsaBalanceCollection
    audit_logs(${D}): AuditLogCollection
    children(${D}): CardholderCollection
    businessIdentityCheck: BusinessIdentityCheck
    beneficial_owner1: BeneficialOwner
    beneficial_owner2: BeneficialOwner
    beneficial_owner3: BeneficialOwner
    beneficial_owner4: BeneficialOwner
    kycBusiness(${D}): KycBusinessCollection
  }
  type BusinessRiskRating {
    risk_rating: String
  }

  ${il("Business")}
`, al = at`
  business(token: ID!): Business
  businesses(
    ${D},
    business_name_dba: String,
    business_name_legal: String,
  ): BusinessCollection
  businessRiskRating(token: ID!): BusinessRiskRating
  fullBusinessIdentificationNumber(
    token: ID!
    type: String!
    full_ssn: Boolean!
  ): FullIdentificationNumber
  fullBusinessIdentificationNumberGranular(
    token: ID!
    type: String!
    full_ssn: Boolean!
  ): FullIdentificationNumber
  businessWithUnmaskedIdentificationsGranular(
    token: ID!
    show_full_id: Boolean!
    beneficial_owner: String
  ): Business
   businessWithUnmaskedIdentifications(
    token: ID!
    show_full_id: Boolean!
    beneficial_owner: String
  ): Business
`, ol = at`
  updateBusiness(
    token: ID!
    attester_name: String
    attestation_consent: Boolean
    attester_title: String
    attestation_date: String
    business_name_legal: String
    business_name_dba: String
    office_location: AddressInput
    in_current_location_since: String
    phone: String
    website: String
    date_established: String
    general_business_description: String
    history: String
    account_holder_group_token: String
    ip_address: String
    notes: String
    business_type: String
    international_office_locations: String
    primary_contact: PrimaryContactInput
    duns_number: String
    incorporation: IncorporationInput
    proprietor_is_beneficial_owner: Boolean
    proprietor_or_officer: ProprietorOrOfficerInput
    metadata: String
    password: String
    identifications: [IdentificationInput]
    taxpayer_id: String 
    beneficial_owner1: ProprietorOrOfficerInput
    beneficial_owner2: ProprietorOrOfficerInput
    beneficial_owner3: ProprietorOrOfficerInput
    beneficial_owner4: ProprietorOrOfficerInput
  ): Business
  updateBusinessRiskRating(
    token: ID!
    risk_rating: String
  ) : BusinessRiskRating
`;
var sl = { types: rl, queries: al, mutations: ol };
const { gql: ot } = e, cl = ot`
  type BusinessIdentityCheck {
    cardholder_token: ID!
    kyb_token: String
    status: String
    attester_name: String
    attester_title: String
    attestation_date: String
    attestation_consent: String
    proprietor_is_beneficial_owner: String
    business: BusinessIdentityCheckBusiness
    proprietor: BusinessIdentityCheckIndividual
    beneficial_owner1: BusinessIdentityCheckIndividual
    beneficial_owner2: BusinessIdentityCheckIndividual
    beneficial_owner3: BusinessIdentityCheckIndividual
    beneficial_owner4: BusinessIdentityCheckIndividual
  }

  type BusinessIdentityCheckBusiness {
    name: BusinessIdentityResult
    address: BusinessIdentityResult
    address2: BusinessIdentityResult
    city: BusinessIdentityResult
    state: BusinessIdentityResult
    zip: BusinessIdentityResult
    country: BusinessIdentityResult
    ein: BusinessIdentityResult
    ofac: BusinessIdentityResult
    sanctions: BusinessIdentityResult
  }

  type BusinessIdentityCheckIndividual {
    first_name: BusinessIdentityResult
    middle_name: BusinessIdentityResult
    last_name: BusinessIdentityResult
    address: BusinessIdentityResult
    address2: BusinessIdentityResult
    city: BusinessIdentityResult
    state: BusinessIdentityResult
    zip: BusinessIdentityResult
    country: BusinessIdentityResult
    ssn: BusinessIdentityResult
    dob: BusinessIdentityResult
    ofac: BusinessIdentityResult
  }

  type BusinessIdentityResult {
    value: String
    status: String
    note: String
  }

  input UpdatedEntity {
    check_name: String
    check_type: String
    check_value: String
    check_status: String
    user_email: String
    note: String
  }
`, _l = ot`
  businessIdentityCheck(
    cardholder_token: ID!
  ): BusinessIdentityCheck
`, dl = ot`
  updateBusinessIdentityCheck(
    cardholder_token: ID!
    updatedEntities:[UpdatedEntity]
  ): String
`;
var ll = { types: cl, queries: _l, mutations: dl };
const { gql: vi } = e, { paginationParams: mv, generateCollectionType: ul } = r, gl = vi`
  type BusinessTransition implements AbstractTransition {
    token: ID!
    status: String
    reason_code: String
    reason: String
    channel: String
    created_time: String
    last_modified_time: String
    business_token: String
  }

  ${ul("BusinessTransition")}
`, pl = vi`
  createBusinessTransition(
    token: ID
    business_token: ID!
    status: String!
    reason_code: String!
    channel: String!
    reason: String
  ): BusinessTransition
`;
var ml = { types: gl, mutations: pl };
const { gql: st } = e, { paginationParams: V, generateCollectionType: Sl } = r, yl = st`
  type Card {
    activation_actions: CardActivationActions
    auth_controls: [AuthControl]
    barcode: String
    bulk_issuance_token: String
    card_product_token: String
    card_product: CardProduct
    cardholder_token: String
    cardholder: Cardholder
    chip_cvv_number: String
    created_time: String
    cvv_number: String
    digital_wallet_tokens(${V}): DigitalWalletTokenCollection
    exemptMids(${V}): ExemptMidCollection
    expedite: Boolean
    expiration_time: String
    expiration: String
    final_fulfillment: CardFulfillment
    fulfillment_status: String
    fulfillment: CardFulfillment
    instrument_type: String
    last_four: String
    last_modified_time: String
    metadata: String
    pan: String
    pin_is_set: Boolean
    reissue_pan_from_card_token: String
    state_reason: String
    state: String
    support_agent_cvv: String
    token: ID!
    transactions(${V}): TransactionCollection
    transitions(${V}): CardTransitionCollection
    translate_pin_from_card_token: String
    transmissions(${V}): TransmissionCollection
    velocity_controls: [VelocityControl]
  }

  type ControlToken {
    control_token: String!
  }

  input CardInput {
    cardholder_token: String!
    card_product_token: String!
  }

  input ExpirationOffsetInput {
    unit: String!
    value: Int!
  }

  ${Sl("Card")}
`, Cl = st`
  card(token: ID!
  ): Card
  cards(
    cardholder_token: ID
    sort_by: String
    count: Int
    start_index: Int
    limit: Int
  ): CardCollection
  showpan(
    token: ID!
    show_cvv_number: Boolean
  ): Card
  searchCardsByLastFour(
    last_four: String
    sort_by: String
    count: Int
    start_index: Int
    limit: Int
  ): CardCollection
  searchCardsByFullPan(
    pan: String
  ): Card
  cardByCardProduct(token: ID!
  ): Card
  cardsByCardProduct(
    cardholder_token: ID
    sort_by: String
    count: Int
    start_index: Int
    limit: Int
  ): CardCollection
  searchCardsByLastFourAndByCardProduct(
    last_four: String
    sort_by: String
    count: Int
    start_index: Int
    limit: Int
  ): CardCollection
  searchCardsByFullPanAndByCardProduct(
    pan: String
  ): Card
`, Tl = st`
  createCard(
    cardholder_token: ID!
    card_product_token: ID!
    expiration_offset: ExpirationOffsetInput
    new_pan_from_card_token: String
    reissue_pan_from_card_token: String
    fulfillment: CardFulfillmentInput
    expedite: Boolean
  ): Card
  manualCreateCard(
    cardholder_token: ID!
    card_product_token: ID!
    expiration_offset: ExpirationOffsetInput
    reissue_pan_from_card_token: String
    fulfillment: CardFulfillmentInput
    expedite: Boolean
  ): Card
  updateCard(
    token: ID!
    cardholder_token: String
    expedite: Boolean
    metadata: String
    fulfillment: CardFulfillmentInput
  ): Card
  createPinControlToken(
    card_token: ID!
  ): ControlToken
  createOrUpdatePin(
    card_token: ID!
    pin: String!
  ): String
  replaceCard(
    token: ID
    card_token: ID!
    state: String!
    reason_code: String!
    reason: String
    channel: String
    cardholder_token: ID!
    card_product_token: ID!
    reissue_pan_from_card_token: String
  ): Card
  reportCard(
    token: ID
    card_token: ID!
    state: String!
    reason_code: String!
    reason: String
    channel: String
    cardholder_token: ID!
    card_product_token: ID!
  ): Card
  lockCard(
    token: ID
    card_token: ID!
    state: String!
    reason_code: String!
    reason: String
    channel: String
  ): CardTransition
  terminateCard(
    token: ID
    card_token: ID!
    state: String!
    reason_code: String!
    channel: String
  ): CardTransition
  unlockCard(
    token: ID
    card_token: ID!
    state: String!
    reason_code: String!
    reason: String
    channel: String
  ): CardTransition
  activateCard(
    token: ID
    card_token: ID!
    state: String!
    reason_code: String!
    reason: String
    channel: String
    ): CardTransition
`;
var Il = { types: yl, queries: Cl, mutations: Tl };
const { gql: ct } = e, { paginationParams: fl, generateCollectionType: Dl } = r, Al = ct`
  type Shipping {
    method: String
    care_of_line: String
    return_address: Address
    recipient_address: Address
  }

  input ShippingInput {
    method: String
    care_of_line: String
    return_address: AddressInput
    recipient_address: AddressInput
  }

  type CardBulkIssuanceFulfillment {
    shipping: Shipping
    card_personalization: CardPersonalization
  }

  input CardBulkIssuanceFulfillmentInput {
    shipping: ShippingInput
    card_personalization: CardPersonalizationInput
  }

  type UserAssociation {
    single_inventory_user: Boolean
    single_inventory_user_token: String
  }

  input UserAssociationInput {
    single_inventory_user: Boolean
    single_inventory_user_token: String
  }

  type CardBulkIssuance {
    token: String
    expedite: Boolean
    fulfillment: CardBulkIssuanceFulfillment
    card_product_token: String
    card_allocation: Int
    cards_processed: Int
    user_association: UserAssociation
    name_line_1_numeric_postfix: Boolean
    expiration_offset: ExpirationOffset
    created_time: String
    name_line1_start_index: Int
    name_line1_end_index: Int
    card_fulfillment_time: String
    provider_ship_date: String
    provider_shipping_method: String
    provider_tracking_number: String
  }

  input CardBulkIssuanceInput {
    token: String
    expedite: Boolean
    fulfillment: CardBulkIssuanceFulfillmentInput
    card_product_token: String
    card_allocation: Int
    cards_processed: Int
    user_association: UserAssociationInput
    name_line_1_numeric_postfix: Boolean
    expiration_offset: ExpirationOffsetInput
    created_time: String
    name_line1_start_index: Int
    name_line1_end_index: Int
    card_fulfillment_time: String
    provider_ship_date: String
    provider_shipping_method: String
    provider_tracking_number: String
  }

  ${Dl("CardBulkIssuance")}
`, kl = ct`
  bulkissuance(token: String!): CardBulkIssuance
  bulkissuances(${fl}): CardBulkIssuanceCollection
`, hl = ct`
  createBulkissuance(
    bulkissuance: CardBulkIssuanceInput
  ): CardBulkIssuance
`;
var El = { types: Al, queries: kl, mutations: hl };
const { gql: _t } = e, { paginationParams: m, generateCollectionType: $l } = r, Pl = _t`
  type Cardholder {
    token: ID!
    active: Boolean
    notes_string: String
    ip_address: String
    password: String
    phone: String
    account_holder_group_token: String
    card_token: String
    identifications: [Identification]
    honorific: String
    title: String
    gender: String
    first_name: String
    middle_name: String
    last_name: String
    email: String
    address1: String
    address2: String
    city: String
    state: String
    country: String
    birth_date: String
    birth_place: String
    corporate_card_holder: Boolean
    nationality: String
    company: String
    parent: Cardholder
    uses_parent_account: Boolean
    parent_token: String
    business_token: String
    postal_code: String
    zip: String
    ssn: String
    passport_number: String
    passport_expiration_date: String
    id_card_number: String
    id_card_expiration_date: String
    status: String
    created_time: String
    last_modified_time: String
    metadata: String
    kycResults(${m}): KycUserResultCollection
    notes(${m}): NoteCollection
    cards(${m}): CardCollection
    transitions(${m}): CardholderTransitionCollection
    direct_deposit_account: DirectDepositAccount
    directDepositAccounts(
      user_token: ID,
      ${m},
    ): DirectDepositAccountCollection
    funding_sources(${m}): FundingSourceCollection
    funding_source_addresses(${m}): FundingSourceAddressCollection
    autoreloads(${m}): AutoReloadCollection
    transactions(${m}): TransactionCollection
    gpa_balance: GpaBalance
    msa_balance(${m}): MsaBalanceCollection
    velocity_controls(${m}): VelocityControlCollection
    auth_controls(${m}): AuthControlCollection
    audit_logs(${m}): AuditLogCollection
    exemptMids(${m}): ExemptMidCollection
    fullIdentificationNumber(
      type: String!
      full_ssn: Boolean!
    ): FullIdentificationNumber
  }
  
  type CardholderRiskRating {
    risk_rating: String
  }

  input CardholderInput {
    first_name: String
    last_name: String
    email: String
    notes: String
  }

  ${$l("Cardholder")}
`, vl = _t`
  cardholder(token: ID!): Cardholder
  cardholders(
    ${m},
    first_name: String,
    last_name: String,
    phone: String,
    email: String,
  ): CardholderCollection
  cardholdersLookup(
    ${m},
    first_name: String, 
    last_name: String, 
    email: String,
    phone: String,
    ssn: String,
    dda: String
  ): CardholderCollection  
  fullCardholderIdentificationNumber(
    token: ID!
    type: String!
    full_ssn: Boolean!
  ): FullIdentificationNumber
  userTransitions(token: String!, ${m}): CardholderTransitionCollection
  userNotes(token: String!, ${m}): NoteCollection
  userNotesGranular(token: String!, ${m}): NoteCollection
  cardholderByCardProduct(token: ID!): Cardholder
  cardholdersLookupByCardProduct(
    ${m},
    first_name: String, 
    last_name: String, 
    email: String,
    phone: String,
    ssn: String,
    dda: String
  ): CardholderCollection
  cardholderRiskRating(token: String!): CardholderRiskRating
`, Rl = _t`
  createCardholder(
    first_name: String
    last_name: String
    email: String
    notes: String
  ): Cardholder
  updateCardholder(
    token: ID!
    honorific: String
    title: String
    gender: String
    email: String
    address1: String
    address2: String
    city: String
    state: String
    postal_code: String
    country: String
    nationality: String
    notes: String
    phone: String
    middle_name: String
    first_name: String
    last_name: String
    birth_date: String
    birth_place: String
    parent_token: String
    ip_address: String
    corporate_card_holder: Boolean
    company: String
    account_holder_group_token: String
    passport_number: String
    passport_expiration_date: String
    id_card_number: String
    id_card_expiration_date: String
    identifications: [IdentificationInput]
    metadata: String
    ssn: String
  ): Cardholder
  updateCardholderIdentifications(
    token: ID!
    ssn: String
    passport_number: String
    passport_expiration_date: String
    id_card_number: String
    id_card_expiration_date: String
    identifications: [IdentificationInput]
  ): Cardholder 
  updateCardholderRiskRating(
    token: String!
    risk_rating: String
  ): CardholderRiskRating
`;
var bl = { types: Pl, queries: vl, mutations: Rl };
const { gql: Nl } = e, Bl = Nl`
  type CardholderAuthenticationData {
    acquirer_exemption: [String]
    authentication_method: String
    authentication_status: String
    electronic_commerce_indicator: String
    three_ds_message_version: String
    verification_result: String
    verification_value_created_by: String
  }
`;
var Ol = { types: Bl };
const { gql: Ri } = e, Fl = Ri`
  type CardholderChargebackHistory {
    amountOfChargebacksInitiatedByNetworkPast120Days: Float
    numberOfChargebacksInitiatedByNetworkPast120Days: Int
    amountOfChargebacksRejectedByNetworkPast120Days: Float
    numberOfChargebacksRejectedByNetworkPast120Days: Int
  }
`, wl = Ri`
getCardholderChargebackHistory(
  user_token: String
  card_token: String
  ): CardholderChargebackHistory
`;
var ql = { types: Fl, queries: wl };
const { gql: bi } = e, { paginationParams: Sv, generateCollectionType: Ml } = r, Ul = bi`
  type CardholderTransition implements AbstractTransition {
    token: ID!
    status: String
    reason_code: String
    reason: String
    channel: String
    created_time: String
    last_modified_time: String
    cardholder_token: String
  }
  ${Ml("CardholderTransition")}
`, Ll = bi`
  createCardholderTransition(
    token: ID
    cardholder_token: ID!
    status: String!
    reason_code: String!
    reason: String
    channel: String
  ): CardholderTransition
`;
var xl = { types: Ul, mutations: Ll };
const { gql: dt } = e, { paginationParams: Gl, generateCollectionType: Hl } = r, Vl = dt`
  type CardPackage {
    token: ID!
    active: Boolean
    package_id: String
    card_stock_sku: Sku
    label_sku: Sku
    carrier_sku: Sku
    envelope_sku: Sku
    created_time: String
    last_modified_time: String
  }

  ${Hl("CardPackage")}
`, Yl = dt`
  cardPackage(token: ID!): CardPackage
  cardPackages(
    ${Gl},
    token: ID,
    active: Boolean,
    card_stock_sku_token: String,
    carrier_sku_token: String,
    envelope_sku_token: String,
    label_sku_token: String,
    package_id: String,
    program: String,
    provider_name: String,
    provider_token: String,
  ): CardPackageCollection
`, Wl = dt`
  createCardPackage(
    card_stock_sku_token: String!,
    carrier_sku_token: String,
    envelope_sku_token: String,
    label_sku_token: String,
    package_id: String!,
    active: Boolean,
  ): CardPackage
  updateCardPackage(
    token: ID!,
    active: Boolean,
    card_stock_sku_token: String,
    carrier_sku_token: String,
    envelope_sku_token: String,
    label_sku_token: String,
    package_id: String,
  ): CardPackage
`;
var Kl = { types: Vl, queries: Yl, mutations: Wl };
const { gql: lt } = e, { paginationParams: ee, generateCollectionType: zl } = r, jl = lt`
  type CardProduct {
    token: ID!
    active: Boolean
    card_service_code: Int
    config: CardProductConfig
    created_time: String
    end_date: String
    last_modified_time: String
    name: String
    start_date: String
    update_expiration_upon_activation: Boolean
    auth_controls(${ee}): AuthControlCollection
    exempt_mids(${ee}): ExemptMidCollection
    velocity_controls(${ee}): VelocityControlCollection
  }

  type CardProductConfig {
    poi: CardProductConfigPoi
    transaction_controls: TransactionControls
    selective_auth: SelectiveAuth
    special: CardProductConfigSpecial
    card_life_cycle: CardLifeCycle
    clearing_and_settlement: ClearingAndSettlement
    jit_funding: CardProductConfigJitFunding
    digital_wallet_tokenization: DigitalWalletTokenization
    fulfillment: CardProductFulfillment
  }

  type CardProductConfigPoi {
    other: CardProductConfigPoiOther
    ecommerce: Boolean
    atm: Boolean
  }

  type CardProductConfigPoiOther {
    allow: Boolean
    card_presence_required: Boolean
    cardholder_presence_required: Boolean
  }

  type CardProductFulfillment {
    shipping: CardFulfillmentShipping
    card_personalization: CardPersonalization
    payment_instrument: String
    package_id: String
    all_zero_card_security_code: Boolean
    bin_prefix: String
    bins: BinCollection
    bulk_ship: Boolean
    pan_length: String
    fulfillment_provider: String
    allow_card_creation: Boolean
    uppercase_name_lines: Boolean
    enable_offline_pin: Boolean

  }

  type CardProductConfigSpecial {
    merchant_on_boarding: Boolean
  }

  type CardProductConfigJitFunding {
    paymentcard_funding_source: JitFundingSource
    programgateway_funding_source: JitFundingSource
    program_funding_source: JitFundingSource
    refunds_destination: String
  }

  type CardLifeCycle {
    activate_upon_issue: Boolean
    expiration_offset: ExpirationOffset
    card_service_code: Int
    update_expiration_upon_activation: Boolean
  }

  type ExpirationOffset {
    unit: String
    value: Int
    min_offset: ExpirationOffset
  }  

  ${zl("CardProduct")}
`, Ql = lt`
  cardProduct(token: ID!): CardProduct
  cardProducts(${ee}): CardProductCollection
`, Jl = lt`
  createCardProduct(
    name: String
    start_date: String
  ): CardProduct
`;
var Zl = { types: jl, queries: Ql, mutations: Jl };
const { gql: fe } = e, { paginationParams: Le, generateCollectionType: bn } = r, Ni = {
  inputFields: fe`
    account_number: String
    account_type: String # ["checking" | "savings" | "corporate" | "loan"]
    active: Boolean
    bank_name: String
    is_default_account: Boolean
    name_on_account: String
    routing_number: String
    cardholder_token: String
    business_token: String
    verification_override: Boolean  
  `
}, Xl = fe`
  type FundingSource implements AbstractFundingSource {
    account_number: String
    account_suffix: String
    account_type: String
    active: Boolean
    bank_name: String
    business: Business
    created_time: String
    date_sent_for_verification: String
    date_verified: String
    is_default_account: Boolean
    last_modified_time: String
    name_on_account: String
    routing_number: String
    token: ID!
    cardholder: Cardholder
    verification_notes: String
    verification_override: Boolean
    verification_status: String
    verify_amount1: Float
    verify_amount2: Float
    exp_date: String
    name: String
    type: String
  }
  
  type AchProgramFundingSource implements AbstractFundingSource {
    account_suffix: String
    account_type: String
    active: Boolean
    bank_name: String
    created_time: String
    date_sent_for_verification: String
    date_verified: String
    is_default_account: Boolean
    last_modified_time: String
    name_on_account: String
    token: ID!
    verification_notes: String
    verification_override: Boolean
    verification_status: String
  }

  input FundingSourceInput {
    ${Ni.inputFields}
  }

  ${bn("FundingSource")}
  ${bn("AchProgramFundingSource")}
`, eu = fe`
  fundingSources(${Le}): FundingSourceCollection
  achFundingSource(token: ID!): FundingSource
  achProgramFundingSource(token: ID!): AchProgramFundingSource
  achProgramFundingSources(
    ${Le}
    active: Boolean
  ): AchProgramFundingSourceCollection
  achProgramFundingSourcesGranular(
    ${Le}
    active: Boolean
  ): AchProgramFundingSourceCollection
  userFundingSources(
    cardholder_token: String
    type: String
    fields: String
  ): FundingSourceCollection
`, tu = fe`
  createAchFundingSource(
    account_number: String!
    account_type: String! # ["checking" | "savings" | "corporate" | "loan"]
    active: Boolean
    bank_name: String
    is_default_account: Boolean
    name_on_account: String!
    routing_number: String!
    cardholder_token: String
    business_token: String
    verification_override: Boolean
  ): FundingSource
  updateAchFundingSource(
    token: ID!
    active: Boolean
    verify_amount1: Float
    verify_amount2: Float
  ): FundingSource
`;
var Bi = { types: Xl, queries: eu, mutations: tu, templates: Ni };
const { gql: j } = e, { generateCollectionType: nu } = r, Oi = {
  inputFields: j`
    amount: Float
    cardholder_token: String
    currency_code: String
    funding_source_token: String!
    business_token: String
    fees: [FeeInput]
    memo: String
    tags: String
    token: ID
  `,
  childInputFields: j`
    amount: Float
    currency_code: String
    fees: [FeeInput]
    memo: String
    tags: String
    token: ID
  `
}, iu = j`
  type GpaOrder {
    amount: Float!
    business_token: String
    business: Business
    cardholder_token: String
    cardholder: Cardholder
    created_time: String
    currency_code: String!
    fees: [FeeWithMetadata]
    funding_source_address: FundingSourceAddress
    funding_source_token: String
    funding_source: FundingSource
    funding: Funding
    gateway_message: String
    gateway_token: Int
    jit_funding: JitFunding
    last_modified_time: String
    memo: String
    response: Response
    state: String
    tags: String
    token: ID!
    transaction: Transaction
    transaction_token: String
    user_token: String
  }

  input GpaOrderInput {
    ${Oi.inputFields}
  }

  ${nu("GpaOrder")}

  input FeeInput {
    memo: String
    tags: String
    token: String
  }
`, ru = j`
  gpaOrder(token: ID!): GpaOrder
`, au = j`
  createGpaOrder(
    amount: Float!
    cardholder_token: String
    currency_code: String!
    funding_source_token: String!
    business_token: String
    fees: [FeeInput]
    memo: String
    tags: String
    token: ID
  ): GpaOrder
  createGpaUnload(
    amount: Float!
    funding_source_address_token: String
    memo: String
    original_order_token: String!
    tags: String
    token: ID
  ): GpaOrder
`;
var Fi = { types: iu, queries: ru, mutations: au, templates: Oi };
const ou = Bi.templates, su = Fi.templates, { gql: wi } = e, cu = wi`
  type FundingSourceParentMutation {
    account_number: String
    account_type: String
    name_on_account: String
    routing_number: String
    gpa_order(${su.childInputFields}): GpaOrder
  }

  type CardholderParentMutation {
    token: ID
    first_name: String
    last_name: String
    existing_cardholder_token: ID
    active_funding_source(${ou.inputFields}): FundingSourceParentMutation
    funding_sources(fundingSources: [FundingSourceInput!]): [FundingSource]
    auth_controls(authControls: [AuthControlInput!]): [AuthControl]
    velocity_controls(velocityControls: [VelocityControlInput!]): [VelocityControl]
  }

  type CardResourceCreation {
    cardholder(
      first_name: String
      last_name: String
      existing_cardholder_token: ID
      parent_token: ID
      token: ID
    ): CardholderParentMutation
  }
`, _u = wi`
  createCardResources: CardResourceCreation
`;
var du = { types: cu, mutations: _u };
const { gql: qi } = e, { paginationParams: yv, generateCollectionType: lu } = r, uu = qi`
  type CardTransition implements AbstractTransition {
    token: ID!
    card_token: String
    cardholder_token: String
    state: String
    reason: String
    reason_code: String
    channel: String
    fulfillment_status: String
    validations: Validation
    type: String
    created_time: String
    last_modified_time: String
    card_product_token: String
    last_four: String
    pan: String
    expiration: String
    expiration_time: String
    barcode: String
    pin_is_set: Boolean
    fulfillment: CardFulfillment
    bulk_issuance_token: String
    reissue_pan_from_card_token: String
    cardholder: Cardholder
    card: Card
    expedite: Boolean
  }
  type CardsTransition {
    status: String
    error_message: String
    error_code: String
    value: CardTransition
  }
  ${lu("CardTransition")}
`, gu = qi`
  createCardTransition(
    token: ID
    card_token: ID!
    state: String!
    reason_code: String!
    reason: String
    channel: String
  ): CardTransition

  createCardsTransition(
    card_tokens: [ID],
    state: String!
    reason_code: String!
    reason: String
    channel: String
  ): [CardsTransition]
`;
var pu = { types: uu, mutations: gu };
const { gql: ut } = e, { paginationParams: Nn, generateCollectionType: Z } = r, mu = ut`
  type Case {
    # String type for flexibility; reference enum CASE_ACTION
    action: String
    assignee: String
    associated_transactions: AssociatedTransactionCollection
    business_token: String
    business: Business
    cardholder_token: String
    cardholder: Cardholder
    chargeback: Chargeback
    created_time: String
    dispute_details: DisputeDetails
    dispute_transitions: DisputeTransitionCollection
    documents: CaseDocumentCollection
    folder_access_token: String
    folder_id: String
    folder_shared_link: String
    kyc_details: KycDetails
    kyc: Kyc
    last_modified_time: String
    memo: String
    network_comment: String
    milestones: MilestoneCollection
    network_case_status_details: NetworkCaseStatusDetails
    program_short_code: String
    reinstate_details: ReinstateDetails
    serviceIntegrations: ServiceIntegrations
    # String type for simplicity; reference enum CASE_STATE
    state: String
    token: ID!
    transaction: Transaction
    transitions: CaseTransitionCollection
    type: String
    type_change_time: String
    user_token: String
    zendesk_ticket_id: String
  }

  type CaseAction {
    case_token: String
    action_type: String
    created_by: String
  }

  type CaseEvent {
    category: String
    case_token: ID
    token: ID
    created_by: String
    event_date: String
    name: String
    created_time: String
  }

  type CaseNote {
    token: ID
    createdBy: String
    content: String
    created_time: String
  }

  type ServiceIntegrations {
    VISA: ServiceIntegration
    MASTERCARD: ServiceIntegration
    PULSE: ServiceIntegration
  }

  type ServiceIntegration {
    dispute_reasons: [String]
    transaction_types: [String]
  }

  type DisputeDetails {
    additional_dispute_details: AdditionalDisputeDetails
    associated_transaction_selection_required: Boolean
    card_token: String
    cardholder_contact_date: String
    chargeback: Chargeback
    chargeback_token: String
    consumer_dispute_type_dispute_details: ConsumerDisputeTypeDisputeDetails
    currency_code: String
    dispute_amount: Float
    dispute_amount_change_reason: DISPUTE_AMOUNT_CHANGE_REASON
    # String type for simplicity; reference enum DISPUTE_REASON
    dispute_reason: String
    dispute_reason_code: String
    dispute_state: String
    fraud_dispute_type_details: FraudDisputeDetails
    fraud_category_type_dispute_details: FraudCategoryDetails
    fraud_classification_type_dispute_details: FraudClassificationTypeDisputeDetails
    network: String
    network_case_number: String
    network_case_status_details: NetworkCaseStatusDetails
    network_failure_response: String
    original_transaction_token: String
    account_status: String
    original_transaction_type: String
    partial_dispute_resolution: PartialDisputeResolutionDetails
    processing_error_type_dispute_details: ProcessingErrorTypeDisputeDetails
    provisional_credit_granted: Boolean
    regulation_details: RegulationDetails
    regulation_type: String
    transaction: Transaction
  }

  type FraudDisputeDetails {
    general_fraud_type_dispute_details: GeneralFraudDisputeDetails
  }

  type GeneralFraudDisputeDetails {
    chip_on_card: Boolean
  }

  type FraudCategoryDetails {
    fraud_type: String
  }
  
  type FraudClassificationTypeDisputeDetails {
    fraud_type_classification: String
  }

  type PartialDisputeResolutionDetails {
    final_resolution_type: String
    final_cardholder_resolution_amount: Float
    amount_reversed: Float
  }

  type AdditionalDisputeDetails {
    explanation_of_credit: String
    regulation_subcategory: String
    exception_reason_apply: Boolean
    regulation_conditions_met_date: String
    reject_reason: String
  }

  type NetworkCaseStatusDetails {
    allowable_actions: [String]
    network: String
    network_case_number: String
    case_status: String
    current_case_amount: String
    # String type for flexibility: reference enum NEXT_ACTOR
    next_actor: String
    days_to_act: Int
    last_action_date: String
    case_opened_date: String
    last_refresh_date: String
    created_time: String
    last_modified_time: String
  }

  type RegulationDetails {
    pc_grant_days_to_act: Int
    pc_perm_days_to_act: Int
    pc_reversed_coms_days_to_act: Int
    pc_reversed_days_to_act: Int
    holidays: [HolidayDetails]
    on_board_date: String
  }

  type HolidayDetails {
    name: String
    start_date: String
  }

  type ATRSubmission {
    updateCase: Case
    createAssociatedTransactionsSelection: [AssociatedTransaction]
    updateAssociatedTransactionsSelection: [AssociatedTransaction]
    createCaseTransition: CaseTransition
  }

  type Milestone {
    case_token: String
    category: String
    sub_category: String
    milestone: String
    next_milestone_due_date: String
    created_time: String
    last_modified_time: String
  }

  input DisputeDetailsInput {
    additional_dispute_details: AdditionalDisputeDetailsInput
    cardholder_contact_date: String
    consumer_dispute_type_dispute_details: ConsumerDisputeTypeDisputeDetailsInput
    dispute_amount: Float
    dispute_amount_change_reason: String
    dispute_reason: String
    dispute_reason_code: String
    fraud_dispute_type_details: FraudDisputeDetailsInput
    fraud_category_type_dispute_details: FraudCategoryDetailsInput
    fraud_classification_type_dispute_details: FraudClassificationTypeDisputeDetailsInput
    memo: String
    network_case_number: String
    original_transaction_token: String
    account_status: String
    processing_error_type_dispute_details: ProcessingErrorTypeDisputeDetailsInput
  }

  input FraudDisputeDetailsInput {
    general_fraud_type_dispute_details: GeneralFraudDisputeDetailsInput
  }

  input GeneralFraudDisputeDetailsInput {
    chip_on_card: Boolean
  }

  input FraudCategoryDetailsInput {
    fraud_type: String
  }
  
  input FraudClassificationTypeDisputeDetailsInput {
    fraud_type_classification: String
  }

  input AdditionalDisputeDetailsInput {
    explanation_of_credit: String
    regulation_subcategory: String
    exception_reason_apply: Boolean
    regulation_conditions_met_date: String
  }

  input UpdateAndAssignInput {
    assignee: String
    created_by: String
    dispute_details: DisputeDetailsInput
    memo: String
    replace_questionnaire: Boolean
    token: ID!
    type: String
  }

  ${Z("Case")}
  ${Z("CaseEvent")}
  ${Z("Milestone")}
  ${Z("CaseNote")}
`, Su = ut`
  case(
    token: ID!
    create_access_token: Boolean
    create_shared_link: Boolean
    expand: String
  ): Case
  cases(
    ${Nn}
    assignee: String
    business_token: ID
    cardholder_token: ID
    chargeback_token: ID
    dispute_amount: String
    expand: String
    # DISPUTE_STATE; if multiple, joined by ",".
    dispute_state: String
    kyc_token: ID
    next_actor: NEXT_ACTOR
    original_transaction_token: ID
    reason: String
    # CASE_STATE; if multiple, joined by ",".
    state: String
    type: String
    network_case_number: String
    acquirer_ref_nbr: String
  ): CaseCollection
  events(case_token: ID!): CaseEventCollection
  milestones(case_token: ID!): MilestoneCollection
  networkCaseStatusDetails(case_token: ID!): NetworkCaseStatusDetails
  bulkDisputeTemplateLink: String
  fraudTemplateLink: String
  associated_transactions(case_token: ID!): AssociatedTransactionCollection
  serviceIntegrations: ServiceIntegrations
  caseNotes(case_token: String! ${Nn}): CaseNoteCollection
`, yu = ut`
  createCase(
    token: ID
    type: String
    dispute_details: DisputeDetailsInput
    memo: String
    network_comment: String
    replace_questionnaire: Boolean
  ): Case
  createAndAssignCase(
    token: ID
    type: String
    assignee: String
    created_by: String
    dispute_details: DisputeDetailsInput
    memo: String
    network_comment: String
    replace_questionnaire: Boolean
    zendesk_ticket_id: ID
  ): Case
  createCaseAction(
    case_token: ID!
    action_type: String
    created_by: String!
  ): CaseAction
  createCaseEvent(
    case_token: ID!
    name: String!
    event_date: String
    created_by: String!
  ): CaseEvent
  createAndWithdrawCase(
    dispute_details: DisputeDetailsInput
    memo: String
    type: String
  ): Case
  updateCase(
    dispute_details: DisputeDetailsInput
    memo: String
    replace_questionnaire: Boolean
    token: ID!
    type: String
    zendesk_ticket_id: String
  ): Case
  updateAndAssignCase(
    token: ID!
    type: String
    assignee: String
    created_by: String
    dispute_details: DisputeDetailsInput
    memo: String
    replace_questionnaire: Boolean
  ): Case
  submitATRAndTransition(
    updateCase: UpdateAndAssignInput
    createAssociatedTransactionsSelection: ATRSubmissionInput
    updateAssociatedTransactionsSelection: ATRSubmissionInput
    createCaseTransition: CaseTransitionInput!
  ): ATRSubmission
  submitATR(
    createAssociatedTransactionsSelection: ATRSubmissionInput
    updateAssociatedTransactionsSelection: ATRSubmissionInput
  ): ATRSubmission
  addCaseNote(
    case_token: String!
    created_by: String!
    content: String
  ): CaseNote
`;
var Cu = { types: mu, queries: Su, mutations: yu };
const { gql: Mi } = e, Tu = Mi`
  type CaseConfigCountryTemplates {
    type: String
    token: String
    name: String
    description: String
    created_time: String
    last_modified_time: String
    details: ConfigHolidayTemplatesDetails
  }
  
  type ConfigHolidayTemplatesDetails {
    values: ConfigTemplatesDetailsValue
    template_criteria: ConfigTemplateCriteria
  }
  
    type ConfigTemplatesDetailsValue {
    version: Int,
    holidays: [Holiday],
    created_time: String                    
    }

    type Holiday {
        name: String
        start_date: String
    }
  
    type ConfigTemplateCriteria {
    criterion_token: String
    country_code: String
    created_time: String
    }
`, Iu = Mi`
  getConfigCountryTemplateByToken(
    token: ID!
  ): CaseConfigCountryTemplates
`;
var fu = { types: Tu, queries: Iu };
const { gql: Ui } = e, { generateCollectionType: Du } = r, Au = Ui`
  type CaseConfigTemplates {
    type: String
    token: String
    name: String
    description: String
    created_time: String
    last_modified_time: String
    details: ConfigTemplatesDetails
  }
  
  type ConfigTemplatesDetails {
    values: [ConfigTemplatesDetailsValues]
    filter_constraints: [ConfigTemplatesDetailsFilterConstraints]
    template_criteria: [ProgramConfigTemplateCriteria]
  }
  
  type ConfigTemplatesDetailsValues {
    pc_grant_days_to_act: Int 
    pc_perm_days_to_act: Int
    pc_reversed_coms_days_to_act: Int
    pc_reversed_days_to_act: Int
    created_time: String                    
}
  
  type ConfigTemplatesDetailsFilterConstraints {
    version: Int
    created_time: String
  }
  
  ${Du("CaseConfigTemplates")}
`, ku = Ui`
  getConfigTemplateByToken(
    token: ID!
  ): CaseConfigTemplates
  
  caseConfigTemplates(
    include_version_action: String 
    include_associations: Boolean 
    template_tokens: String
    template_names: String
    count: Int
  ): CaseConfigTemplatesCollection
`;
var hu = { types: Au, queries: ku };
const { gql: gt } = e, { paginationParams: Eu, generateCollectionType: $u } = r, Pu = gt`
  type CaseDocument {
    token: ID
    case_token: ID!
    # See enum DOCUMENT_CATEGORY for full list
    document_category: String
    document_name: String
    document_content_type: String
    network_process_type: String
    # One of the following: INITIATED | REPRESENTMENT | PRE_ARBITRATION
    network_process_phase: String
    network_process_time: String
    created_time: String
    last_modified_time: String
    download_link: String
  }

  type CaseDocumentDeleteResponse {
    status: String
  }

  type RetrieveCaseDocumentsResponse {
    status: String
  }

  ${$u("CaseDocument")}
`, vu = gt`
  caseDocuments(
    case_token: ID!
    ${Eu}
  ): CaseDocumentCollection

  caseDocumentDetail(
    case_token: ID!
    content_token: ID!
  ): CaseDocument
`, Ru = gt`
    createCaseDocument(
      case_token: ID!
      document_category: String!
      file: FileInput
      token: ID
    ): CaseDocument

    deleteCaseDocument(
      document_token: ID!
      case_token: ID!
    ): CaseDocumentDeleteResponse

    updateCaseDocument(
      case_token: ID!
      document_category: String
      document_name: String
      document_token: ID!
    ): CaseDocument

    retrieveCaseDocuments(
      case_token: ID!
    ): RetrieveCaseDocumentsResponse
`;
var bu = { types: Pu, queries: vu, mutations: Ru };
const { gql: Nu } = e, Bu = Nu`
  enum DOCUMENT_CATEGORY {
    CARDHOLDER_LETTER
    MERCHANT_LETTER
    SALES_DRAFT
    CREDIT_VOUCHER
    BANK_STATEMENT
    CANCELLED_CHECK
    SECOND_OPTION
    FULFILLMENT
    AUTHORIZATION_RECORD
    NETWORK_DOCUMENT
    UPDATED_CARDHOLDER_LETTER
    UPDATED_MERCHANT_LETTER
    AFFIDAVIT_FRAUD
    OTHERS
    NETWORK_EXHIBIT
    ISSUER_CERTIFICATION
    RECEIPT
    CUSTOMER_COMMUNICATION
    CUSTOMER_SIGNATURE
    CUSTOMER_DL
    CUSTOMER_SSN
    CUSTOMER_PASSPORT
    UTILITY_BILL
    DISPUTE_FORM
    TAX_DOCUMENTS
    INCORPORATION_CERTIFICATE
    LEASE_AGREEMENT
  }
`;
var Ou = { types: Bu };
const { gql: Fu } = e, wu = Fu`
  # Source of truth for Case Mgmt Service enums:
  # https://github.marqeta.com/marqeta/case-management-service/tree/master/src/main/java/com/marqeta/casemanagement/enums

  enum DISPUTE_AMOUNT_CHANGE_REASON {
    MERCHANT_ISSUED_PARTIAL_REFUND
    NOT_AS_DESCRIBED_PARTIAL
    NOT_AUTHORIZED_FOR_FULL_AMOUNT
    PARTIAL_DISPUTE
    PARTIAL_SERVICE
    PRORATED_REFUND
  }

  enum DISPUTE_REASON {
    ACCOUNT_NUMBER_NOT_ON_FILE
    AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM
    CANCELLED_MERCHANDISE_OR_SERVICES
    CANCELLED_RECURRING_TRANSACTION
    CARDHOLDER_DISPUTE
    CARDHOLDER_DISPUTE_US_ONLY
    CHIP_LIABILITY_SHIFT
    CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN
    CHIP_READ_POS_LATE_PRESENTMENT
    CREDIT_NOT_PROCESSED
    DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE
    EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD
    EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD
    FRAUD_MULTIPLE_TRANSACTIONS
    FRAUD_TRANSACTION
    FRAUD_REPORT
    INCORRECT_ACCOUNT_NUMBER
    INCORRECT_CURRENCY
    INCORRECT_CURRENCY_OR_TRANSACTION_CODE
    INCORRECT_TRANSACTION_AMOUNT
    INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER
    INCORRECT_TRANSACTION_CODE
    INSTALLMENT_BILLING_DISPUTE
    LATE_PRESENTMENT
    NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM
    NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE
    NOT_AUTHORIZED_CARD_ABSENT
    NOT_AUTHORIZED_CARD_PRESENT
    NO_AUTHORIZATION
    NO_SHOW_ADDENDUM_OR_ATM_DISPUTE
    OTHER_DISPUTES
    OTHER_MAESTRO_DISPUTES
    OTHER_PULSE_DISPUTES
    POINT_OF_INTERACTION_ERRORS
    QUESTIONABLE_MERCHANT_ACTIVITY
    SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED
    TRANSACTION_NOT_RECOGNIZED
    WARNING_BULLETIN_FILE
  }

  enum CASE_STATE {
    CHARGEBACK_INITIATED
    CLOSED
    NONE
    OPEN
    OPEN_WITH_ACTION_REQUIRED
    READY
    PENDING_CLOSE
  }

  enum CASE_ACTION {
    ASSIGN
    CHARGEBACK_CREDIT
    CHARGEBACK_SUBMIT
    CHARGEBACK_NO_CREDIT
    CLOSE
    CREATE
    DOCUMENTS_DELETED
    KYC_OVERRIDE
    NON_CHARGEBACK_CREDIT
    REINSTATE_BUSINESS
    REINSTATE_USER
    REVIEW
    RE_OPEN
    WITHDRAW_AND_CLOSE
  }

  enum DISPUTE_TRANSITION_ACTION {
    ACCEPT_AND_CLOSE
    ADJUSTMENT
    ALLOCATION_ACKNOWLEDGED
    ARB_ACCEPTED
    ARB_DECLINED
    CLOSE_WITH_NETWORK_REJECTED
    PREARB_ACCEPTED
    CLOSE_WITH_CASE_WON
    PREARB_DECLINED
    PREARB_RECEIVED
    PREARB_RESPONSE_DECLINED
    REPRESENTMENT_RECEIVED
    RESPOND_WITH_ARB
    RESPOND_WITH_PREARB
    RESPOND_WITH_PREARB_RESPONSE
    SUBMIT
    WAIT
  }

  enum NEXT_ACTOR {
    ACQUIRER
    DISPUTE_COMPLETED
    ISSUER
    UNKNOWN
  }

  enum PREARBITRATION_RESPONSE_DECISION {
    ACCEPT_PARTIAL
    DECLINE
  }

  enum CASE_TYPE {
    DISPUTE
    LEGACY_DISPUTE
  }
`;
var qu = { types: wu };
const { gql: pt } = e, { generateCollectionType: Mu } = r, Uu = pt`
  type CaseProgramConfigs {
    type: String
    token: String
    program_code: String
    template_token: String
    template_name: String
    template_version: Int
    enabled: Boolean
    lock_version: Boolean
    change_reference: String
    created_time: String
    last_modified_time: String
    template_values: RegulationDetails
    filter_constraint: ProgramConfigFilterConstraint
    template_criteria: ProgramConfigTemplateCriteria
  }

  type ProgramConfigFilterConstraint {
    category: String
    values: FilterConstraintValues
  }

  type FilterConstraintValues {
    min_days: Int
    max_days: Int
  }

  type ProgramConfigTemplateCriteria {
    dispute_reason: String
    country_code: String
    transaction_type: String
    created_time: String
  }
  
  type UpdateProgramConfigsResponse {
     program_code: String
     program_configs: [CaseProgramConfigs]
  }
  
  input UpdateProgramConfig {
    operation: String
    change_reference: String
    details: Program_Configs
  }
  
  input Program_Configs {
    program_configs: [ProgramConfig]
  }
  
  input ProgramConfig {
    token: String
    enabled: Boolean
    lock_version: String
    version_number: String
  }
  
  input UpdateProgramConfigTemplateAssociation {
      type: String
      change_reference: String
      details: TemplateAssociationDetails
  }
  
  input TemplateAssociationDetails {
    template_association: TemplateAssociation
    template_associations: [TemplateAssociationConfigTemplate]

  }

  input TemplateAssociation {
      template_token: String
      country_code: String
      lock_version: Boolean
      version_number: Int
      enabled: Boolean
  }

  input TemplateAssociationConfigTemplate {
      template_token: String
      dispute_reason: String
      country_code: String
      lock_version: Boolean
      version_number: Int
      enabled: Boolean
  }
  input UpdateProgramConfigTemplateGroup {
      type: String
      change_reference: String
      details: TemplateGroupDetails
  }
  
  input TemplateGroupDetails {
    template_group: TemplateGroup
  }
  input TemplateGroup {
      template_token: String
      lock_latest_version: Boolean
      enabled: Boolean
  }
  
  ${Mu("CaseProgramConfigs")}
`, Lu = pt`
  caseProgramConfigs(
    count: Int
  ): CaseProgramConfigsCollection
`, xu = pt`
  updateCaseProgramConfigs(
    payload: UpdateProgramConfig
  ): UpdateProgramConfigsResponse
  updateCaseProgramConfigTemplateAssociation(
    payload: UpdateProgramConfigTemplateAssociation
  ): UpdateProgramConfigsResponse
  updateCaseProgramConfigTemplateGroup(
    payload: UpdateProgramConfigTemplateGroup
  ): UpdateProgramConfigsResponse
`;
var Gu = { types: Uu, queries: Lu, mutations: xu };
const { gql: Li } = e, { generateCollectionType: Hu } = r, Vu = Li`
  type CaseTemplateGroups {
    type: String
    token: String
    name: String
    description: String
    created_time: String
    last_modified_time: String
    details: Details
  }
  type TemplateAssociations {
    template_token: String
    template_name: String
    dispute_reason: String
    country_code: String
  }  
  type Details {
    template_associations: [TemplateAssociations]
  }

  ${Hu("CaseTemplateGroups")}
`, Yu = Li`
  getTemplateGroupByToken(
    token: String
  ):CaseTemplateGroups
  caseTemplateGroups(
    count: Int
  ): CaseTemplateGroupsCollection
`;
var Wu = { types: Vu, queries: Yu };
const { gql: mt } = e, { paginationParams: Cv, generateCollectionType: Ku } = r, zu = mt`
  type CaseTransition {
    token: ID!
    case_token: ID!
    action: String
    reason_code: String
    created_by: String
    memo: String
    assignee: String
    reason_description: String
    failure_reason: String
    # String type for flexibility; reference enum CASE_STATE
    state: String
    transition_details: TransitionDetails
    created_date: String
  }

  type TransitionDetails {
    review_details: TransitionReviewDetails
    chargeback_details: TransitionChargebackDetails
  }

  type TransitionReviewDetails {
    attached_contents: [ID]
  }

  type TransitionChargebackDetails {
    attached_contents: [ID]
  }

  input CaseTransitionInput {
    token: ID
    case_token: ID!
    # String type for flexibility; reference enum CASE_ACTION
    action: String!
    reason_code: String!
    memo: String
    created_by: String
    created_date: String
    transition_details: TransitionDetailsInput
  }

  input TransitionDetailsInput {
    review_details: ReviewDetailsInput
    chargeback_details: ChargebackDetailsInput
  }

  input ReviewDetailsInput {
    attached_contents: [ID]
  }

  input ChargebackDetailsInput {
    attached_contents: [ID]
  }

  ${Ku("CaseTransition")}
`, ju = mt`
  caseTransitions(case_token: ID!): CaseTransitionCollection
`, Qu = mt`
  createCaseTransition(
    # String type for flexibility; reference enum CASE_ACTION
    action: String!
    case_token: ID!
    created_by: String
    memo: String
    reason_code: String!
    token: ID
    transition_details: TransitionDetailsInput
    created_date: String
  ): CaseTransition
`;
var Ju = { types: zu, queries: ju, mutations: Qu };
const { gql: St } = e, { paginationParams: Zu, generateCollectionType: Xu } = r, eg = St`
  type CFPersistCard {
    id: String
    card_token: String
    card_state: String
    provider_order_failure_description: String
    card_fulfillment_failure_description: String
    order_confirmation_status: String
    shipment_confirmation_status: String
    provider_name: String
    input_file_name: String
    program: String
    card_product_token: String
    bulk_order_token: String
    care_of_line: String
    should_expedite: Boolean
    is_chip_card: Boolean
    denomination: String
    barcode: String
    rejected_transition_idempotency_key: String
    shipped_transition_idempotency_key: String
    ordered_transition_idempotency_key: String
    file_metadata_id: Int
    shipment_confirmation_file_metadata_id: Int
    order_confirmation_file_metadata_id: Int
    ship_date: String
    shipping_method: String
    tracking_number: String
    card_reference_id: String
    created_time: String
    last_modified_time: String
    cfPersistFileMetadata: CFPersistFileMetadata
  }
  ${Xu("CFPersistCard")}
`, tg = St`
  cfPersistCards(
    card_token: String
    file_metadata_id: Int
    card_state: String,
    program: String
    provider_order_failure_description: String
    card_fulfillment_failure_description: String
    order_confirmation_status: String,
    shipment_confirmation_status: String
    ship_date: String
    tracking_number: String
    shipping_method: String
    provider_name: String
    card_reference_id: String
    card_product_token: String
    sort_by: String
    start_date: String
    end_date: String
    count: Int
    start_index: Int
    ${Zu}
  ): CFPersistCardCollection
`, ng = St``;
var ig = { types: eg, queries: tg, mutations: ng };
const { gql: yt } = e, rg = yt`
  type CFPersistFileMetadata {
    id: ID!
    num_processed_cards: Int
    num_terminated_cards: Int
    num_unsupported_cards: Int
    encrypted_file_s3_url: String
    scrubbed_file_s3_url: String
    provider_name: String
    sftp_host: String
    sftp_host_secondary: String
    created_time: String
    last_modified_time: String
  }
`, ag = yt`
  cfPersistFileMetadata(id: ID): CFPersistFileMetadata
`, og = yt``;
var sg = { types: rg, queries: ag, mutations: og };
const { gql: xi } = e, { generateCollectionType: cg, paginationParams: _g } = r, dg = xi`
  type Chargeback {
    token: ID!
    transaction_token: ID
    transaction: Transaction
    amount: Float
    reason_description: String
    reason_code: String
    memo: String
    state: String
    channel: String
    network: String
    network_case_id: String
    credit_user: Boolean
    created_time: String
    last_modified_time: String
  }

  ${cg("Chargeback")}
`, lg = xi`
  chargeback(token: ID!): Chargeback
  chargebacks(
    ${_g}
    network_reference_id: String
    network_case_id: String
    transaction_token: ID
    amount: String
    states: String
  ): ChargebackCollection
  chargebackTransitions(token: ID!): ChargebackCollection
`;
var ug = { types: dg, queries: lg };
const { gql: Gi } = e, { generateCollectionType: gg, paginationParams: pg } = r, mg = Gi`
  type CommandoMode {
    token: ID!
    program_gateway_funding_source: ProgramGatewayFundingSource
    enabled: Boolean
    enabled_reason: String
    enabled_channel: String
    enabled_username: String
    program_funding_source: ProgramFundingSource
    ignore_card_suspended_state: Boolean
    velocity_controls: [VelocityControl]
    auth_controls: [AuthControl]
    real_time_standin_enabled: Boolean
    real_time_standin_include_connection_errors: Boolean
    real_time_standin_inclue_response_timeouts: Boolean
    real_time_standin_include_application_errors: Boolean
    created_time: String
    last_modified_time: String
    transitions(${pg}): CommandoModeTransitionCollection
  }

  ${gg("CommandoMode")}
`, Sg = Gi`
  commandoMode(token: ID!): CommandoMode
  commandoModes: CommandoModeCollection
`;
var yg = { types: mg, queries: Sg };
const { gql: Ct } = e, { generateCollectionType: Cg, paginationParams: Tg } = r, Ig = Ct`
  type CommandoModeTransition {
    token: ID!
    type: String
    commando_mode_token: String
    enabled: Boolean
    enabled_reason: String
    enabled_channel: String
    enabled_username: String
    created_time: String
    name: String
  }

  ${Cg("CommandoModeTransition")}
`, fg = Ct`
  commandoModeTransitions(${Tg}, token: ID!): CommandoModeTransitionCollection
`, Dg = Ct`
  transitionCommandoMode(
    token: ID!
    commando_enabled: Boolean
    reason: String
    username: String
  ): CommandoModeTransition
`;
var Ag = { types: Ig, queries: fg, mutations: Dg };
const { gql: Hi } = e, kg = Hi`
  type AccountConfig {
    account_service: AccountService
    bip: Bip
    white_label_app: WhiteLabelApp
  }

  type Bip {
    bip_business_provisioning_enabled: Value
    bip_user_provisioning_enabled: Value
  }

  type WhiteLabelAppEnabled {
    app_enabled: Value
    facade_enabled: Value
  }
  
  type AccountService {
      multi_account_enabled: Value
  }

  type WhiteLabelApp {
    virtual_card_product_token: StringValue
    enabled: WhiteLabelAppEnabled
    rewards_funding_source_token: StringValue
    disbursement_funding_source_token: StringValue
    physical_card_product_token: StringValue
  }
      
  type Value {
      value: Boolean
  }

  type StringValue {
      value: String
  }
  
  type ConfigStore {
    config: AccountConfig
    created_by: String
    created_time: String
    customer_token: String
    entity_status: String
    last_modified_by: String
    last_modified_time: String
    long_code: String
    short_code: String
    name: String
    token: ID
    }
`, hg = Hi`
  configStore: ConfigStore
`;
var Eg = { types: kg, queries: hg };
const { gql: $g } = e, Pg = $g`
  type ConsumerDisputeTypeDisputeDetails {
    service_not_provided_merchandise_not_received_details: ServiceNotProvidedMerchandiseNotReceivedDetails
    cancelled_recurring_transaction_details: CancelledRecurringTransactionDetails
    not_as_described_or_defective_merchandise_details: NotAsDecribedOrDefectiveMerchandiseDetails
    credit_not_processed_details: CreditNotProcessedDetails
    cancelled_merchandise_or_services_details: CancelledMerchandiseOrServicesDetails
    counterfeit_merch_details: CounterfeitMerchDetails
    misrepresentation_details: MisrepresentationDetails  
    original_credit_not_accepted_details: OriginalCreditNotAcceptedDetails
  }

  input ConsumerDisputeTypeDisputeDetailsInput {
    service_not_provided_merchandise_not_received_details: ServiceNotProvidedMerchandiseNotReceivedDetailsInput
    cancelled_recurring_transaction_details: CancelledRecurringTransactionDetailsInput
    not_as_described_or_defective_merchandise_details: NotAsDecribedOrDefectiveMerchandiseDetailsInput
    credit_not_processed_details: CreditNotProcessedDetailsInput
    cancelled_merchandise_or_services_details: CancelledMerchandiseOrServicesDetailsInput
    counterfeit_merch_details: CounterfeitMerchDetailsInput
    misrepresentation_details: MisrepresentationDetailsInput  
    original_credit_not_accepted_details: OriginalCreditNotAcceptedDetailsInput
  }
  
  type MisrepresentationDetails {
      did_cardholder_cancel: Boolean
      cancellation_date: String
      cancellation_reason: String
      cardholder_attempt_to_resolve: Boolean
      attempt_to_resolve_proh_local_law: Boolean
      merchandise_or_services: String
      service_received_date: String
      merchandise_received_date: String
      how_merchandise_service_misrepresented: String
      describe_what_was_purchased: String
      cardholder_return_merchandise_ind: Boolean
      shipping_tracking_number: String
      cardholder_attempt_return_merchandise: Boolean
      attempted_return_date: String
      how_ch_attempt_return_and_disp_of_merchandise: String
      merchant_refuse_ind: String
      cardholder_returned_merchandise_date: String
      merchant_received_returned_merchandise_date: String
      return_method: String
      how_merchandise_returned: String
      motive_code: String
      merchandise_counterfeit_confirmation_date: String
      promised_delivery_date: String
      cash_over_indicator: String
  }
  
  input MisrepresentationDetailsInput {
      did_cardholder_cancel: Boolean
      cancellation_date: String
      cancellation_reason: String
      cardholder_attempt_to_resolve: Boolean
      attempt_to_resolve_proh_local_law: Boolean
      merchandise_or_services: String
      service_received_date: String
      merchandise_received_date: String
      how_merchandise_service_misrepresented: String
      describe_what_was_purchased: String
      cardholder_return_merchandise_ind: Boolean
      shipping_tracking_number: String
      cardholder_attempt_return_merchandise: Boolean
      attempted_return_date: String
      how_ch_attempt_return_and_disp_of_merchandise: String
      merchant_refuse_ind: String
      cardholder_returned_merchandise_date: String
      merchant_received_returned_merchandise_date: String
      return_method: String
      how_merchandise_returned: String
      motive_code: String
      merchandise_counterfeit_confirmation_date: String
      promised_delivery_date: String
      cash_over_indicator: String
  }
  
   type OriginalCreditNotAcceptedDetails {
      explain_reason: String
  }
  
  input OriginalCreditNotAcceptedDetailsInput {
      explain_reason: String
  }

  type ServiceNotProvidedMerchandiseNotReceivedDetails {
    what_is_the_amount_on_the_cardholders_receipt: Float
    does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token: String
    what_is_the_currency_on_the_cardholders_receipt: String
    detailed_description_of_what_was_purchased_and_explanation_of_the_dispute: String
    is_merchant_in_bankruptcy_liquidation: Boolean
    merchandise_delivered_late: Boolean
    non_fiat_currency_not_delivered: Boolean
    did_the_cardholder_return_the_merchandise: String
    expected_receipt_date: String
    expected_receipt_time: String
    did_cardholder_cancel_prior_to_the_expected_date: Boolean
    cancellation_date: String
    cancellation_reason: String
    did_cardholder_attempt_to_resolve_dispute_with_merchant: Boolean
    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: Boolean
    provide_details_of_local_law_or_regulations: String
    merchandise_or_services: MERCHANDISE_OR_SERVICES
    was_merchandise_delivered_to_wrong_location: Boolean
    address_of_agreed_location: String
    did_cardholder_return_merchandise: Boolean
    date_cardholder_returned_merchandise: String
    date_merchant_received_returned_merchandise: String
    did_cardholder_attempt_to_return_merchandise: Boolean
    date_of_attempted_return: String
    explain_how_merchandise_was_returned: String
    third_party_gift_card_indicator: Boolean
    visa_commercial_card_virtual_account_indicator: Boolean
    did_virtual_account_holder_suffer_financial_loss: Boolean
    did_merchant_cancel_services: Boolean
    date_merchant_cancelled_services: String
    did_merchant_cancel_merchandise: Boolean
    date_merchant_cancelled_merchandise: String
    explanation_dispute_prior_expected_delivery_date: String
    agreed_delivery_date_or_service_date: String
    date_of_return: String
    cash_over_indicator: String
  }

  input ServiceNotProvidedMerchandiseNotReceivedDetailsInput {
    what_is_the_amount_on_the_cardholders_receipt: Float
    does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token: String
    what_is_the_currency_on_the_cardholders_receipt: String
    detailed_description_of_what_was_purchased_and_explanation_of_the_dispute: String
    is_merchant_in_bankruptcy_liquidation: Boolean
    merchandise_delivered_late: Boolean
    non_fiat_currency_not_delivered: Boolean
    did_the_cardholder_return_the_merchandise: String
    expected_receipt_date: String
    expected_receipt_time: String
    did_cardholder_cancel_prior_to_the_expected_date: Boolean
    cancellation_date: String
    cancellation_reason: String
    did_cardholder_attempt_to_resolve_dispute_with_merchant: Boolean
    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: Boolean
    provide_details_of_local_law_or_regulations: String
    merchandise_or_services: String
    was_merchandise_delivered_to_wrong_location: Boolean
    address_of_agreed_location: String
    did_cardholder_return_merchandise: Boolean
    date_cardholder_returned_merchandise: String
    date_merchant_received_returned_merchandise: String
    did_cardholder_attempt_to_return_merchandise: Boolean
    date_of_attempted_return: String
    explain_how_merchandise_was_returned: String
    third_party_gift_card_indicator: Boolean
    visa_commercial_card_virtual_account_indicator: Boolean
    did_virtual_account_holder_suffer_financial_loss: Boolean
    did_merchant_cancel_services: Boolean
    date_merchant_cancelled_services: String
    did_merchant_cancel_merchandise: Boolean
    date_merchant_cancelled_merchandise: String
    explanation_dispute_prior_expected_delivery_date: String
    agreed_delivery_date_or_service_date: String
    date_of_return: String
    cash_over_indicator: String
  }

  type CancelledRecurringTransactionDetails {
    cancellation_date: String
    cancellation_reason: String
    date_issuer_informed_merchant_of_account_closure: String
    contact_merchant_details: String
    other_form_of_payment_ind: Boolean
    other_form_of_payment_desc: String
    contact_method_with_merchant_ind: Boolean
    contact_method_merchant_email_ind: Boolean
    contact_merchant_details_email_address: String
    contact_method_merchant_call_center_ind: Boolean
    contact_method_merchant_mail_ind: Boolean
    contact_method_merchant_SMS_ind: Boolean
    contact_merchant_details_phone_number: String
    contact_method_merchant_in_person_ind: Boolean
    contact_merchant_details_physical_address: String
    contact_method_merchant_webform_ind: Boolean
    contact_merchant_details_application_name: String
    is_dispute_impacted_by_local_law_or_regulation: Boolean
    cancelled_recurring_payment_date: String
    recurring_payment_plan_expiry_date: String
  }

  input CancelledRecurringTransactionDetailsInput {
    cancellation_date: String
    cancellation_reason: String
    date_issuer_informed_merchant_of_account_closure: String
    contact_merchant_details: String
    other_form_of_payment_ind: Boolean
    other_form_of_payment_desc: String
    contact_method_with_merchant_ind: Boolean
    contact_method_merchant_email_ind: Boolean
    contact_merchant_details_email_address: String
    contact_method_merchant_call_center_ind: Boolean
    contact_method_merchant_mail_ind: Boolean
    contact_method_merchant_SMS_ind: Boolean
    contact_merchant_details_phone_number: String
    contact_method_merchant_in_person_ind: Boolean
    contact_merchant_details_physical_address: String
    contact_method_merchant_webform_ind: Boolean
    contact_merchant_details_application_name: String
    is_dispute_impacted_by_local_law_or_regulation: Boolean
    cancelled_recurring_payment_date: String
    recurring_payment_plan_expiry_date: String
  }

  type NotAsDecribedOrDefectiveMerchandiseDetails {
    cancellation_date: String
    cancellation_reason: String
    cardholder_merchant_previous_negotiation_evidence: Boolean
    date_cardholder_returned_the_merchandise: String
    date_merchandise_or_service_was_received: String
    date_merchandise_was_received: String
    date_merchant_received_the_returned_merchandise: String
    date_of_attempted_return: String
    date_the_cardholder_first_notified_the_issuer_of_the_dispute: String
    did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant: Boolean
    did_the_cardholder_attempt_to_return_the_merchandise: Boolean
    did_the_cardholder_cancel_the_services: Boolean
    did_the_cardholder_return_the_merchandise: Boolean
    did_the_merchandise_or_services_differ_from_what_was_described_on_the_receipt: Boolean
    does_the_dispute_involve_merchandise_or_services_provided_that_do_not_match_the_merchants_verbal_description: Boolean
    explain_how_the_merchandise_was_returned: String
    explain_prev_negotiation: String
    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: Boolean
    merchandise_or_services: MERCHANDISE_OR_SERVICES
    merchant_refuse_advise: String
    not_as_described_or_defective: NOT_AS_DESCRIBED_OR_DEFECTIVE
    what_is_the_disposition_of_the_merchandise: String
    provide_a_detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise: String
    provide_details_of_local_law_or_regulations: String
    provide_details_of_what_was_ordered_and_not_as_described: String
    return_method: RETURN_METHOD
    tracking_number: String
    what_was_ordered_and_how_it_was_damaged_or_defective: String
    when_negotiations_begin: String
    motive_code: String
    merchandise_counterfeit_confirmation_date: String
    promised_delivery_date: String
    cash_over_indicator: String
  }

  input NotAsDecribedOrDefectiveMerchandiseDetailsInput {
    cancellation_date: String
    cancellation_reason: String
    cardholder_merchant_previous_negotiation_evidence: Boolean
    date_cardholder_returned_the_merchandise: String
    date_merchandise_or_service_was_received: String
    date_merchandise_was_received: String
    date_merchant_received_the_returned_merchandise: String
    date_of_attempted_return: String
    date_the_cardholder_first_notified_the_issuer_of_the_dispute: String
    did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant: Boolean
    did_the_cardholder_attempt_to_return_the_merchandise: Boolean
    did_the_cardholder_cancel_the_services: Boolean
    did_the_cardholder_return_the_merchandise: Boolean
    did_the_merchandise_or_services_differ_from_what_was_described_on_the_receipt: Boolean
    does_the_dispute_involve_merchandise_or_services_provided_that_do_not_match_the_merchants_verbal_description: Boolean
    explain_how_the_merchandise_was_returned: String
    explain_prev_negotiation: String
    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: Boolean
    merchandise_or_services: String
    merchant_refuse_advise: String
    not_as_described_or_defective: String
    what_is_the_disposition_of_the_merchandise: String
    provide_a_detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise: String
    provide_details_of_local_law_or_regulations: String
    provide_details_of_what_was_ordered_and_not_as_described: String
    return_method: String
    tracking_number: String
    what_was_ordered_and_how_it_was_damaged_or_defective: String
    when_negotiations_begin: String
    motive_code: String
    merchandise_counterfeit_confirmation_date: String
    promised_delivery_date: String
    cash_over_indicator: String
  }

  type CreditNotProcessedDetails {
    credit_voucher_transaction_receipt_or_refund_acknowledgement_date: String
    date_cardholder_returned_cancelled_merchandise: String
    is_the_credit_voucher_transaction_receipt_or_refund_acknowledgement_dated: Boolean
    was_a_credit_voucher_voided_transaction_receipt_or_refund_acknowledgement_given: Boolean
    date_of_cancellation: String
    date_of_return: String
    cash_over_indicator: String
  }

  input CreditNotProcessedDetailsInput {
    credit_voucher_transaction_receipt_or_refund_acknowledgement_date: String
    date_cardholder_returned_cancelled_merchandise: String
    is_the_credit_voucher_transaction_receipt_or_refund_acknowledgement_dated: Boolean
    was_a_credit_voucher_voided_transaction_receipt_or_refund_acknowledgement_given: Boolean
    date_of_cancellation: String
    date_of_return: String
    cash_over_indicator: String
  }

  type CancelledMerchandiseOrServicesDetails {
    merchandise_or_services: MERCHANDISE_OR_SERVICES
    describe_what_was_purchased: String
    date_cardholder_received_or_expected_to_receive_merchandise: String
    did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant: Boolean
    provide_details_of_local_law_or_regulations: String
    did_the_cardholder_return_the_merchandise: Boolean
    date_of_return: String
    date_merchant_received_returned_merchandise: String
    return_method: RETURN_METHOD
    tracking_number: String
    explain_how_the_merchandise_was_returned: String
    did_the_cardholder_attempt_to_return_the_merchandise: Boolean
    date_of_attempted_return: String
    detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise: String
    did_cardholder_cancel: Boolean
    cancellation_date: String
    cancellation_reason: String
    was_cancellation_policy_provided: Boolean
    type_of_service: TYPE_OF_SERVICE
    date_of_service_or_expected_service: String
    cancelled_guaranteed_reservation_certification_selection: CANCELLED_GUARANTEED_RESERVATION_CERTIFICATION_SELECTION
    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: Boolean
    merchant_refuse_advise: String
    what_is_the_disposition_of_the_merchandise: String
  }

  input CancelledMerchandiseOrServicesDetailsInput {
    merchandise_or_services: String
    describe_what_was_purchased: String
    date_cardholder_received_or_expected_to_receive_merchandise: String
    did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant: Boolean
    provide_details_of_local_law_or_regulations: String
    did_the_cardholder_return_the_merchandise: Boolean
    date_of_return: String
    date_merchant_received_returned_merchandise: String
    return_method: String
    tracking_number: String
    explain_how_the_merchandise_was_returned: String
    did_the_cardholder_attempt_to_return_the_merchandise: Boolean
    date_of_attempted_return: String
    detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise: String
    did_cardholder_cancel: Boolean
    cancellation_date: String
    cancellation_reason: String
    was_cancellation_policy_provided: Boolean
    type_of_service: String
    date_of_service_or_expected_service: String
    cancelled_guaranteed_reservation_certification_selection: String
    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: Boolean
    merchant_refuse_advise: String
    what_is_the_disposition_of_the_merchandise: String
  }

  input CounterfeitMerchDetailsInput {
      certification_the_merchandise_was_identified_as_counterfeit_by_one_of_the_following: String
      date_the_cardholder_received_the_merchandise_or_notification: String
      describe_the_counterfeit_merchandise: String
      describe_the_disposition_of_counterfeit_merchandise: String
      provide_information_about_the_entity_that_indicated_the_merchandise_to_be_counterfeit: String
      what_was_ordered: String
      motive_code: String
      merchandise_counterfeit_confirmation_date: String
      promised_delivery_date: String
      cash_over_indicator: String
  }
  
  type CounterfeitMerchDetails{
      certification_the_merchandise_was_identified_as_counterfeit_by_one_of_the_following: String
      date_the_cardholder_received_the_merchandise_or_notification: String
      describe_the_counterfeit_merchandise: String
      describe_the_disposition_of_counterfeit_merchandise: String
      provide_information_about_the_entity_that_indicated_the_merchandise_to_be_counterfeit: String
      what_was_ordered: String
      motive_code: String
      merchandise_counterfeit_confirmation_date: String
      promised_delivery_date: String
      cash_over_indicator: String
  }

  enum MERCHANDISE_OR_SERVICES {
    MERCHANDISE
    SERVICES
  }

  enum NOT_AS_DESCRIBED_OR_DEFECTIVE {
    NOT_AS_DESCRIBED
    DEFECTIVE
  }

  enum RETURN_METHOD {
    FACE_TO_FACE
    FED_EX
    DHL
    UPS
    POSTAL_SERVICE
    OTHER
  }

  enum TYPE_OF_SERVICE {
    TIMESHARE
    GUARANTEED_RESERVATION
    OTHER
  }

  enum CANCELLED_GUARANTEED_RESERVATION_CERTIFICATION_SELECTION {
    CARDHOLDER_PROPERLY_CANCELLED
    CARDHOLDER_ATTEMPTED_TO_CANCEL_WITHIN_24_HOURS_OF_CONFIRMATION
    MERCHANT_BILLED_A_NO_SHOW_TRANSACTION_FOR_MORE_THAN_ONE_DAYS_ACCOMODATION
  }
`;
var vg = { types: Pg };
const { gql: Tt } = e, Rg = Tt`
  type ReviewDocument {
    id: String
    token: String
    program_short_code: String
    user_token: String
    entity_token: String
    name: String
    type: String
    created_time: String
    last_modified_time: String
    deleted_time: String
  }

  type UploadResponse {
    timestamp: String
    errorCode: String
    message: String
  }

  input UploadedFile {
    filename: String
    mimetype: String
    file: String
  }
`, bg = Tt`
  getReviewDocuments(
    reviewToken: ID!
  ): [ReviewDocument]
`, Ng = Tt`
  deleteReviewDocument(
    reviewToken: ID!
    documentToken: String
  ): String
`;
var Bg = { types: Rg, queries: bg, mutations: Ng };
const { gql: Vi } = e, Og = Vi`
  type Country {
    code: String
    name: String
  }
`, Fg = Vi`
  countries: [Country]!
`;
var wg = { types: Og, queries: Fg };
const { gql: It } = e, { paginationParams: qg, generateCollectionType: Mg } = r, Ug = It`
  type CreditAccount_CreditLine {
    token: String
    limit: Float
    currencyCode: String
  }

  type Account_APR {
    balanceType: String
    type: String
    value: Float
  }

  type CreditFee {
    type: FEE
    active: Boolean
    method: String
    value: Int
  }

  enum CreditFeeMethod {
    FLAT
    PERCENTAGE
  }

  type CreditConfigFeeScheduleEntry {
    method: CreditFeeMethod
    value: Float
    effectiveDate: String
  }

  type CreditConfigFeeSchedule {
    type: FEE
    active: Boolean
    schedule: [CreditConfigFeeScheduleEntry]
  }

  type CreditAccountMinPayment {
    overrideStartTime: String
    overrideEndTime: String
    minPaymentFlatAmount: Float
    minPaymentPercentage: Float
    active: Boolean
  }

  enum CreditAccountStatus {
    ACTIVE
    SUSPENDED
    UNACTIVATED
    TERMINATED
  }

  input CreditAccountsFilters {
    status: [CreditAccountStatus]
    user_first_name: String
    user_last_name: String
    ssn: String
    user_phone_number: String
    user_email: String
    acquisition_offer_tokens: String
    product_tokens: String
  }

  input CreditAccountMemoInput {
    accountToken: ID!
    memo: String!
  }

  type CreditAccountMemo {
    token: ID!
    accountToken: ID
    createdBy: String
    memo: String
    createdTime: String
  }

  type CreditAccountConfig {
    billingCycleDay: Int
    paymentDueDay: Int
    fees: [CreditConfigFeeSchedule]
    minPayment: CreditAccountMinPayment
  }

  type CreditAccountAprSchedule {
    value: Float
    effectiveDate: String
  }

  type CreditAccountApr {
    type: String
    active: Boolean
    createdDate: String
    updatedDate: String
    schedule: [CreditAccountAprSchedule]
  }

  type CreditAccountUsage {
    type: String
    aprs: [CreditAccountApr]
    fees: [CreditFee]
    rewards: [CREDIT_REWARD]
  }

  type CreditAccount {
    token: ID
    name: String
    description: String
    status: String
    activationTime: String
    type: String
    purchaseBalance: Float
    availableCredit: Float
    productToken: String
    creditProduct: CreditProduct
    acquisitionOfferToken: String
    offer: Offer
    accountHolderToken: String
    accountHolderDetails: Cardholder
    externalOfferId: String
    
    accountSubStatuses: [String!]
    userSubStatuses: [String!]

    accountCards: [Card]
    creditLine: CreditAccount_CreditLine

    remainingStatementBalance: Float
    config: CreditAccountConfig
    accountUsage: [CreditAccountUsage]

    createdTime: String
    updatedTime: String
    memos: [CreditAccountMemo]

    # TMP hardcoded in code (resolvers/creditAccountResolvers.js)
    paymentDueDate: String
    statementBalance: Float
    minimumPayment: Float
  }

  type CreditAccountListItem {
    account: CreditAccount
    cardInstrumentType: String
    cardLastFour: String
    firstName: String
    lastName: String
    ssnlastFour: String
    phone: String
    email: String
  }

  ${Mg("CreditAccountListItem")}
`, Lg = It`
    creditAccount(token: String!, hasGranularPermission: Boolean): CreditAccount
    creditAccounts(
        start_index: String,
        filters: CreditAccountsFilters,
        includeSsn: Boolean!,
        hasGranularPermission: Boolean,
        ${qg}
    ): CreditAccountListItemCollection
`, xg = It`
  createCreditAccountMemo(
    accountToken: ID!
    memo: String!
    hasGranularPermission: Boolean
  ): CreditAccountMemo

  removeCreditAccountMemo(
    accountToken: ID!
    token: ID!
    hasGranularPermission: Boolean
  ): CreditAccountMemo

`;
var Gg = { types: Ug, queries: Lg, mutations: xg };
const { gql: ft } = e, { paginationParams: Bn, generateCollectionType: On } = r, Hg = ft`
  enum CREDIT_ACCOUNT_PAYMENT_STATUS {
    PENDING
    PROCESSING
    SUBMITTED
    COMPLETED
    REJECTED
    RETURNED
    CANCELLED
  }

  enum CREDIT_ACCOUNT_PAYMENT_METHOD {
    ACH
    CHECK
    CASH
    DEBIT
  }

  input CreditAccountPaymentFilters {
    amount: Float
    status: [CREDIT_ACCOUNT_PAYMENT_STATUS]
    method: [CREDIT_ACCOUNT_PAYMENT_METHOD]
  }

  type CreditAccountPayment {
    token: ID
    accountToken: ID
    paymentSourceToken: ID
    paymentScheduleToken: ID
    currencyCode: String
    amount: Float
    status: CREDIT_ACCOUNT_PAYMENT_STATUS
    method: CREDIT_ACCOUNT_PAYMENT_METHOD
    sourceAccount: String
    transactionId: String
    createdTime: String
    updatedTime: String
    description: String
    memo: String
    refundReasons: String
    cancelationReasons: String
    transitions: [CreditAccountPaymentTransition]
  }
  ${On("CreditAccountPayment")}

  type CreditAccountPaymentTransition {
      token: String
      status: TRANSITION_STATUS
      created_time: String
  }

  enum TRANSITION_STATUS {
      INITIATED
      PENDING
      PROCESSING
      SUBMITTED
      CANCELLED
      COMPLETED
      RETURNED
      REFUNDED
      SYS_ERROR
      ACH_ERROR
  }

  enum PAYMENT_SOURCE_TYPE {
    SAVINGS
    CHECKING
    OTHER
  }
  
  enum VERIFICATION_STATUS_TYPE {
    ACH_VERIFIED
    PENDING
  }
  
  enum PAYMENT_SOURCE_STATUS_TYPE {
    ACTIVE
    PENDING
    INACTIVE
  }

  type CreditAccountPaymentSource {
    token: ID
    accountToken: ID
    createdTime: String
    lastModifiedTime: String
    sourceType: PAYMENT_SOURCE_TYPE
    name: String
    verificationStatus: VERIFICATION_STATUS_TYPE
    verificationNotes: String
    accountSuffix: String
    routingNumber: String
    bankName: String
    status: PAYMENT_SOURCE_STATUS_TYPE   
  }
  ${On("CreditAccountPaymentSource")}

  input CreditPaymentSourceUpdateInput {
      status: PAYMENT_SOURCE_STATUS_TYPE
  }
`, Vg = ft`
    creditAccountPayment(accountToken: String! token: String!): CreditAccountPayment
    creditAccountPayments(
      accountToken: String!,
      ${Bn}
    ): CreditAccountPaymentCollection
    creditAccountPaymentSources(
      accountToken: String!,
      ${Bn}
    ): CreditAccountPaymentSourceCollection

    creditAccountPaymentSource(token: String!, hasGranularPermission: Boolean) : CreditAccountPaymentSource
`, Yg = ft`
  updatePaymentSource(token: String!, status: CreditPaymentSourceUpdateInput!): CreditAccountPaymentSource
`;
var Wg = { types: Hg, queries: Vg, mutations: Yg };
const { gql: Yi } = e, { paginationParams: Kg, generateCollectionType: zg } = r, jg = Yi`
  enum CREDIT_AMOUNT_CATEGORY {
    FIXED
    MINIMUM_PAYMENT
    REMAINING_STATEMENT_BALANCE
    CURRENT_BALANCE
  }

  enum PAYMENT_SCHEDULE_STATUS {
    ACTIVE
    COMPLETED
    TERMINATED
  }

  enum FREQUENCY {
    ONCE
    MONTHLY
  }

  type CreditAccountPaymentSchedules {
    token: String
    amountCategory: CREDIT_AMOUNT_CATEGORY
    paymentSourceToken: String
    accountToken: String
    status: PAYMENT_SCHEDULE_STATUS
    amount: Float
    frequency: FREQUENCY
    paymentDay: String
    nextPaymentImpactDate: String
    currencyCode: String
    description: String
    createdTime: String
    updatedTime: String
  }
  
  ${zg("CreditAccountPaymentSchedules")}
`, Qg = Yi`
    creditAccountPaymentSchedules(accountToken: String! paymentScheduleToken: String!): CreditAccountPaymentSchedules
    creditAccountListPaymentSchedules(accountToken: String!, ${Kg},
    frequency: String, statuses: String, hasGranularPermission: Boolean): CreditAccountPaymentSchedulesCollection
`;
var Jg = { types: jg, queries: Qg };
const { gql: Wi } = e, { paginationParams: Fn, generateCollectionType: xe } = r, Zg = Wi`
  type CreditAccountStatement {
    token: ID
    accountToken: String!
    openingBalance: Float
    closingBalance: Float
    creditLimit: Float
    availableCredit: Float
    pastDueAmount: Float
    purchases: Float
    interest: Float
    fees: Float
    credits: Float
    payments: Float
    daysInBillingCycle: Int
    gracePeriod: Int
    paymentDueDate: String
    openingDate: String
    closingDate: String
    createdTime: String
    paymentInfo: CreditAccountStatementPaymentInfo
    transactions: CreditTransactionCollection
    rewards: CreditAccountStatementReward
    yearToDate: CreditAccountStatementYearToDate
    isCurrent: Boolean
  }

  ${xe("CreditAccountStatement")}

  type CreditAccountStatementYearToDate {
    totalReward: Float
    totalFees: Float
    totalInterest: Float
  }

  type CreditAccountStatementWarning {
    type: String
    totalPaid: Float
    monthlyPayment: Float
    payOffPeriod: Int
    periodType: String
  }

  type CreditAccountStatementPaymentInfo {
    token: ID
    statementSummaryToken: ID
    newStatementBalance: Float
    minimumPaymentDue: Float
    paymentDueDate: String
    warnings: [CreditAccountStatementWarning]
    createdTime: String
  }

  type CreditAccountStatementReward {
    token: ID
    previousMonthReward: Float
    currentMonthReward: Float
    adjustedReward: Float
    totalReward: Float
  }

  ${xe("CreditAccountStatementReward")}
  
  type CreditAccountStatementFile {
    token: ID
    accountToken: String
    statementSummaryToken: String
    type: CREDIT_ACCOUNT_STATEMENT_FILE_TYPE
    signedUrl: String
    closingDate: String
    openingDate: String
  }
  
  enum CREDIT_ACCOUNT_STATEMENT_FILE_TYPE {
    STATEMENT_PDF
  }

  ${xe("CreditAccountStatementFile")}
`, Xg = Wi`
    creditAccountStatement(accountToken: String!, token: ID!, hasGranularPermission: Boolean): CreditAccountStatement
    creditAccountStatements(accountToken: String! ${Fn}, hasGranularPermission: Boolean): CreditAccountStatementCollection
    creditAccountStatementFiles(accountToken: String!, statementSummaryToken: String!, hasGranularPermission: Boolean ${Fn}): CreditAccountStatementFileCollection
`;
var ep = { types: Zg, queries: Xg };
const { gql: Dt } = e, { paginationParams: tp, generateCollectionType: np } = r, ip = Dt`

  enum CREDIT_ADJUSTMENT_TYPE {
      PURCHASE
      FEE
      REWARD
      INTEREST
      GENERAL
  }
  
  enum CREATE_CREDIT_ADJUSTMENT_REASON {
      DISPUTE
      DISPUTE_RESOLUTION
      RETURNED_OR_CANCELED_PAYMENT
      OTHER
  }
  
  type CreditAdjustment {
    token: ID
    accountToken: ID
    type: CREDIT_ADJUSTMENT_TYPE
    originalLedgerEntryToken: ID
    detailToken: ID
    relatedDetailToken: ID
    amount: Float
    currencyCode: String
    description: String
    note: String
    reason: CREATE_CREDIT_ADJUSTMENT_REASON
    createdTime: String
  }
  ${np("CreditAdjustment")}
  
  input CreateAdjustmentInput {
    token: ID
    originalLedgerEntryToken: ID
    externalAdjustmentId: ID
    amount: Float!
    currencyCode: String!
    description: String!
    note: String
    reason: CREATE_CREDIT_ADJUSTMENT_REASON
  }
`, rp = Dt`
    creditAdjustment(accountToken: String! token: String!): CreditAdjustment
    creditAdjustments(
      accountToken: String!,
      ${tp}
    ): CreditAdjustmentCollection
`, ap = Dt`
    createAdjustment(accountToken: String!, creditAdjustment: CreateAdjustmentInput!): CreditAdjustment
`;
var op = { types: ip, queries: rp, mutations: ap };
const { gql: Ki } = e, sp = Ki`

  type CreditAuthorizedUser {
    token: String!
    firstName: String
    lastName: String
  }
  
  type CreditAuthorizedUsers {
    token: String!
    authorizedUsers: [CreditAuthorizedUser]
  }
`, cp = Ki`
  creditAuthorizedUsers(accountToken: String!): CreditAuthorizedUsers
`;
var _p = { types: sp, queries: cp };
const { gql: dp } = e, lp = dp`
  createCreditCard(
    accountToken: ID!
    userToken: ID!
    expirationOffset: ExpirationOffsetInput
    reissuePanFromCardToken: String
  ): Card
`;
var up = { mutations: lp };
const { gql: zi } = e, gp = zi`
  type CreditCollectionsTasks {
    token: String
    accountToken: String
    delinquencyTransitionToken: String
    triggerTime: String
    state: CreditCollectionsTasksState
    action: CreditCollectionsTasksAction
    canceledByDelinquencyTransitionToken: String
    actionedOn: String
    createdTime: String
    updatedTime: String
    canceledTime: String
  }

  enum CreditCollectionsTasksState {
    SCHEDULED
    COMPLETED
    CANCELED
    FAILED
    CANCELED_UNSUSPEND_ACCOUNT
  }

  enum CreditCollectionsTasksAction {
    PAST_DUE_WEBHOOK
    PAYMENT_APPROACHING_WEBHOOK
    SUSPEND_PAST_DUE_ACCOUNT
    UNSUSPEND_PAST_DUE_ACCOUNT
    DECREASE_CREDIT_LIMIT
    PAST_DUE_SMS
    TERMINATE_PAST_DUE_ACCOUNT
  }
`, pp = zi`
  creditCollectionsTasks(accountToken: String!): [CreditCollectionsTasks]
`;
var mp = { types: gp, queries: pp };
const { gql: At } = e, { paginationParams: wn, generateCollectionType: Sp } = r, yp = At`
  enum MIN_PAYMENT_OPTIONS {
    PAST_DUE_AMOUNT
    OVER_LIMIT_AMOUNT
    INTEREST_CHARGES
    LATE_PAYMENT_FEE
    RETURN_PAYMENT_FEE
  }

  enum INTEREST_ON_GRACE_REACTIVATION {
    ACCRUE_PAYMENT_DATE
    ACCRUE_FULL_CYCLE
    WAIVE
  }

  enum INTEREST_APPLICATION {
    PRINCIPAL
    INTEREST
    FEES
  }

  enum CREDIT_PRODUCT_STATUS {
    DRAFT
    ACTIVE
    ARCHIVED
    PENDING_APPROVAL
    SENT_FOR_REVISION
    REJECTED
  }

  enum ACCOUNT_APR {
    GO_TO
    PROMOTIONAL
  }

  enum FEE {
    PERIODIC_MEMBERSHIP_FEE
    FOREIGN_TRANSACTION_FEE
    OVER_LIMIT_FEE
    LATE_PAYMENT_FEE
    RETURNED_PAYMENT_FEE
    CARD_REPLACEMENT_FEE
    ANNUAL_FEE
    MONTHLY_FEE
  }

  type CreditProduct_CreditLine {
    min: Float
    max: Float
  }

  input CreditProduct_CreditLineInput {
    min: Float
    max: Float
  }

  enum PRODUCT_USAGE_ENUM {
    PURCHASE
    CASH_ADVANCE
    BALANCE_TRANSFER
    DIRECT_DEPOSIT
  }

  type ProductApplicationOfCredits {
    cycleType: String
    day: Int
  }

  type ProductInterestCalculation {
    method: String
    dayCount: String
    interestApplication: [String]
    minimumInterest: Float
    interestOnGraceReactivation: String
    graceDaysApplication: String
    applicationOfCredits: ProductApplicationOfCredits
    excludeTranTypes: [String]
  }

  type ProductConfig {
    billingCycleDay: Int
    paymentDueDay: Int
    fees: [String]
    periodicFees: [PeriodicFee]
  }

  enum ProductClassification {
    CONSUMER
    SMALL_AND_MEDIUM_BUSINESS
  }

  enum PeriodicFeeTypes {
    ANNUAL
    MONTHLY
  }

  type PeriodicFee {
    frequency: PeriodicFeeTypes
    numberOfDaysPostActivation: Int
  }

  input PeriodicFeeInput {
    frequency: PeriodicFeeTypes
    numberOfDaysPostActivation: Int
  }

  type CreditProduct {
    token: ID
    parentProductToken: ID

    cardProductTokens: [String]
    name: String
    description: String
    status: CREDIT_PRODUCT_STATUS
    createdTime: String
    updatedTime: String
    classification: ProductClassification
    productType: String
    productSubType: String
    currencyCode: String
    creditLine: CreditProduct_CreditLine
    usage: [PRODUCT_USAGE_ENUM]
    minPaymentPercentage: Float
    minPaymentFlatAmount: Float
    paymentAllocationOrder: [String]
    interestCalculation: ProductInterestCalculation
    config: ProductConfig
    submissionDate: String
    includeInMinimumPayment: [MIN_PAYMENT_OPTIONS]
    rewards: Boolean

    offers: [Offer]
    history: [CreditHistoryRecord]
    dateArchived: String
    cardProducts: [CardProduct]

    originalCreditProduct: CreditProduct
  }

  ${Sp("CreditProduct")}
`, Cp = At`
    creditProduct(token: ID!): CreditProduct
    
    creditProducts(count: Int, ${wn}): CreditProductCollection
    
    parentCreditProducts(${wn}): CreditProductCollection
    
    productDefaults: CreditProduct
    
    creditProductsLineage(token: ID!): CreditProductCollection
`, qn = `
  cardProductTokens: [String]!,
  name: String!,
  description: String,
  status: String!,
  classification: ProductClassification
  creditLineMin: Float,
  creditLineMax: Float,
  usage: [String],
  minPaymentPercentage: Float,
  minPaymentFlatAmount: Float,
  interestApplication: [String]
  minimumInterest: Float,
  fees: [String],
  periodicFees: [PeriodicFeeInput],
  comment: String
  includeInMinimumPayment: [MIN_PAYMENT_OPTIONS]
  rewards: Boolean
`, Tp = `
  token: String!
  cardProductTokens: [String]!,
  name: String!,
  description: String,
  status: String!,
  classification: ProductClassification
  creditLineMin: Float,
  creditLineMax: Float,
  usage: [String],
  minPaymentPercentage: Float,
  minPaymentFlatAmount: Float,
  interestApplication: [String]
  minimumInterest: Float,
  fees: [String],
  periodicFees: [PeriodicFeeInput],
  comment: String
  includeInMinimumPayment: [MIN_PAYMENT_OPTIONS]
  rewards: Boolean
`, Ip = At`
  createCreditProduct(
    ${qn}
  ): CreditProduct

  createCreditProductClone(
    ${Tp}
  ): CreditProduct

  updateCreditProduct(
    token: ID!
    ${qn}
  ): CreditProduct
  
  updateCreditProductStatus(
    token: ID!
    status: CREDIT_PRODUCT_STATUS
    comment: String
  ): CreditProduct

  activateCreditProductClone(
    token: ID!
    comment: String
  ): CreditProduct
`;
var fp = { types: yp, queries: Cp, mutations: Ip };
const { gql: kt } = e, { paginationParams: Dp, generateCollectionType: Ap } = r, kp = kt`
  scalar Day

  enum ALLOCATION_ORDER {
    INTEREST
    FEES
    PRINCIPAL
  }

  enum INCLUDE_FEES_CHARGED {
    LATE_PAYMENT_FEE
    RETURNED_PAYMENT_FEE
  }

  input MinPaymentPercentageProductPolicyInput {
    percentageOfBalance: Float
    includeInterestCharged: Boolean
    includeAllFeesCharged: Boolean
  }

  type MinPaymentPercentageProductPolicy {
    percentageOfBalance: Float
    includeInterestCharged: Boolean
    includeAllFeesCharged: Boolean
  }

  input MinPaymentCalculationProductPolicyInput {
    includePastDueAmount: Boolean
    includeOverlimitAmount: Boolean
    minPaymentPercentage: MinPaymentPercentageProductPolicyInput
    minPaymentFlatAmount: Float
  }

  type MinPaymentCalculationProductPolicy {
    includePastDueAmount: Boolean
    includeOverlimitAmount: Boolean
    minPaymentPercentage: MinPaymentPercentageProductPolicy
    minPaymentFlatAmount: Float
  }

  input PaymentsProductPolicyInput {
    minPaymentCalculation: MinPaymentCalculationProductPolicyInput
    allocationOrder: [ALLOCATION_ORDER]
    dueDay: Day
    billingCycleDay: Int
  }

  type PaymentsProductPolicy {
    minPaymentCalculation: MinPaymentCalculationProductPolicy
    allocationOrder: [ALLOCATION_ORDER]
    dueDay: Day
    billingCycleDay: Int
  }

  enum EXCLUDED_TRAN_TYPE {
    LATE_PAYMENT_FEE
    ANNUAL_FEE
    CASH_BACK_STATEMENT_CREDIT
    RETURNED_PAYMENT_FEE
  }

  enum CYCLE_TYPE {
    BEGINNING_REVOLVING
    REVOLVING
    END_REVOLVING
    TRANSACTING
  }

  input ApplicationOfCreditsProductPolicyInput {
    cycleType: CYCLE_TYPE
    day: Day
  }

  type ApplicationOfCreditsProductPolicy {
    cycleType: CYCLE_TYPE
    day: Day
  }

  enum GRACE_DAYS_APPLICATION {
    NEXT_CYCLE_DATE
  }

  enum DAY_COUNT {
    ACTUAL
  }

  enum METHOD {
    AVG_DAILY_BALANCE_WITH_NEW_TRANSACTIONS
  }

  input InterestCalculationProductPolicyInput {
    method: METHOD
    dayCount: DAY_COUNT
    interestApplication: [INTEREST_APPLICATION]
    minimumInterest: Float
    interestOnGraceReactivation: INTEREST_ON_GRACE_REACTIVATION
    graceDaysApplication: GRACE_DAYS_APPLICATION
    applicationOfCredits: ApplicationOfCreditsProductPolicyInput
    excludeTranTypes: [EXCLUDED_TRAN_TYPE]
  }

  type InterestCalculationProductPolicy {
    method: METHOD
    dayCount: DAY_COUNT
    interestApplication: [INTEREST_APPLICATION]
    minimumInterest: Float
    interestOnGraceReactivation: INTEREST_ON_GRACE_REACTIVATION
    graceDaysApplication: GRACE_DAYS_APPLICATION
    applicationOfCredits: ApplicationOfCreditsProductPolicy
    excludeTranTypes: [EXCLUDED_TRAN_TYPE]
  }

  enum USAGE {
    PURCHASE
  }

  input CreditLineInput {
    min: Float
    max: Float
  }

  type CreditLine {
    min: Float
    max: Float
  }

  enum CURRENCY_CODE {
    USD
  }

  enum PRODUCT_SUB_TYPE {
    CREDIT_CARD
  }

  enum PRODUCT_TYPE {
    REVOLVING
  }

  enum CLASSIFICATION {
    CONSUMER
  }

  enum CARD_PRODUCT_LEVELS {
    TRADITIONAL
    PREMIUM
  }

  input CardProductForPolicyInput {
    token: String
    level: CARD_PRODUCT_LEVELS
  }

  type CardProductForPolicy {
    token: String
    level: CARD_PRODUCT_LEVELS
    name: String
  }

  type CreditProductPolicy {
    token: String
    cardProducts: [CardProductForPolicy]
    name: String
    description: String
    classification: CLASSIFICATION
    productType: PRODUCT_TYPE
    productSubType: PRODUCT_SUB_TYPE
    currencyCode: CURRENCY_CODE
    creditLine: CreditLine
    usage: [USAGE]
    interestCalculation: InterestCalculationProductPolicy
    createdTime: String
    updatedTime: String
    payments: PaymentsProductPolicy
  }

  ${Ap("CreditProductPolicy")}
`, hp = `
    token: ID
    cardProducts: [CardProductForPolicyInput]
    name: String!
    description: String
    classification: CLASSIFICATION!
    productType: PRODUCT_TYPE!
    productSubType: PRODUCT_SUB_TYPE!
    currencyCode: CURRENCY_CODE!
    creditLine: CreditLineInput!
    usage: [USAGE]!
    interestCalculation: InterestCalculationProductPolicyInput!
    payments: PaymentsProductPolicyInput!
`, Ep = `
    token: ID!
    cardProducts: [CardProductForPolicyInput]
    name: String!
    description: String
    classification: CLASSIFICATION!
    productType: PRODUCT_TYPE!
    productSubType: PRODUCT_SUB_TYPE!
    currencyCode: CURRENCY_CODE!
    creditLine: CreditLineInput!
    usage: [USAGE]!
    interestCalculation: InterestCalculationProductPolicyInput!
    payments: PaymentsProductPolicyInput!
`, $p = kt`
  creditProductPolicy(token: ID!): CreditProductPolicy
  creditProductPolicies(${Dp}): CreditProductPolicyCollection
`, Pp = kt`
  creditProductPolicyCreate(${hp}): CreditProductPolicy
  creditProductPolicyClone(token: ID!): CreditProductPolicy
  creditProductPolicyUpdate(${Ep}): CreditProductPolicy
`;
var vp = { types: kp, queries: $p, mutations: Pp };
const { gql: ji } = e, { paginationParams: Mn } = r, Rp = ji`

    type CreditProgramType {
        shortCode: String
        partner: CREDIT_PROGRAM_PARTNER
        name: String
        updatedTime: String
        createdTime: String
        statementPdfEnabled: Boolean
    }
    
    enum CREDIT_PROGRAM_PARTNER {
        MARQETA
        DESERVE
        FNBO
        TESTPRIMERATE
    }  
`, bp = ji`
    creditProgram(${Mn}): [CreditProgramType]
    getCreditProgramForActiveShortCode(${Mn}): CreditProgramType
`;
var Np = { types: Rp, queries: bp };
const { gql: ht } = e, { paginationParams: Un, generateCollectionType: Bp } = r, Op = ht`

    type CreditProgramsFundingType {
        shortCode: String
        token: String
        amount: Float
        currencyCode: String
        memo: String
        postTime: String
        createdTime: String
        updatedTime: String
    }
    ${Bp("CreditProgramsFundingType")}

    input CreditProgramsFundingInput {
        shortCode: String
        amount: Float
        currencyCode: String
        memo: String
        postTime: String
    } 
`, Fp = ht`
    creditProgramsFunding(
        start_index: Int, short_code: String
        ${Un}
    ): CreditProgramsFundingTypeCollection
    fetchAllProgramsFunding(
        start_index: Int, short_code: String
        ${Un}
    ): CreditProgramsFundingTypeCollection
`, wp = ht`
    createCreditProgramsFunding(programsFunding: CreditProgramsFundingInput!): CreditProgramsFundingType
`;
var qp = { types: Op, queries: Fp, mutations: wp };
const { gql: Et } = e, { paginationParams: Mp, generateCollectionType: Up } = r, Lp = Et`

    type CreditSubStatus {
        token: String
        resourceType: String
        resourceToken: String
        subStatus: String
        state: String
        isActive: Boolean
        attributes: [CreditSubStatusAttribute]
        events: [CreditSubStatusEvent]
        createdTime: String
        updatedTime: String
    }
    ${Up("CreditSubStatus")}

    input CreditSubStatusInput {
        resourceType: String
        resourceToken: String
        substatus: String
        attributes: [CreditSubStatusAttributeInput]
        events: [CreditSubStatusEventInput]
    }

    input CreditSubStatusUpdateInput {
        state: String
        channel: String
        reason: String
        effectiveDate: String
    }
    
    type CreditSubStatusEvent {
        state: String
        channel: String
        reason: String
        effective_date: String
        created_time: String
    }

    input CreditSubStatusEventInput {
        state: String
        channel: String
        reason: String
        effective_date: String
    }
    
    type CreditSubStatusAttribute {
        key: String
        value: String
    }

    input CreditSubStatusAttributeInput {
        key: String
        value: String
    }
`, xp = Et`
    creditSubstatus(token: String, hasGranularPermission: Boolean): CreditSubStatus
    creditSubstatuses(
        start_index: String,
        token: String,
        hasGranularPermission: Boolean,
        ${Mp}
    ): CreditSubStatusCollection
`, Gp = Et`
    creditCreateSubstatus(subStatus: CreditSubStatusInput!, hasGranularPermission: Boolean): CreditSubStatus
    creditUpdateSubstatus(token: String!, subStatus: CreditSubStatusUpdateInput!, hasGranularPermission: Boolean): CreditSubStatus
`;
var Hp = { types: Lp, queries: xp, mutations: Gp };
const { gql: Qi } = e, { paginationParams: Vp, generateCollectionType: Yp } = r, Wp = Qi`
  enum CREDIT_TRANSACTION_STATUS {
    PENDING
    POSTED
  }

  enum CREDIT_TRANSACTION_STATE {
    ALL
    CLEARED
    COMPLETION
    DECLINED
    ERROR
    PENDING
  }

  enum CREDIT_TRANSACTION_GROUP {
    PURCHASE
    INTERNAL
    FEE
    REWARD
    INTEREST
    PAYMENT
    ADJUSTMENT
    BALANCE_TRANSFER
    CASH_ADVANCE
  }

  input CreditTransactionsFilters {
    startDate: String
    endDate: String
    amount: String
    description: String
    statuses: [String]
    groups: [String]
    card_tokens: [String]
    user_tokens: [String]
  }

  type CreditTransactionDetailObjectPos {
    pan_entry_mode: String
  }

  type PaymentDetail {
    method: String
  }

  type CreditTransactionDetailObject {
    card_acceptor: CardAcceptor
    state: CREDIT_TRANSACTION_STATE
    fee: Float
    value: Float
    method: String
    appliedToAmount: Float
    pos: CreditTransactionDetailObjectPos
    phone: String
    statementToken: String
    statementOpeningDate: String
    statementClosingDate: String
    statementBalance: Float
    averageDailyBalance: Float
    gotoApr: Float
    dailyPeriodicRate: Float
    daysInBillingCycle: Float
    interestAmount: Float
    payment: PaymentDetail
    paymentSourceToken: String
  }

  type CreditTransaction {
    token: ID
    id: ID
    relatedToken: String
    accountToken: String
    userToken: String
    cardToken: String
    computedStatus: String
    status: CREDIT_TRANSACTION_STATUS
    group: CREDIT_TRANSACTION_GROUP
    type: String
    transactionId: String
    amount: Float
    currencyCode: String
    memo: String
    requestTime: String
    createdTime: String
    detailToken: String
    detailUrl: String
    detailObject: CreditTransactionDetailObject

    transactionTime: String

    creditAccount: CreditAccount
    card: Card
  }

  ${Yp("CreditTransaction")}
`, Kp = Qi`
    creditTransactions(
        accountToken: ID!
        hasGranularPermission: Boolean
        filters: CreditTransactionsFilters,
        ${Vp}
    ): CreditTransactionCollection
    creditTransaction(
      token: String!,
      accountToken: String!
      isSupportAgent: Boolean!,
      hasGranularPermission: Boolean
    ): CreditTransaction
`;
var zp = { types: Wp, queries: Kp };
const { gql: Ji } = e, { paginationParams: jp, generateCollectionType: Qp } = r, Jp = Ji`
  type CreditUser {
    firstName: String
    lastName: String
    phoneNumber: String
    emailAddress: String
    userToken: String
  }

  input CreditUserFilters {
    user_first_name: String
    user_last_name: String
    user_phone_number: String
    user_email: String
    user_tokens: String
  }

  ${Qp("CreditUser")}
`, Zp = Ji`
  creditUsers(
    start_index: String,
    filters: CreditUserFilters,
    ${jp}
  ): CreditUserCollection
  
`;
var Xp = { types: Jp, queries: Zp };
const { gql: Zi } = e, { generateCollectionType: em } = r, tm = Zi`
  type CreditUserAccounts {
    token: String
    isPrimary: Boolean
  }
  
  type CreditUserDetails {
    token: String
    firstName: String
    lastName: String
    email: String
    phone: String
    address1: String
    address2: String
    city: String
    state: String
    country: String
    zip: String
    creditAccounts: [CreditUserAccounts]
  }
  ${em("CreditUserDetails")}
`, nm = Zi`
  creditUserDetails(
    user_token: String,
  ): CreditUserDetails
 
`;
var im = { types: tm, queries: nm };
const { gql: Xi } = e, rm = Xi`
  type CreditDelinquencyBucket {
    bucketNumber: Int
    paymentDueDate: String
    pastDueCarriedForward: Float
    currentDue: Float
    totalDue: Float
    daysPastDue: Int
  }

  type CreditDelinquencyState {
    accountToken: String
    isDelinquent: Boolean
    dateAccountDelinquent: String
    dateAccountCurrent: String
    totalDaysPastDue: Int
    totalPastDue: Float
    currentDue: Float
    totalDue: Float
    buckets: [CreditDelinquencyBucket]
  }
`, am = Xi`
  creditDelinquencyState(accountToken: String!): CreditDelinquencyState
`;
var om = { types: rm, queries: am };
const sm = /* @__PURE__ */ B(ga), { gql: er } = e, cm = sm, _m = er`

enum CurrencyCode {
  ${cm.codes().join(`
`)}
}
`, dm = er`
  currencyCodes: [CurrencyCode]!
`;
var lm = { types: _m, queries: dm };
const { gql: tr } = e, um = tr`
  type CustomerDueDiligence {
    token: ID!
    account_token: ID
    bank: String
    question: String
    answer: String
    type: String
  }
`, gm = tr`
  customerDueDiligence(
    account_token: ID!,
  ): [CustomerDueDiligence]
`;
var pm = { types: um, queries: gm };
const { gql: nr } = e, { paginationParams: ir, generateCollectionType: mm } = r, Sm = nr`
  type TokenServiceProvider {
    token_reference_id: String
    pan_reference_id: String
    correlation_id: String
    token_requestor_id: String
    token_requestor_name: String
    token_type: String
    token_pan: String
    token_expiration: String
    token_score: String
    token_assurance_level: String
    token_eligibility_decision: String
  }

  type Device {
    token: String
    type: String
    language_code: String
    device_id: String
    phone_number: String
    name: String
    location: String
    ip_address: String
  }

  type WalletProviderProfile {
    account: WalletAccount
    risk_assessment: RiskAssessment
    device_score: String
    pan_source: String
    reason_code: String
  }

  type DigitalWalletToken {
    token: ID
    card: Card
    card_token: String
    created_time: String
    last_modified_time: String
    state: String
    state_reason: String
    fulfillment_status: String
    issuer_eligibility_decision: String
    token_service_provider: TokenServiceProvider
    device: Device
    wallet_provider_profile: WalletProviderProfile
    address_verification: WalletAddressVerification
    transitions(${ir}): DigitalWalletTokenTransitionCollection
  }

  ${mm("DigitalWalletToken")}
`, ym = nr`
  digitalWalletToken(token: ID!): DigitalWalletToken
  digitalWalletTokenShowTokenPan(token: ID!): DigitalWalletToken
  cardDigitalWalletTokens(
    card_token: ID!
    ${ir}
  ): DigitalWalletTokenCollection
`;
var Cm = { types: Sm, queries: ym };
const { gql: rr } = e, { paginationParams: Tv, generateCollectionType: Tm } = r, Im = rr`
  type DigitalWalletTokenTransition implements AbstractTransition {
    token: ID!
    digital_wallet_token: DigitalWalletToken
    card_swap: CardSwap
    type: String
    channel: String
    state: String
    fulfillment_status: String
    reason: String
    reason_code: String
    created_time: String
    last_modified_time: String
  }

  ${Tm("DigitalWalletTokenTransition")}
`, fm = rr`
  createDigitalWalletTokenTransition(
    token: ID 
    reason_code: String!
    token_reference_id: String
    channel: String
    digital_wallet_token: ID!
    state: String!
    reason: String
    override_tsp_error: Boolean
  ) : DigitalWalletTokenTransition
`;
var Dm = { types: Im, mutations: fm };
const { gql: $t } = e, { paginationParams: Am, generateCollectionType: km } = r, hm = $t`
  type DirectDepositAccount {
    token: ID!
    user_token: ID
    business_token: ID
    account_number: String
    routing_number: String
    state: String
    allow_immediate_credit: Boolean
    created_time: String
    last_modified_time: String
    type: String
    customer_due_diligence: [CustomerDueDiligence]
    gpa_balance: AccountBalance
    available_balance: Float
    currency_code: String
  }

  type AccountBalance {
      currency_code: String
      ledger_balance: Float
      available_balance: Float
      credit_balance: Float
      pending_credits: Float
  }
    
  type GPABalance {
  gpa: AccountBalance
  }

  ${km("DirectDepositAccount")}
`, Em = $t`
  createDirectDepositAccount(
    token: ID
    user_token: ID
    business_token: ID
    type: String
    allow_immediate_credit: Boolean
  ): DirectDepositAccount
`, $m = $t`
  directDepositAccount(
    token: ID!
  ): DirectDepositAccount
  directDepositAccounts(
    user_token: ID,
    business_token: ID,
    type: String,
    ${Am},
  ): DirectDepositAccountCollection
  directDepositAccountUser(
    ach_account: String!
  ): Cardholder
  directDepositAccountBalance(
    token: ID!
  ): GPABalance
`;
var Pm = { types: hm, queries: $m, mutations: Em };
const { gql: Pt } = e, { paginationParams: vm, generateCollectionType: Rm } = r, bm = Pt`
  type DirectDepositAccountTransition {
    token: ID!
    account_token: ID!
    state: String!
    channel: String!
    reason: String
    user_token: String
    business_token: String
    created_time: String
  }

  ${Rm("DirectDepositAccountTransition")}
`, Nm = Pt`
  directDepositAccountsTransitions(
    user_token: ID!,
    ${vm},
  ): DirectDepositAccountTransitionCollection
`, Bm = Pt`
  createDirectDepositAccountTransition(
    token: ID
    account_token: ID!
    state: String!
    reason: String
  ): DirectDepositAccountTransition
`;
var Om = { types: bm, queries: Nm, mutations: Bm };
const { gql: ar } = e, { generateCollectionType: Fm } = r, wm = ar`
  type DirectDepositRecord {
    token: ID!
    amount: String!
    business_token: ID
    company_discretionary_data: String
    company_entry_description: String
    company_identification: String
    company_name: String
    created_time: String
    direct_deposit_account_token: ID!
    individual_identification_number: String
    individual_name: String
    last_modified_time: String
    settlement_date: String
    standard_entry_class_code: String
    state_reason_code: String
    state_reason: String
    state: String!
    type: String!
    user_token: ID
  }

  ${Fm("DirectDepositRecord")}
`, qm = ar`
  directDepositRecord(token: ID!): DirectDepositRecord
`;
var Mm = { types: wm, queries: qm };
const { gql: vt } = e, { paginationParams: Um, generateCollectionType: Lm } = r, xm = vt`
  type DirectDepositTransition implements AbstractTransition {
    channel: String
    created_time: String
    direct_deposit_token: ID
    last_modified_time: String
    reason: String
    reason_code: String
    state: String
    token: ID!
    transaction_token: String
  }

  ${Lm("DirectDepositTransition")}
`, Gm = vt`
  createDirectDepositTransition(
    channel: String!
    direct_deposit_token: ID!
    reason: String!
    reason_code: String!
    state: String!
    token: ID
  ): DirectDepositTransition
`, Hm = vt`
  directDepositTransitions(
    ${Um}
  ): DirectDepositTransitionCollection
`;
var Vm = { types: xm, mutations: Gm, queries: Hm };
const { gql: Rt } = e, { paginationParams: Ym, generateCollectionType: Wm } = r, Km = Rt`
  type Director {
    token: String
    active: Boolean
    first_name: String
    middle_name: String
    last_name: String
    address: Address
    email: String
    phone: String
    birth_date: String
    identifications: [Identification]
    title: String
    nationality: String
    place_of_birth: String
    last_modified_time: String
    created_time: String
  }

  type DirectorIdentifications {
    ssn: String
    nin: String
    sin: String
    tin: String
  }

  ${Wm("Director")}
`, zm = Rt`
  directors(
    ${Ym}
    business_token: String!
  ): DirectorCollection
  director(
    business_token: String!
    director_token: String!
  ): Director
  directorIdentifications(
    business_token: String!
    director_token: String!
    full_ssn: Boolean
  ): DirectorIdentifications
`, jm = Rt`
  createBusinessDirector(
    business_token: String!
    active: Boolean
    first_name: String
    middle_name: String
    last_name: String
    address: AddressInput
    email: String
    phone: String
    birth_date: String
    identifications: [IdentificationInput]
    title: String
    nationality: String
    place_of_birth: String
  ): Director
  updateBusinessDirector(
    business_token: String!
    token: String
    active: Boolean
    first_name: String
    middle_name: String
    last_name: String
    address: AddressInput
    email: String
    phone: String
    birth_date: String
    identifications: [IdentificationInput]
    title: String
    nationality: String
    place_of_birth: String
  ): Director
`;
var Qm = { types: Km, queries: zm, mutations: jm };
const { gql: bt } = e, { generateCollectionType: Jm } = r, Zm = bt`
  type DisputeTransition {
    case_token: ID!
    # String type for flexibility; reference enum DISPUTE_TRANSITION_ACTION
    action: String
    created_by: String
    created_time: String
    last_modified_time: String
    memo: String
    from_network_status: String
    to_network_status: String
    network_dispute_id: String
    network_details: NetworkDetails
    system_error_message: String
    network_error_message: String
  }

  type NetworkDetails {
    dispute_transition_token: ID
    arbitration_details: ArbitrationDetails
    case_close_details: CaseCloseDetails
    prearbitration_details: PrearbitrationDetails
    representment_details: RepresentmentDetails
    prearbitration_response_details: PrearbitrationResponseDetails
    network_state_details: NetworkStateDetails
    dispute_state: String
    created_time: String
    network_attached_contents: [ID]
  }

  input NetworkDetailsInput {
    arbitration_details: ArbitrationDetailsInput
    case_close_details: CaseCloseDetailsInput
    prearbitration_details: PrearbitrationDetailsInput
    representment_details: RepresentmentDetailsInput
    prearbitration_response_details: PrearbitrationResponseDetailsInput
    dispute_state: String
    created_time: String
  }

  type ArbitrationDetails {
    attached_contents: [ID]
  }

  type CaseCloseDetails {
    write_off: Boolean
    write_off_actor: String
  }

  input RepresentmentDetailsInput {
    amount: Float
    attached_contents: [ID]
  }

  input PrearbitrationResponseDetailsInput {
    amount: Float
    prearb_response_decision: String
    partial_acceptance_amount: Float
    why_are_you_not_accepting_liability: String
    certify_that_cardholder_continues_dispute: Boolean
    explanation_cardholder_continues_dispute: String
    certify_cardholder_details_dont_match_issuer_records: Boolean
    explanation_continuing_the_dispute: String
    attached_contents: [ID]
  }
  type PrearbitrationResponseDetails {
    amount: Float
    prearb_response_decision: String
    partial_acceptance_amount: Float
    why_are_you_not_accepting_liability: String
    certify_that_cardholder_continues_dispute: Boolean
    explanation_cardholder_continues_dispute: String
    certify_cardholder_details_dont_match_issuer_records: Boolean
    explanation_continuing_the_dispute: String
    attached_contents: [ID]
  }

  type RepresentmentDetails {
    amount: Float
    attached_contents: [ID]
  }

  input ArbitrationDetailsInput {
    attached_contents: [ID]
  }

  input CaseCloseDetailsInput {
    write_off: Boolean
    write_off_actor: String
  }

  type PrearbitrationDetails {
    attached_contents: [ID]
    amount: String
    why_are_you_initiating_prearbitration: String
    are_you_providing_new_information: Boolean
    summary_of_new_information: String
    filed_against_ica: String
    filing_ica: String
    network_memo: String
    merchant_name: String
    comment: String
    # String type for flexibility; reference enum PREARBITRATION_RESPONSE_DECISION
    prearbitration_response_decision: String
    why_are_you_not_accepting_liability: String
    certify_that_you_have_contacted_cardholder_and_reviewed_the_compelling_evidence_with_them_and_cardholder_continues_dispute: Boolean
    explanation_of_why_cardholder_continues_dispute: String
    certify_that_cardholder_name_and_address_provided_by_acquirer_does_not_match_issuer_records: Boolean
    explanation_of_why_you_are_continuing_the_dispute: String
  }

  input PrearbitrationDetailsInput {
    attached_contents: [ID]
    amount: String
    why_are_you_initiating_prearbitration: String
    are_you_providing_new_information: Boolean
    summary_of_new_information: String
    filed_against_ica: String
    filing_ica: String
    network_memo: String
    merchant_name: String
    comment: String
    # String type for flexibility; reference enum PREARBITRATION_RESPONSE_DECISION
    prearbitration_response_decision: String
    why_are_you_not_accepting_liability: String
    certify_that_you_have_contacted_cardholder_and_reviewed_the_compelling_evidence_with_them_and_cardholder_continues_dispute: Boolean
    explanation_of_why_cardholder_continues_dispute: String
    certify_that_cardholder_name_and_address_provided_by_acquirer_does_not_match_issuer_records: Boolean
    explanation_of_why_you_are_continuing_the_dispute: String
  }

  # This object originates from Card networks and will follow non-Marqetan API standards.
  type NetworkStateDetails {
    # GENERAL OR RE-USED
    issuer_acquirer_contact_info: IssuerAcquirerContactInfo
    recall_ind: Boolean
    liability_not_accepted_fully: String
    dispute_amount: AmountObject

    # VISA PRE-ARB
    dispute_amount_change_ind: String
    initiate_pre_arb_reason: String
    dispute_invalid_reason: String
    not_listed_dispute_invalid_reason: String

    # VISA ARB
    requesting_member_bin: String
    requestor_name: String
    opposer_member_bin: String
    opposer_name: String
    case_filing_amount: AmountObject
    comments: String
    appeal_ind: Boolean
    filing_reason: String

    # VISA REPRESENTMENT
    exception_cpd: String
    dispute_response: String
    acceptance_amount: AmountObject
    dispute_response_reason: String

    # VISA PRE-ARB RESPONSE
    pre_arb_response: String
    comp_evidence_ip_address_ind: Boolean
    comp_evidence_email_address_ind: Boolean
    comp_evidence_physical_address_ind: Boolean
    comp_evidence_phone_number_ind: Boolean
    comp_evidence_cust_acc_login_id_ind: Boolean
    comp_evidence_device_id_fingerprinting_ind: Boolean
    merchandise_or_services: MerchandiseOrServices
    merchandise_or_services_desc: String
    shipping_delivery_status: String
    merchandise_or_services_provided_date: String
    disputed_transaction: DisputedTransaction
    undisputed_transactions: [UndisputedTransaction]

    # MASTERCARD SECOND PRESENTMENT
    reason_code: String
    member_message_text: String
    status: String
    creation_date: String
    source_amount: String
    currency_conversion_assessment_cca_included: String
    currency_conversion_assessment_cca_amount: String
    document_indicator: String
    chargeback_reference_number: String
    reject_reason: String

    # MASTERCARD CASE FILING
    case_filing_id: String
    case_type: String
    case_status: String
    filling_ica: String
    filed_against_ica: String
    case_filing_status: String
    merchant_name: String
  }

  type AmountObject {
    value: String
    currency: String
  }

  type DisputedTransaction {
    device_id_details: String
    device_fingerprinting_details: String
    device_type_details: String
    ip_address_details: String
    customer_account_login_id_details: Boolean
    delivery_address_details: DeliveryAddressDetails
  }

  type DeliveryAddressDetails {
    address: String
    address2: String
    city: String
    state_region: String
    postal_code: String
    country: String
  }

  type UndisputedTransaction {
    historical_tran_amount: String
    historical_tran_date: String
    historical_transaction_id: String
    historical_ARN: String
    rol_transaction_id: String
    merchandise_or_services_desc: String
    device_id_details: String
    device_fingerprinting_details: String
    device_type_details: String
    ip_address_details: String
    customer_account_login_id_details: String
    delivery_address_details: DeliveryAddressDetails
  }

  type IssuerAcquirerContactInfo {
    contact_name: String
    contact_phone: String
    contact_other: String
    contact_email: String
  }

  enum MerchandiseOrServices {
    NS
    B
    IT
    PS
    S
    C
    SE
    P
    O
    D
  }

  ${Jm("DisputeTransition")}
`, Xm = bt`
  disputeTransitions(case_token: ID!): DisputeTransitionCollection
`, eS = bt`
  createDisputeTransition(
    case_token: ID!
    action: String
    created_by: String
    memo: String
    network_details: NetworkDetailsInput
    withWriteOff: Boolean
  ): DisputeTransition
`;
var tS = { types: Zm, queries: Xm, mutations: eS };
const { gql: or } = e, { paginationParams: nS, generateCollectionType: iS } = r, rS = or`
  type DNABank {
    token: ID!
    active: Boolean
    name: String
    created_time: String
    last_modified_time: String
  }
  ${iS("DNABank")}
`, aS = or`
  dnaBank(token: ID!): DNABank
  dnaBanks(${nS}): DNABankCollection
`;
var oS = { types: rS, queries: aS };
const { gql: Nt } = e, { paginationParams: Ln, generateCollectionType: sS } = r, cS = Nt`
  type DNACustomer {
    token: ID!
    active: Boolean
    name: String
    created_time: String
    last_modified_time: String
    stage: String
  }

  type DnaDirectDeposit {
    account_number_length: Int
    account_number_prefix: String
    deny_debit: Boolean
    process_file: Boolean
    routing_number: String
  }

  type DnaAchOriginationAccount {
    account_number: String
    routing_number: String
  }

  type DnaAch {
    cut_off_hour: Int
    cut_off_timezone: String
    instant_funding: Boolean
    origination_account: DnaAchOriginationAccount
    origination_enabled: Boolean
    timezone: String
    verification_api_enable: Boolean
    verification_max_attempt: Int
    wait_period_days: Int
  }

  type DnaPtc {
    ptc_enabled: Boolean
    ptc_merchant_id: String
    ptc_sub_client_id: String
  }

  type DnaPlaid {
    processor_auth_enabled: Boolean
    processor_balance_enabled: Boolean
    processor_balance_cache_ttl_seconds: String
  }
  
  type DnaBillPay {
    service_enabled: Boolean
  }

  type DNAProgram {
    ach: DnaAch
    active: Boolean
    auth_control_default: String
    auth_expiration_days: Int
    bank: DNABank
    created_time: String
    customer: DNACustomer
    direct_deposit: DnaDirectDeposit
    last_modified_time: String
    long_code: String
    marqeta_js_enabled: Boolean
    name: String
    parent_max_children: Int
    pin_create_reject_weak: Boolean
    plaid: DnaPlaid
    processor_only: Boolean
    ptc: DnaPtc
    program_id: ID
    short_code: String
    solution: String
    token: ID!
    uai_prefix: String
    regime: String
    bill_pay: DnaBillPay
  }
  ${sS("DNAProgram")}
`, _S = Nt`
  currentDNAProgram: DNAProgram
  dnaProgram(token: ID!): DNAProgram
  dnaProgramByHeaderShortCode: DNAProgram
  dnaPrograms(short_code: String, ${Ln}): DNAProgramCollection
  dnaProgramsRestricted(short_code: String, ${Ln}, programs: [String]): DNAProgramCollection
`, dS = Nt`
  updateCurrentDnaProgramDirectDeposit(
    routing_number: String
    account_number_prefix: String
  ): DNAProgram
`;
var lS = { types: cS, queries: _S, mutations: dS };
const { gql: Bt } = e, { paginationParams: uS, generateCollectionType: gS } = r, xn = `
  templateToken: String
  templateUrls: DocumentPolicyTemplateUrls
  templateCreatedTime: String
`, Gn = `
  assetToken: String
  assetUrls: DocumentPolicyAssetUrls
  assetCreatedTime: String
`, pS = Bt`  
  input DocumentPolicyTemplateInput {
    templateToken: String
  }

  input DocumentPolicyAssetInput {
    assetToken: String
  }

  input DocumentPolicyTemplateAndAssetInput {
    templateToken: String
    assetToken: String
  }

  type DocumentPolicyTemplateUrls {
    html: String
  }
  
  type DocumentPolicyAssetUrls {
    png: String
    pdf: String
    html: String
  }

  type DocumentPolicyTemplate {
    ${xn}
  }

  type DocumentPolicyAsset {
    ${Gn}
  }
  
  type DocumentPolicyTemplateAndAsset {
    ${xn}
    ${Gn}
  }

  type DocumentPolicy {
    token: String
    name: String
    summaryOfCreditTerms: DocumentPolicyTemplateAndAsset
    rewardsDisclosure: DocumentPolicyTemplateAndAsset
    termsSchedule: DocumentPolicyTemplate
    benefitsDisclosurePremium: DocumentPolicyAsset
    benefitsDisclosureTraditional: DocumentPolicyAsset
    privacyPolicy: DocumentPolicyAsset
    eDisclosure: DocumentPolicyAsset
    cardMemberAgreement: DocumentPolicyAsset
    accountStatement: DocumentPolicyTemplate
    noaaSingleReason: DocumentPolicyTemplate
    noaaSingleReasonWithDoddFrank: DocumentPolicyTemplate
    noaaMultipleReasonWithDoddFrank: DocumentPolicyTemplate
    createdTime: String
    updatedTime: String
  }

  ${gS("DocumentPolicy")}
`, mS = `
    token: ID
    name: String!
    summaryOfCreditTerms: DocumentPolicyTemplateAndAssetInput!
    rewardsDisclosure: DocumentPolicyTemplateAndAssetInput
    termsSchedule: DocumentPolicyTemplateInput!
    benefitsDisclosurePremium: DocumentPolicyAssetInput!
    benefitsDisclosureTraditional: DocumentPolicyAssetInput!
    privacyPolicy: DocumentPolicyAssetInput!
    eDisclosure: DocumentPolicyAssetInput!
    cardMemberAgreement: DocumentPolicyAssetInput!
    accountStatement: DocumentPolicyTemplateInput!
    noaaSingleReason: DocumentPolicyTemplateInput!
    noaaSingleReasonWithDoddFrank: DocumentPolicyTemplateInput!
    noaaMultipleReasonWithDoddFrank: DocumentPolicyTemplateInput!
`, SS = Bt`
    documentPolicy(token: ID!): DocumentPolicy
    documentPolicies(${uS}): DocumentPolicyCollection
`, yS = Bt`
    documentPolicyCreate(${mS}): DocumentPolicy
`;
var CS = { types: pS, queries: SS, mutations: yS };
const { gql: sr } = e, { paginationParams: TS, generateCollectionType: IS } = r, fS = sr`
  type ExemptMid {
    token: ID
    name: String
    mid: String
    merchant_group_token: String
    active: Boolean
    created_time: String
    last_modified_time: String
    association: Association
  }

  ${IS("ExemptMid")}
`, DS = sr`
  exemptMids(
    user: ID,
    card_product: ID,
    ${TS},
  ): ExemptMidCollection
`;
var AS = { types: fS, queries: DS };
const { gql: Ot } = e, { paginationParams: kS, generateCollectionType: hS } = r, ES = Ot`
  enum FEE_DEFAULT_METHOD {
    FLAT
  }

  enum PERCENTAGE_DEFAULT_METHOD {
    PERCENTAGE
  }

  input FeePolicyAccountTypeInput {
    defaultMethod: FEE_DEFAULT_METHOD
    defaultValue: Float
  }

  type FeePolicyAccountType {
    defaultMethod: FEE_DEFAULT_METHOD
    defaultValue: Float
  }

  input ForeignTransactionFeePolicyAccountTypeInput {
    defaultMethod: PERCENTAGE_DEFAULT_METHOD
    defaultValue: Float
  }

  type ForeignTransactionFeePolicyAccountType {
    defaultMethod: PERCENTAGE_DEFAULT_METHOD
    defaultValue: Float
  }

  input FeePolicyPeriodicTypeInput {
      feeAmount: Float
      numberOfDaysPostActivation: Int
      excludeFromInterestCalculation: Boolean
  }

  type FeePolicyPeriodicType {
      feeAmount: Float
      numberOfDaysPostActivation: Int
      excludeFromInterestCalculation: Boolean
  }

  input FeePolicyAccountInput {
    latePayment: FeePolicyAccountTypeInput
    returnedPayment: FeePolicyAccountTypeInput
    monthlyFee: FeePolicyPeriodicTypeInput
    annualFee: FeePolicyPeriodicTypeInput
    foreignTransactionFee: ForeignTransactionFeePolicyAccountTypeInput
  }

  type FeePolicyAccount {
    latePayment: FeePolicyAccountType
    returnedPayment: FeePolicyAccountType
    monthlyFee: FeePolicyPeriodicType
    annualFee: FeePolicyPeriodicType
    foreignTransactionFee: ForeignTransactionFeePolicyAccountType
  }

  type FeePolicy {
    token: String
    name: String
    description: String
    account: FeePolicyAccount
    purchases: String
    createdTime: String
    updatedTime: String
  }

  ${hS("FeePolicy")}
`, $S = `
    token: ID
    name: String!
    description: String
    account: FeePolicyAccountInput!
    purchases: String
`, PS = `
    token: ID!
    name: String!
    description: String
    account: FeePolicyAccountInput!
    purchases: String
`, vS = Ot`
    feePolicy(token: ID!): FeePolicy
    feePolicies(${kS}): FeePolicyCollection
`, RS = Ot`
    feePolicyCreate(${$S}): FeePolicy
    feePolicyClone(token: ID!): FeePolicy
    feePolicyUpdate(${PS}): FeePolicy
`;
var bS = { types: ES, queries: vS, mutations: RS };
const { gql: cr } = e, { paginationParams: NS, generateCollectionType: BS } = r, OS = cr`
  type Fee {
    token: String
    active: Boolean
    memo: String
    name: String
    amount: String
    tags: String
    currency_code: String
    real_time_assessment: RealTimeAssessment
  }
  ${BS("Fee")}
`, FS = cr`
  fees(${NS}): FeeCollection
`;
var wS = { types: OS, queries: FS };
const { gql: qS } = e, MS = qS`
  type File {
    filename: String
    file: String
    mimetype: String
    ID: String
  }

  input FileInput {
    filename: String
    file: String
    mimetype: String
  }
`;
var US = { types: MS };
const { gql: Ft } = e, { paginationParams: LS, generateCollectionType: xS } = r, GS = Ft`
  type TemplateUploadUrl {
    token: String
    signedUploadUrl: String
  }

  type FileTemplateSignedUrl {
    html: String
    png: String
    zip: String
  }

  type FileTemplate {
    token: ID
    description: String
    createdTime: String
    shortCode: String
    state: String
    name: String
    signedUrl: FileTemplateSignedUrl
    referenceGroup: String
  }

  ${xS("FileTemplate")}
`, HS = `
  referenceGroups: String!
  aggregatedBy: String
`, VS = `
  token: String!,
  name: String!,
  description: String,
  referenceToken: String,
  referenceGroup: String
`, YS = Ft`
  upload: TemplateUploadUrl
  templates(${HS}, ${LS}): FileTemplateCollection
`, WS = Ft`
  templateCreate(${VS}): FileTemplate
`;
var KS = { types: GS, queries: YS, mutations: WS };
const { gql: wt } = e, { paginationParams: Iv, generateCollectionType: zS } = r, jS = wt`
  enum FileTemplateAssetState {
    PENDING
    RENDERED
    FAILED
  }

  type FileTemplateAssetSignedUrl {
    html: String
    pdf: String
    png: String
  }

  type FileTemplateAsset {
    token: ID
    templateToken: String
    referenceToken: String
    referenceGroup: String
    shortCode: String
    hash: String
    state: FileTemplateAssetState
    signedUrl: FileTemplateAssetSignedUrl
    createdTime: String
  }

  ${zS("FileTemplateAsset")}
`, QS = `
        token: ID
        templateToken: String!
        referenceToken: String!
        referenceGroup: String
        values: String!
`, JS = wt`
    fileTemplateAsset(token: ID!): FileTemplateAsset
    fileAssetsByToken(tokens: [String]!): FileTemplateAssetCollection
    fileTemplateAssets(referenceGroups: [String], aggregatedBy: String): FileTemplateAssetCollection
`, ZS = wt`
    fileTemplateAssetCreate(${QS}): FileTemplateAsset
`;
var XS = { types: jS, queries: JS, mutations: ZS };
const { gql: _r } = e, ey = _r`
  type FraudHealth {
    account_risk_score: String
    actingcardholder: String
    amount: String
    ca_country: String
    ca_name: String
    ca_region: String
    ca_zip: String
    card: String
    cardholder: String
    cardtoken: String
    currencycode: String
    date: String
    dateday: String
    duration: String
    fraud_model: String
    fraud_score_reasons: String
    fraudstream_message: String
    fraudstream_score: String
    hour: String
    insertion_time: String
    itc: String
    mcc: String
    prg_name: String
    rc: String
    recommended_action: String
    ref_id: String
    rule_violations: String
    tc_id: String
    tc_token: String
    tl_id: String
    transaction_risk_score: String
    transaction_risk_score_reason_code: String
    transaction_risk_score_reason_description: String
    transactionstate: String
    transactiontype: String
    tt_token: String
  }
`, ty = _r`
  fraudHealthData: [FraudHealth]
`;
var ny = { types: ey, queries: ty };
const { gql: qt } = e, { paginationParams: iy, generateCollectionType: ry } = r, ay = qt`
  type FulfillmentProvider {
    token: ID!
    active: Boolean
    name: String
    created_time: String
    last_modified_time: String
  }

  ${ry("FulfillmentProvider")}
`, oy = qt`
  fulfillmentProvider(token: ID!): FulfillmentProvider
  fulfillmentProviders(
    ${iy},
    active: Boolean,
    name: String,
    token: ID,
  ): FulfillmentProviderCollection
`, sy = qt`
  createFulfillmentProvider(
    active: Boolean,
    name: String!,
  ): FulfillmentProvider
  updateFulfillmentProvider(
    token: ID!,
    active: Boolean,
    name: String,
  ): FulfillmentProvider
`;
var cy = { types: ay, queries: oy, mutations: sy };
const { gql: dr } = e, { paginationParams: _y, generateCollectionType: dy } = r, ly = dr`
  type FulfillmentProviderV2 {
    token: ID!
    active: Boolean
    created_time: String
    last_modified_time: String
    name: String
    long_name: String
    fulfillment_processing_schedule: String
    fulfillment_processing_cutoff_time: String
    fulfillment_file_spec_version: String
    encoding_format: String
    strict_emboss_enabled: Boolean
    pgp_signature_option: String
    confirmation_report_sftp_path: String
  }

  ${dy("FulfillmentProviderV2")}
`, uy = dr`
  fulfillmentProviderV2(token: ID!): FulfillmentProviderV2
  fulfillmentProvidersV2(
    ${_y},
    active: Boolean,
    name: String,
    token: ID,
  ): FulfillmentProviderV2Collection
`;
var gy = { types: ly, queries: uy };
const { gql: lr } = e, py = lr`
  type FundingAccountBalance implements AbstractBalance {
    currency_code: String
    ledger_balance: Float
    available_balance: Float
    credit_balance: Float
    pending_credits: Float
    balances: BalanceByCurrency
  }
`, my = lr`
  fundingAccountBalance: FundingAccountBalance
  fundingAccountBalanceGranular: FundingAccountBalance
`;
var Sy = { types: py, queries: my };
const { gql: ur } = e, yy = ur`
  type GLTransaction {
    token: ID!
    type: String
    reference_id: Int
    mcc_group: String
    transaction_date: String
    amount: Int
    currency_code: String
    response_code: String
    response_type: String
    response_text: String
  }
  enum GLEntryType {
    CREDIT
    DEBIT
  }
  input GLTransactionInput {
    itc: String
    entries: [GLEntry]
    cardholder_visible: Boolean
    trigger_webhook: Boolean
    attributes: String
  }
  input GLEntry {
    amount: Float
    layer: String
    type: String
    account: String
  }
`, Cy = ur`
  createGLTransactions(
    transactions: [GLTransactionInput]!
  ): [GLTransaction]
`;
var Ty = { types: yy, mutations: Cy };
const { gql: Mt } = e, { generateCollectionType: Ge, paginationParams: Iy } = r, fy = Mt`
  type HSMKey {
    programShortcode: String
    keyName: String
    network: String
    keyType: String
    keyUnderLmk: String
    keyUnderZmk: String
    keyCheckValue: String
    createdTime: String
    updatedTime: String
  }

  type ZMKNetwork {
    keyName: String
  }

  type ZMKProvider {
    keyName: String
  }

  enum CryptoKeyTypes {
    AC
    CVK
    SMI
    SMC
    ZPK
  }

  input ProviderHSMKeysToGenerate {
    providerZmkKeyName: String
    keyTypes: [CryptoKeyTypes]
  }

  input NetworkHSMKeysToGenerate {
    networkZmkKeyName: String
    keyTypes: [CryptoKeyTypes]
  }

  ${Ge("HSMKey")}
  ${Ge("ZMKNetwork")}
  ${Ge("ZMKProvider")}
`, Dy = Mt`
    hsmKeys(${Iy}): HSMKeyCollection
    ZMKNetworks: ZMKNetworkCollection
    ZMKProviders: ZMKProviderCollection
`, Ay = Mt`
    assignHSMKeys(
      providerHSMKeysToGenerate: ProviderHSMKeysToGenerate
      networkHSMKeysToGenerate: NetworkHSMKeysToGenerate
    ): HSMKeyCollection
`;
var ky = { types: fy, queries: Dy, mutations: Ay };
const { gql: Ut } = e, { generateCollectionType: He } = r, hy = Ut`
  enum InventorySKUType {
    CARRIER
    TERMS_AND_CONDITIONS
    ENVELOPE
    ACTIVATION_LABEL
    JHOOK
    INSERT
    CARD_STOCK
    SHIPPING_INSERT
  }

  enum InventoryTransactionType {
    JOB
    ADJUSTMENT
    SCRAP
    RECEIPT
    COUNT
  }

  type InventoryCardPackage {
    token: ID!
    provider_id: String
    external_token: String
    is_active: String
    description: String
    inventorySkus: InventorySKUCollection
  }

  type InventorySKU {
    token: ID!
    provider_id: String
    external_token: String
    is_active: String
    description: String
    type: InventorySKUType
    created_time: String
    num_incoming: Int
    inventoryTransactions: InventoryTransactionCollection
  }

  type InventoryTransaction {
    token: ID!
    provider_id: String
    external_token: String
    transaction_date: String
    type: InventoryTransactionType
    quantity: Int
    on_hand: Int
  }

  ${He("InventoryCardPackage")}
  ${He("InventorySKU")}
  ${He("InventoryTransaction")}
`, Ey = Ut`
  inventoryCardPackages: InventoryCardPackageCollection
  inventorySkus(cardPackageToken: String!): InventorySKUCollection
  inventoryTransactions(skuToken: String!): InventoryTransactionCollection
`, $y = Ut``;
var Py = { types: hy, queries: Ey, mutations: $y };
const { gql: gr } = e, vy = gr`
  type InventoryAdjustment {
    token: ID!
    amount: Int
    layer: String
    sku: Sku
    reason: String
    created_time: String
    last_modified_time: String
  }
`, Ry = gr`
  createInventoryAdjustment(
    amount: Int!,
    layer: String!,
    sku_token: String!,
    reason: String,
    token: ID,
  ): InventoryAdjustment
`;
var by = { types: vy, mutations: Ry };
const { gql: pr } = e, { paginationParams: Ny, generateCollectionType: By } = r, Oy = pr`
  type InventoryLevel {
    token: ID!
    backordered_count: Int
    ordered_count: Int
    processed_count: Int
    scrapped_count: Int
    shipped_count: Int
    stocked_count: Int
    date: String
    created_time: String
    last_modified_time: String
  }

  ${By("InventoryLevel")}
`, Fy = pr`
  inventoryLevel(
    token: ID!
    sku_token: String!
  ): InventoryLevel
  inventoryLevels(
    ${Ny},
    sku_token: String!
    date: String,
    start_date: String,
    end_date: String,
  ): InventoryLevelCollection
`;
var wy = { types: Oy, queries: Fy };
const { gql: Lt } = e, { paginationParams: qy, generateCollectionType: My } = r, Uy = Lt`
  type InventoryOrder {
    token: ID!
    amount: Int
    sku: Sku
    reason: String
    created_time: String
    last_modified_time: String
  }

  ${My("InventoryOrder")}
`, Ly = Lt`
  inventoryOrder(
    sku_token: String!
    token: ID!
  ): InventoryOrder
  inventoryOrders(
    ${qy},
    sku_token: String!
    amount: Int,
    token: String,
  ): InventoryOrderCollection
`, xy = Lt`
  createInventoryOrder(
    sku_token: String!,
    amount: Int!,
    reason: String,
    token: ID,
  ): InventoryOrder
`;
var Gy = { types: Uy, queries: Ly, mutations: xy };
const { gql: mr } = e, { paginationParams: Hy, generateCollectionType: Vy } = r, Yy = mr`
  type KybLog {
    cardholder_token: ID!
    user_email: String
    timestamp: String
    type: String
    message_title: String
    message: String
    note: String
  }
  ${Vy("KybLog")}
`, Wy = mr`
  kybLog(
    ${Hy},
    cardholder_token: ID!,
  ): KybLogCollection
`;
var Ky = { types: Yy, queries: Wy };
const { gql: xt } = e, zy = xt`
  # KYC types
  enum KYCStatus {
    SUCCESS
    FAILURE
    PENDING
  }

  type KYCCode {
    code: String
    message: String
  }

  type KYCResult {
    status: KYCStatus
    codes: [KYCCode!]
  }

  type KYC {
    created_time: String!
    last_modified_time: String!
    token: ID
    user_token: String
    result: KYCResult
    manual_override: Boolean
    notes: String
    reference_id: String
  }

  # KYB types
  enum KYBStatus {
    SUCCESS
    FAILURE
    PENDING
    VENDOR_PENDING
  }

  enum KYBComponent {
    BUSINESS
    PROPRIETOR
    BENEFICIAL_OWNER1
    BENEFICIAL_OWNER2
    BENEFICIAL_OWNER3
    BENEFICIAL_OWNER4
  }

  type KYBStatusResult {
    status: KYBStatus
  }

  type KYBResult {
    component: KYBComponent
    reference_id: String
    outcome: KYBStatus
    outcome_reasons: [String!]
  }

  type KYB {
    created_time: String!
    last_modified_time: String!
    token: ID!
    business_token: String
    status: KYBStatus
    result: KYBStatusResult
    results: [KYBResult!]
    manual_override: Boolean
    notes: String
    reference_id: String
  }

  type KycReview {
    token: String
  }

  type KycFile {
    filename: String
    getUrl: String
  }
`, jy = xt`
  kycFiles(
    cardholder_token: String!
  ): [KycFile]

  kycUploadUrl(
    cardholder_token: String!
    filename: String!
  ): String

  kybFiles(
    cardholder_token: String!
  ): [KycFile]

  kybUploadUrl(
    cardholder_token: String!
    filename: String!
  ): String
`, Qy = xt`
  createKycReview(
    user_token: String!
  ): KycReview

  performKYC(
    token: String
    notes: String
    manual_override: Boolean
    reference_id: String
    user_token: String!
  ): KYC!

  performKYB(
    token: String
    notes: String
    manual_override: Boolean
    reference_id: String
    business_token: String!
  ): KYB!

`;
var Jy = { types: zy, queries: jy, mutations: Qy };
const { gql: Sr } = e, { paginationParams: Zy, generateCollectionType: Xy } = r, eC = Sr`
  type KycBusiness {
    token: ID!
    created_time: String
    last_modified_time: String
    business_token: String
    result: KycBusinessResult
    manual_override: Boolean
    notes: String
  }

  type KycBusinessResult {
    status: String
    codes: [KycBusinessCode!]
  }

  type KycBusinessCode {
    code: String!
  }

  ${Xy("KycBusiness")}
`, tC = Sr`
  kycBusiness(
    ${Zy},
    business_token: ID!,
  ): KycBusinessCollection
`;
var nC = { types: eC, queries: tC };
const { gql: Gt } = e, iC = Gt`
  type KycReviewDetails {
    token: ID!
    status: String
    last_modified_time: String
    created_time: String
    assignment: KycAssignment
    alert: KycReviewAlert
    available_values: AvailableValuesItem
    disposition: KycDisposition
    notes: [KycReviewNoteItem]
    history: [KycReviewHistoryItem]
    programs: [KycProgramItem]
  }

  type KycAssignment {
    team: String
    marqeta_agent: KycAgent
    customer_agent: KycAgent
    transition_note: String
  }

  type KycAgent {
    token: ID!
    email: String
    first_name: String
    last_name: String
  }

  type KycReviewAlert {
    decision: String
    program_short_code: String
    user_token: String
    business_token: String
    kyc_status: String
    kyc_identity: KycUserDetails
  }

  type KycUserDetails {
    first_name: FullDetail
    middle_name: FullDetail
    last_name: FullDetail
    address1: FullDetail
    address2: FullDetail
    city: FullDetail
    state: FullDetail
    postal_code: FullDetail
    country: FullDetail
    ssn: FullDetail
    birth_date: FullDetail
    ofac: FullDetail
  }

  type FullDetail {
    value: String
    status: String
  }

  type AvailableValuesItem {
    statuses: [String]
    dispositions: [String]
    disposition_reason_codes: [String]
    teams: [String]
    transition_reason_codes: [String]
  }

  type KycDisposition {
    disposition: String
    disposition_reason_codes: [String]
    disposition_note: String
  }

  type KycReviewNoteItem {
    token: ID!
    text: String
  }

  type KycReviewHistoryItem {
    header: String
    body: String
    user_channel: String
    modify_time: String
    modify_user: ModifyUser
  }

  type ModifyUser {
    token: String
    first_name: String
    last_name: String
    email_address: String
  }

  type KycProgramItem {
    short_code: String
    name: String
  }

  type NewTeamDetails {
    review_token: String
    team: String
    transition_reason_codes: [String]
    transition_note: String
  }

  input IdentityCheckPayloadInternal {
    kyc_identity: KycIdentityUploadDetails
    note: String
  }

  input IdentityCheckPayloadCustomer {
    kyc_user: KycUserUploadDetails
    note: String
  }

  input KycUserUploadDetails {
    first_name: String
    middle_name: String
    last_name: String
    address1: String
    address2: String
    city: String
    state: String
    postal_code: String
    country: String
    ssn: String
    birth_date: String
    ofac: String
  }

  input KycIdentityUploadDetails {
    first_name: FullUploadDetail
    middle_name: FullUploadDetail
    last_name: FullUploadDetail
    address1: FullUploadDetail
    address2: FullUploadDetail
    city: FullUploadDetail
    state: FullUploadDetail
    postal_code: FullUploadDetail
    country: FullUploadDetail
    ssn: FullUploadDetail
    birth_date: FullUploadDetail
    ofac: FullUploadDetail
  }

  input FullUploadDetail {
    value: String
    status: String
  }
`, rC = Gt`
  kycReviewDetails(
    reviewToken: ID!
  ): KycReviewDetails
`, aC = Gt`
  changeReviewStatus(
   reviewToken: ID!,
   status: String,
   note: String
  ): KycReviewDetails
  changeReviewTeam(
   reviewToken: ID!,
   transition_note: String,
   transition_reason_codes: [String]
  ): NewTeamDetails
  updateControlPlaneReviewInternal(
    reviewToken:ID!
    updatedEntities:IdentityCheckPayloadInternal
  ): String
  updateControlPlaneReviewCustomer(
    reviewToken:ID!
    updatedEntities:IdentityCheckPayloadCustomer
  ): String
`;
var oC = { types: iC, queries: rC, mutations: aC };
const { gql: sC } = e, cC = sC`
  type KycUserResultOutcomeCode {
    code: String
  }

  type KycUserResultOutcome {
    status: String
    codes: [KycUserResultOutcomeCode]
  }

  type KycUserResult {
    created_time: String
    last_modified_time: String
    token: ID!
    user_token: ID!
    result: KycUserResultOutcome
    manual_override: Boolean
    notes: String
  }

  # Rather than add a one-time-use collection to partials, just do a one-off here
  type KycUserResultCollection implements AbstractCollection {
    data: [KycUserResult]
    count: Int
    start_index: Int
    end_index: Int
    is_more: Boolean
    hasKycMicroservice: Boolean
  }
`;
var _C = { types: cC };
const { gql: yr } = e, dC = yr`
manualTransition(
    case_token: ID!
    payload: ManualTransitionPayload
  ): ManualTransitionResponse
`, lC = yr`
  input ManualTransitionPayload {
    to_case_state: String
    to_dispute_state: String
    to_network_case_state: String
    to_dispute_transition_state: String
    to_case_transition_state: String
    to_chargeback_state: String
    to_chargeback_transition_state: String
    memo: String
  }
  type ManualTransitionResponse {
    case_state: String
    dispute_state: String
    network_case_state: String
    dispute_transition_state: String
    case_transition_state: String
    chargeback_state: String
    chargeback_transition_state: String
    memo: String
  }
`;
var uC = { types: lC, mutations: dC };
const { gql: Ht } = e, { generateCollectionType: gC, paginationParams: pC } = r, mC = Ht`
  type MCCGroup {
    token: ID!
    name: String
    active: Boolean
    mccs: [String]
    mccs_with_names: [MCCsWithName]
    config: MCCGroupConfig
  }

  type MCCsWithName {
    mcc: String
    name: String
  }

  type MCCGroupConfig {
    authorization_controls: MCCAuthorizationControls
  }

  type MCCAuthorizationControls {
    hold_increase: HoldIncrease
    hold_expiration_days: Int
  }

  type MCCList {
    mcc: String
    name: String
  }

  input HoldIncreaseInput {
    type: String
    value: Float
  }

  input MCCAuthorizationControlsInput {
    hold_increase: HoldIncreaseInput
    hold_expiration_days: Int
  }

  input MCCGroupConfigInput {
    authorization_controls: MCCAuthorizationControlsInput
  }

  ${gC("MCCGroup")}
`, SC = Ht`
  mccGroup(token: ID!): MCCGroup
  mccGroups(
    ${pC},
  ): MCCGroupCollection 
  mccList: [MCCList]!
`, yC = Ht`
  createMccGroup(
    token: ID!
    name: String
    active: Boolean
    mccs: [String]
    config: MCCGroupConfigInput
  ): MCCGroup
  updateMccGroup(
    token: ID!
    name: String
    active: Boolean
    mccs: [String]
    config: MCCGroupConfigInput
  ): MCCGroup
`;
var CC = { types: mC, queries: SC, mutations: yC };
const { gql: TC } = e, { paginationParams: fv, generateCollectionType: b } = r, IC = TC`
  scalar Upload

  type Bank {
    token: String
    active: Boolean
    name: String
    created_time: String
    last_modified_time: String
  }
  ${b("Bank")}

  type DirectDeposit {
    token: ID!
    amount: String
    type: String
    state: String
    settlement_date: String
    state_reason: String
    state_reason_code: String
    cardholder: Cardholder
    business: Business
    standard_entry_class_code: String
    company_name: String
    company_discretionary_data: String
    company_identificatio: String
    company_entry_description: String
    individual_identification_number: String
    individual_name: String
  }
  ${b("DirectDeposit")}

  type MsaOrder {
    token: String
    cardholder: Cardholder
    business: Business
    order_balances: MsaBalance
    purchase_amount: String
    last_transaction_date: String
    start_date: String
    end_date: String
    currency_code: String
    active: Boolean
    reward_amount: String
    reward_trigger_amount: String
    unloaded_amount: String
    campaign_token: String
    funding: Funding
    aggregated_balances: MsaBalance
    transaction: Transaction
  }
  ${b("MsaOrder")}

  type Response {
    code: String
    memo: String
    additional_information: String
  }

  type Merchant {
    token: ID!
    name: String
    active: Boolean
    contact: String
    contact_email: String
    longitude: String
    latitude: String
    address1: String
    address2: String
    city: String
    state: String
    province: String
    postal_code: String
    zip: String
    phone: String
    country: String
    partial_auth_flag: Boolean
  }
  ${b("Merchant")}

  type Store {
    token: ID!
    name: String
    active: Boolean
    contact: String
    contact_email: String
    longitude: String
    latitude: String
    address1: String
    address2: String
    city: String
    state: String
    province: String
    postal_code: String
    zip: String
    phone: String
    country: String
    partial_auth_flag: Boolean
    mid: String
    network_mid: String
    merchant: Merchant
    partial_approvable_capable: Boolean
    keyed_auth_cvv_enforced: Boolean
  }
  ${b("Store")}

  type Acquirer {
    institution_country: String
    network_international_id: String
    institution_id_code: String
    retrieval_reference_number: String
    system_trace_audit_number: String
  }

  type CardAcceptor {
    mid: String
    mcc: String
    network_mid: String
    mcc_groups: [String]
    name: String
    address: String
    street_address: String
    city: String
    state: String
    postal_code: String
    zip: String
    country: String
    country_code: String
    poi: Poi
    mcc_name: String
  }

  type Poi {
    tid: String
    partial_approval_capable: String
    cardholder_presence: String
    card_presence: String
    channel: String
    processing_type: String
    pin_present: String
  }

  type Pos {
    card_data_input_capability: String
    card_holder_presence: Boolean
    card_presence: Boolean
    cardholder_authentication_method: String
    country_code: String
    is_installment: Boolean
    is_recurring: Boolean
    pan_entry_mode: String
    partial_approval_capable: Boolean
    pin_entry_mode: String
    pin_present: String
    purchase_amount_only: Boolean
    terminal_attendance: String
    terminal_id: String
    terminal_location: String
    terminal_type: String
    zip: String
  }

  type GpaOrderUnload {
    token: String
    amount: String
    tags: String
    memo: String
    transaction: Transaction
    state: String
    response: Response
    funding: Funding
    funding_source_token: String
    funding_source_address: FundingSourceAddress
    original_order_token: String
  }

  type Funding {
    amount: String
    source: FundingSource
    source_address: FundingSourceAddress
    gateway_log: GatewayLog
  }

  type GatewayLog {
    duration: Int
    message: String
    order_number: String
    response: GatewayResponse
    timed_out: Boolean
    transaction_id: String
  }

  type GatewayResponse {
    code: String
    data: GatewayResponseData
  }

  type GatewayResponseData {
    jit_funding: GatewayResponseDataJitFunding
  }

  type JitFunding {
    acting_user_token: String
    address_verification: AddressVerification
    amount: Float
    method: String
    original_jit_funding_token: String
    token: String
    user_token: String
  }

  type AddressVerification {
    gateway: Gateway
  }

  type Gateway {
    on_file: OnFile
    response: Response
  }

  type OnFile {
    postal_code: String
    street_address: String
  }

  type GatewayResponseDataJitFunding {
    token: String
    method: String
    cardholder: Cardholder
    acting_cardholder_token: String
    business: Business
    amount: String
    memo: String
    tags: String
    original_jit_funding_token: String
    incremental_authorization_jit_funding_tokens: [String]
    address_verification: JitFundingAddressVerification
    decline_reason: String
    balances: BalanceByCurrency
  }

  type JitFundingAddressVerification {
    request: Address
    issuer: JitFundingAddressVerificationResult
    gateway: JitFundingAddressVerificationResult
  }

  type JitFundingAddressVerificationResult {
    on_file: Address
    response: Response
  }

  type FeeWithMetadata {
    token: String
    memo: String
    tags: String
    transaction: Transaction
    fee: Fee
  }

  type CardSecurityCodeVerification {
    type: String
    response: Response
  }

  type RealTimeAssessment {
    transaction_type: String
    international_enabled: Boolean
    domestic_enabled: Boolean
  }

  type Staff {
    email: String
  }

  type Transmission {
    token: ID!
    transmission_method: String
    card: Card
    recipient_contact: String
    recipient_name: String
    subject: String
    message: String
    logo_location: String
    metadata: String
    template: String
  }
  ${b("Transmission")}

  type WalletAccount {
    id: String
    email_address: String
    score: String
  }

  type RiskAssessment {
    score: String
    version: String
  }

  type WalletAddressVerification {
    name: String
    street_address: String
    postal_code: String
    zip: String
  }

  type TransactionControls {
    accepted_countries_token: String
    always_require_pin: Boolean
    always_require_icc: Boolean
    allow_gpa_auth: Boolean
    address_verification: TransactionControlsAddressVerification
    require_card_not_present_card_security_code: Boolean
    allow_mcc_group_authorization_controls: Boolean
    allow_first_pin_set_via_financial_transaction: Boolean
    ignore_card_suspended_state: Boolean
    allow_network_load: Boolean
    allow_network_load_card_activation: Boolean
    allow_quasi_cash: Boolean
    enable_partial_auth_approval: Boolean
    allow_chip_fallback: Boolean
  }

  type TransactionControlsAddressVerification {
    av_messages: TransactionControlsAddressVerificationMessageSettings
    auth_messages: TransactionControlsAddressVerificationMessageSettings
  }

  type TransactionControlsAddressVerificationMessageSettings {
    validate: Boolean
    decline_on_address_number_mismatch: Boolean
    decline_on_postal_code_mismatch: Boolean
  }

  type SelectiveAuth {
    sa_mode: Int
    enable_regex_search_chain: Boolean
    dmd_location_sensitivity: Int
  }

  type ClearingAndSettlement {
    overdraft_destination: String
  }

  type JitFundingSource {
    enabled: Boolean
    funding_source_token: String
    refunds_destination: String
  }

  type DigitalWalletTokenization {
    provisioning_controls: ProvisioningControls
    card_art_id: String
  }

  type ProvisioningControls {
    manual_entry: ProvisioningControlSettings
    wallet_provider_card_on_file: ProvisioningControlSettings
    in_app_provisioning: ProvisioningControlSettings
  }

  type ProvisioningControlSettings {
    enabled: Boolean
    address_verification: ProvisioningControlAddressVerification
  }

  type CardActivationActions {
    terminate_reissued_source_card: Boolean
    swap_digital_wallet_tokens_from_card_token: String
  }

  type CardFulfillment {
    shipping: CardFulfillmentShipping
    card_personalization: CardPersonalization
    card_fulfillment_reason: String
  }

  input CardFulfillmentInput {
    shipping: CardFulfillmentShippingInput
    card_personalization: CardPersonalizationInput
    card_fulfillment_reason: String
  }

  type CardFulfillmentShipping {
    method: String
    return_address: Address
    recipient_address: Address
    care_of_line: String
  }

  input CardFulfillmentShippingInput {
    method: String
    return_address: AddressInput
    recipient_address: AddressInput
    care_of_line: String
  }

  type CardPersonalization {
    text: CardText
    images: CardImages
    carrier: CardCarrier
    perso_type: String
  }

  input CardPersonalizationInput {
    text: CardTextInput
    images: CardImagesInput
    carrier: CardCarrierInput
    perso_type: String
  }

  type CardText {
    name_line_1: NameValuePair
    name_line_2: NameValuePair
    name_line_3: NameValuePair
  }

  input CardTextInput {
    name_line_1: NameValuePairInput
    name_line_2: NameValuePairInput
    name_line_3: NameValuePairInput
  }

  type CardCarrier {
    template_id: String
    logo_file: String
    logo_thumbnail_file: String
    message_file: String
    message_line: String
  }

  input CardCarrierInput {
    template_id: String
    logo_file: String
    logo_thumbnail_file: String
    message_file: String
    message_line: String
  }

  type CardImages {
    card: CardImagesCard
    carrier: CardImagesCarrier
    signature: NameValuePair
    carrier_return_window: NameValuePair
  }

  input CardImagesInput {
    card: CardImagesCardInput
    carrier: CardImagesCarrierInput
    signature: NameValuePairInput
    carrier_return_window: NameValuePairInput
  }

  type CardImagesCard {
    name: String
    thermal_color: String
  }

  input CardImagesCardInput {
    name: String
    thermal_color: String
  }

  type CardImagesCarrier {
    name: String
    message_1: String
  }

  input CardImagesCarrierInput {
    name: String
    message_1: String
  }

  ## These KYC types are depricated for user/cardholder KYC. Please use KycUserResult types
  type Kyc {
    token: ID!
    cardholder_token: String
    business_token: String
    result: KycResult
    manual_override: Boolean
    notes: String
  }
  ${b("Kyc")}

  type KycResult {
    status: String
    failed_questions_count: Int
    codes: [KycResultCode]
  }

  type KycResultCode {
    code: String
    message: String
  }

  type FundingSourceAddress implements AbstractAddress {
    token: ID!
    cardholder_token: String
    business_token: String
    first_name: String
    last_name: String
    address1: String
    address2: String
    city: String
    state: String
    postal_code: String
    zip: String
    is_default_address: Boolean
    phone: String
    active: Boolean
  }
  ${b("FundingSourceAddress")}

  type AutoReload {
    token: ID!
    active: Boolean
    funding_source: AbstractFundingSource
    funding_source_address: FundingSourceAddress
    association: Association
    order_scope: OrderScope
    currency_code: String
  }
  ${b("AutoReload")}

  type MerchantScope {
    mid: String
    mcc: String
    mcc_name: String
    mcc_group: String
    mcc_group_data: MccGroup
  }

  type MccGroup {
    token: ID
    name: String!
    mcc_names: [String]!
    mccs: [String]!
    active: Boolean
    config: MccGroupConfig
  }

  type MccGroupConfig {
    authorization_controls: AuthorizationControls
    hold_expiration_days: Int
  }

  type AuthorizationControls {
    hold_increase: HoldIncrease
  }

  type HoldIncrease {
    type: String
    value: Float
  }

  input MerchantScopeInput {
    mid: String
    mcc: String
    mcc_group: String
  }

  type Association {
    cardholder_token: String
    card_product_token: String
    business_token: String
  }

  input AssociationInput {
    cardholder_token: String
    card_product_token: String
    business_token: String
  }

  type OrderScope {
    gpa: AutoReloadTrigger
    msa: AutoReloadTrigger
  }

  type AutoReloadTrigger {
    campaign_token: String
    trigger_amount: Float
    reload_amount: Float
  }

  type PrimaryContact {
    full_name: String
    title: String
    department: String
    phone: String
    extension: String
    fax: String
    mobile: String
    email: String
  }

  input PrimaryContactInput {
    full_name: String
    title: String
    department: String
    phone: String
    extension: String
    fax: String
    mobile: String
    email: String
  }

  type Incorporation {
    is_public: Boolean
    is_regulated_entity: Boolean
    incorporation_type: String
    stock_symbol: String
    state_of_incorporation: String
    name_registered_under: String
    address_registered_under: Address
  }

  input IncorporationInput {
    is_public: Boolean
    is_regulated_entity: Boolean
    incorporation_type: String
    stock_symbol: String
    state_of_incorporation: String
    name_registered_under: String
    address_registered_under: AddressInput
  }

  type ProprietorOrOfficer {
    first_name: String
    middle_name: String
    last_name: String
    alternative_names: String
    birth_place: String
    nationality: String
    title: String
    home: Address
    dob: String
    phone: String
    email: String
    ownership_percentage: String
    ssn: String
    identifications: [Identification]
  }

  input ProprietorOrOfficerInput {
    first_name: String
    middle_name: String
    last_name: String
    alternative_names: String
    title: String
    home: AddressInput
    dob: String
    birth_place: String
    nationality: String
    ownership_percentage: String
    phone: String
    email: String
    ssn: String
    identifications: [IdentificationInput]
  }

  type BeneficialOwner {
    first_name: String
    middle_name: String
    last_name: String
    title: String
    home: Address
    getdob: String
    birth_place: String
    nationality: String
    ownership_percentage: String
    email: String
    phone: String
    identifications: [Identification]
    ssn: String
  }

  type FullIdentificationNumber {
    ssn: String
    tin: String
    sin: String
    nin: String
    passport_number: String
    drivers_license: String
  }

  type Identification {
    type: String!
    value: String!
    expiration_date: String
  }

  input IdentificationInput {
    type: String
    value: String
    expiration_date: String
  }

  type NameValuePair {
    value: String
    name: String
  }

  input NameValuePairInput {
    value: String
    name: String
  }

  type ProvisioningControlAddressVerification {
    validate: Boolean
  }

  type CardSwap {
    previous_card_token: String
    new_card_token: String
  }

  type Validation {
    cardholder: Cardholder
  }

  enum ProgramAttributeType {
    DECISION_SERVICE
    DECISION_NOTIFY_SERVICE
    DECOUPLED_AUTH
    OOB_AUTH
  }

  type ProgramAttribute {
    type: ProgramAttributeType!
    active: Boolean!
    url: String!
    username: String!
  }

  input ProgramAttributeUpdateInput {
    type: ProgramAttributeType!
    active: Boolean!
    url: String!
    username: String!
    password: String
  }

  input ProgramAttributeCreateInput {
    type: ProgramAttributeType!
    active: Boolean!
    url: String!
    username: String!
    password: String!
  }

  type ReinstateDetails {
    cardholder_token: String
    business_token: String
    status: String
    reason_code: String
    reason: String
  }

  input ReinstateDetailsInput {
    user_token: String
    business_token: String
    memo: String
  }

  type KycDetails {
    kyc_token: String
    kyc: Kyc
    kyc_failure_reason: String
  }

  input KycDetailsInput {
    kyc_token: String
    memo: String
  }
`;
var fC = IC;
const { gql: DC } = e, AC = DC`
  enum Network {
    NETWORK_DISCOVER
    NETWORK_MASTERCARD
    NETWORK_PULSE
    NETWORK_VISA
    NETWORK_MARQETA
    UNRECOGNIZED
  }
`;
var kC = { types: AC };
const { gql: Vt } = e, { paginationParams: hC, generateCollectionType: EC } = r, $C = Vt`
  type Note {
    token: String
    description: String
    created_by: String
    created_by_user_role: String
    private: Boolean
    created_time: String
    last_modified_time: String
  }

  ${EC("Note")}
`, PC = Vt`
  notes(${hC}): NoteCollection
`, vC = Vt`
  createBusinessNote(
    token: String!
    description: String
    created_by: String
    created_by_user_role: String
    private: Boolean
  ): Note
  createCardholderNote(
    token: String!
    description: String
    created_by: String
    created_by_user_role: String
    private: Boolean
  ): Note
`;
var RC = { types: $C, queries: PC, mutations: vC };
const { gql: Yt } = e, { paginationParams: bC, generateCollectionType: NC } = r, BC = Yt`
  type NotificationActor {
    entityType: String
    token: String
  }
  type Notification {
    token: ID
    title: String
    message: String
    link: String
    metadata: String
    createdTime: String
    to: NotificationActor
    initiator: NotificationActor
  }
  type NotificationReadUpdate {
    timestamp: String
  }
  type NotificationRemove {
    notificationToken: String
  }

  type NotificationResponse {
    notificationToken: String
  }
  type NotificationReadResponse {
    timestamp: String
  }
  input CreateNotificationParams {
    toToken: String!
    toEntityType: String!
    initiatorEntityType: String!
    title: String!
    message: String!
    link: String!
  }
  ${NC("Notification")}
`, OC = Yt`
  notifications(${bC}): NotificationCollection
`, FC = Yt`
  deleteNotification(notificationToken: String!): NotificationResponse
  createNotification(notificationParams: CreateNotificationParams!): NotificationResponse
  readNotifications: NotificationReadResponse
`;
var wC = { types: BC, queries: OC, mutations: FC };
const { gql: Wt } = e, { paginationParams: qC, generateCollectionType: MC } = r, UC = Wt`
  type CreditHistoryRecord {
    operation: String
    username: String
    userRole: String
    createdTime: String
    newStatus: String
    comment: String
    email: String
  }

  input APR_input {
    balance_type: String
    type: String
    minimum: Float
    maximum: Float
  }

  type APR {
    balanceType: String
    type: String
    minimum: Float
    maximum: Float
  }

  type CREDIT_REWARD {
    type: String
    method: String
    value: Float
  }

  input CREDIT_REWARD_INPUT {
    type: String
    method: String
    value: Float
  }

  type FEE_VALUE {
    type: String!
    method: String!
    value: Float!
  }

  input FEE_input {
    type: String!
    method: String!
    value: Float!
  }

  enum OFFER_STATUS {
    DRAFT
    PENDING_APPROVAL
    ACTIVE
    REJECTED
    SENT_FOR_REVISION
  }

  enum OFFER_CHANNEL {
    EMAIL
    DIRECT_MAIL
    SOCIAL
    IN_APP
  }

  type Offer {
    token: ID!
    name: String
    description: String
    status: OFFER_STATUS
    productToken: CreditProduct
    channels: [OFFER_CHANNEL]
    gracePeriodDays: Int
    paymentDueDay: Int
    currencyCode: String
    aprs: [APR]
    fees: [FEE_VALUE]
    rewards: [CREDIT_REWARD]
    createdTime: String
    updatedTime: String
    history: [CreditHistoryRecord]
  }

  input OffersFilters {
    product_name: String
    product_tokens: [String]
    offer_name: String
    statuses: [OFFER_STATUS]
    start_date: String
    end_date: String
  }

  enum TAB_NAMES_MAP {
    QUEUE
    ACTIVE
    REJECTED
    CREDIT_PRODUCT_DETAILS
  }

  type OffersPrecence {
    active: Boolean
    rejected: Boolean
    queue: Boolean
  }

  ${MC("Offer")}
`, LC = Wt`
    offer(token: ID!): Offer
    offers(
        filters: OffersFilters,
        activeTab: TAB_NAMES_MAP,
        ${qC},
    ): OfferCollection
    offersPresence: OffersPrecence
`, xC = Wt`
  createOffer(
    name: String
    description: String
    status: OFFER_STATUS
    product_token: String
    channels: [OFFER_CHANNEL]
    gracePeriodDays: Int
    paymentDueDay: Int 
    aprs: [APR_input]
    fees: [FEE_input]
    rewards: [CREDIT_REWARD_INPUT]
    comment: String
  ): Offer

  updateOffer(
    token: String
    name: String
    description: String
    status: OFFER_STATUS
    product_token: String
    channels: [OFFER_CHANNEL]
    gracePeriodDays: Int
    paymentDueDay: Int 
    aprs: [APR_input]
    fees: [FEE_input]
    rewards: [CREDIT_REWARD_INPUT]
    comment: String
  ): Offer
  
  updateOfferStatus(
    token: String
    status: OFFER_STATUS
    comment: String
  ): Offer
`;
var GC = { types: UC, queries: LC, mutations: xC };
const { gql: Kt } = e, HC = Kt`
  type OnboardProgramResponse{
      apiEnabledPrograms: String
      allowedProgramShortCodesForFolder: String
  }
  
  type StatusResponse {
      status: String
  }
  
  input OnboardProgramPayload {
      isRegEProgram: Boolean
   }

  input OnboardCountryCodePayload {
      country_code: String
  }
`, VC = Kt`
`, YC = Kt`
  onboardProgram(
    program_short_code: ID!
    payload: OnboardProgramPayload
  ): OnboardProgramResponse
  onboardCountryCode(
    program_short_code: ID!
    payload: OnboardCountryCodePayload
  ): StatusResponse
`;
var WC = { types: HC, queries: VC, mutations: YC };
const { gql: Cr } = e, KC = Cr`
  type PaymentCardFundingSource implements AbstractFundingSource {
    token: ID!
    type: String
    account_suffix: String
    account_type: String
    active: Boolean
    is_default_account: Boolean
    exp_date: String
    cardholder: Cardholder
    business: Business
  }
`, zC = Cr`
  createPaymentCardFundingSource(
    cardholder_token: String
    business_token: String
    account_number: String
    cvv_number: String
    exp_date: String
    postal_code: String
    is_default_account: Boolean
  ): PaymentCardFundingSource
`;
var jC = { types: KC, mutations: zC };
const { gql: zt } = e, QC = zt`
  type PersistUser {
    id: Int!
    email: String
    saved_reports: [DivaReport]
    default_report: String
  }
`, JC = zt`
  persistUser(id: Int!): PersistUser
`, ZC = zt`
  findOrCreatePersistUser(email: String!): PersistUser
  updateDefaultDivaReport(
    user_id: Int!
    default_report: String
  ): PersistUser
`;
var XC = {
  types: QC,
  queries: JC,
  mutations: ZC
};
const { gql: jt } = e, eT = jt`
  type DivaReport {
    id: Int
    uid: String
    name: String
    hydrator: String
    created_at: String
    updated_at: String
    created_by: PersistUser
  }
`, tT = jt`
  divaReport(uid: String!): DivaReport
`, nT = jt`
  addDivaReport(
    uid: String!
    created_by_user_id: Int!
    name: String!
    hydrator: String!
  ): DivaReport
  editDivaReport(
    uid: String!
    name: String
    hydrator: String!
  ): DivaReport
  deleteDivaReport(
    uid: String!
  ): DivaReport
`;
var iT = {
  types: eT,
  queries: tT,
  mutations: nT
};
const rT = XC, aT = iT;
var oT = [aT, rT];
const { gql: Tr } = e, { paginationParams: sT, generateCollectionType: cT } = r, _T = Tr`
  type PrimeRate {
    rate: Float
    effectiveDate: String
    determinationDate: String
  }

  type Tier {
    pricingTier: Int
    margin: Float
  }

  type PricingStrategy {
    strategyId: ID
    displayName: String
    tiers: [Tier]
  }

  type PricingStrategyListItem {
    strategyId: ID
    displayName: String
  }

  ${cT("PricingStrategyListItem")}
`, dT = Tr`
  primeRate: PrimeRate
  pricingStrategy(token: ID!): PricingStrategy
  pricingStrategies(${sT}): PricingStrategyListItemCollection
`;
var lT = { types: _T, queries: dT };
const { gql: uT } = e, gT = uT`
  type ProcessingErrorTypeDisputeDetails {
    duplicate_processing_or_paid_by_other_means_details: DuplicateProcessingDetails
    late_presentment_details: LatePresentmentDetails
    no_authorization_details: NoAuthorizationDetails
    invalid_data_details: InvalidDataDetails
    incorrect_transaction_code_details: IncorrectTransactionCodeDetails
    incorrect_currency_details: IncorrectCurrencyDetails
    incorrect_account_number_details: IncorrectAccountNumberDetails
    incorrect_transaction_amount_details: IncorrectTransactionAmountDetails
  }

  input ProcessingErrorTypeDisputeDetailsInput {
    duplicate_processing_or_paid_by_other_means_details: DuplicateProcessingDetailsInput
    late_presentment_details: LatePresentmentDetailsInput
    no_authorization_details: NoAuthorizationDetailsInput
    invalid_data_details: InvalidDataDetailsInput
    incorrect_transaction_code_details: IncorrectTransactionCodeDetailsInput
    incorrect_currency_details: IncorrectCurrencyDetailsInput
    incorrect_account_number_details: IncorrectAccountNumberDetailsInput
    incorrect_transaction_amount_details: IncorrectTransactionAmountDetailsInput
  }

  type DuplicateProcessingDetails {
    error_type: String
    both_transactions_in_same_account: Boolean
    other_transaction_reference_token: String
    other_visa_transaction_reference_id: String
    other_visa_transaction_mcsn: String
    transaction_in_different_visa_account: Boolean
    is_other_transaction_with_same_merchant: Boolean
    provided_proof_of_other_means_type: String
    is_evidence_of_merchant_passed_funds_provided: Boolean
    cardholder_attempted_to_resolve: Boolean
    is_attempt_to_resolve_prohibited_by_local_law: Boolean
    other_visa_transaction_arn: String
    other_visa_transaction_information: String
  }

  input DuplicateProcessingDetailsInput {
    error_type: String
    both_transactions_in_same_account: Boolean
    other_transaction_reference_token: String
    other_visa_transaction_reference_id: String
    other_visa_transaction_mcsn: String
    transaction_in_different_visa_account: Boolean
    is_other_transaction_with_same_merchant: Boolean
    provided_proof_of_other_means_type: String
    is_evidence_of_merchant_passed_funds_provided: Boolean
    cardholder_attempted_to_resolve: Boolean
    is_attempt_to_resolve_prohibited_by_local_law: Boolean
    other_visa_transaction_arn: String
    other_visa_transaction_information: String
  }

  type LatePresentmentDetails {
    account_status: ACCOUNT_STATUS
    cash_over_indicator: String
  }

  input LatePresentmentDetailsInput {
    account_status: String
    cash_over_indicator: String
  }
  
  type NoAuthorizationDetails {
    cash_over_indicator: String
  }
  
  input NoAuthorizationDetailsInput {
    cash_over_indicator: String
  }

  type InvalidDataDetails {
      authorization_request_declined_valid_data: Boolean
      explain_why_valid_data_inclusion_reason: String
  }

  input InvalidDataDetailsInput {
      authorization_request_declined_valid_data: Boolean
      explain_why_valid_data_inclusion_reason: String
  }

  type IncorrectTransactionCodeDetails {
    how_is_transaction_code_incorrect: HOW_IS_TRANSACTION_CODE_INCORRECT
    explain_why_the_credit_refund_was_processed_in_error: String
    credit_confirmation_number: String
    date_of_return: String
    return_method: String
  }

  input IncorrectTransactionCodeDetailsInput {
    how_is_transaction_code_incorrect: HOW_IS_TRANSACTION_CODE_INCORRECT
    explain_why_the_credit_refund_was_processed_in_error: String
    credit_confirmation_number: String
    date_of_return: String
    return_method: String
  }

  type IncorrectCurrencyDetails {
    incorrect_currency_reason: INCORRECT_CURRENCY_REASON
    what_was_the_correct_currency: Int
    certification_that_the_cardholder_did_not_agree_to_dynamic_currency_conversion_and_did_not_make_an_active_choice: Boolean
  }

  input IncorrectCurrencyDetailsInput {
    incorrect_currency_reason: String
    what_was_the_correct_currency: Int
    certification_that_the_cardholder_did_not_agree_to_dynamic_currency_conversion_and_did_not_make_an_active_choice: Boolean
  }

  type IncorrectAccountNumberDetails {
    is_the_account_number_on_the_issuers_master_file: Boolean
    does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token: Boolean
  }

  input IncorrectAccountNumberDetailsInput {
    is_the_account_number_on_the_issuers_master_file: Boolean
    does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token: Boolean
  }

  type IncorrectTransactionAmountDetails {
    what_is_the_amount_on_the_cardholders_receipt: Float
    what_is_the_currency_on_the_cardholders_receipt: String
    is_the_dispute_due_to_the_difference_between_quoted_price_and_actual_charges_made_by_the_merchant: Boolean
    cash_over_indicator: String
  }

  input IncorrectTransactionAmountDetailsInput {
    what_is_the_amount_on_the_cardholders_receipt: Float
    what_is_the_currency_on_the_cardholders_receipt: String
    is_the_dispute_due_to_the_difference_between_quoted_price_and_actual_charges_made_by_the_merchant: Boolean
    cash_over_indicator: String
  }

  enum ACCOUNT_STATUS {
    ACCOUNT_CLOSED
    CREDIT_PROBLEM
    FRAUD
    NONSUFFICIENT_FUNDS
  }

  enum HOW_IS_TRANSACTION_CODE_INCORRECT {
    CREDIT_INSTEAD_OF_REVERSAL_OR_ADJUSTMENT
    CREDIT_POSTED_AS_DEBIT
    DEBIT_POSTED_AS_CREDIT
  }

  enum INCORRECT_CURRENCY_REASON {
    CURRENCY_DIFFERENCE
    DCC_DISPUTE
    CREDIT_INSTEAD_OF_REVERSAL_OR_ADJUSTMENT
    CREDIT_POSTED_AS_DEBIT
    DEBIT_POSTED_AS_CREDIT
  }
`;
var pT = { types: gT };
const { gql: Qt } = e, mT = Qt`
  type ProgramConfigs {
    ACHO_CLEAR_MAX_ATTEMPTS: String
    ACHO_MINIMUM_RESERVE_BALANCE_THRESHOLD: String
    ACHO_VERIFY_PROGRAM_RESERVE_BALANCE: String
    ACH_LAST_FILE_SENT: String
    ACHO_JIT_PASSTHROUGH_ENABLED: String
    ACHO_PULL_DAILY_TRANSFER_LIMIT: String
    ACHO_PULL_CLEAR_HOLD_TIME_DAYS: String
    ACHO_PUSH_DAILY_TRANSFER_LIMIT: String
    ACHO_PUSH_CLEAR_HOLD_TIME_DAYS: String
    ACH_REJECT_PROCESSING_ENABLED: String
    ACH_TRACE_NUMBER: String
    ALLOW_ACCOUNT_FUNDING: String
    ALLOW_NETWORK_LOAD: String
    ARROWEYE_DATASET_ID: String
    AUTH_CONTROL_DEFAULT: String
    AUTHORIZATION_DIGEST_PERCENTAGE_SWITCH: String
    BALANCE_INQUIRY_TO_JIT_GATEWAY: String
    BULK_CARD_ORDER_BATCH_PROCESS_RETRY_ENABLED: String
    CAN_MOVE_ACTIVE_CARDS: String
    CHARGEBACK_ALLOCATION_FLOW_ENABLED: String
    DB_CONNECTION_RELEASE_ENABLED: String
    DEFAULT_CURRENCY: String
    defaultLayers: String
    DIRECT_DEPOSIT_ACCOUNT_LOOKUP_LEGACY: String
    DIRECT_DEPOSIT_BANK_PROVIDER: String
    DIRECT_DEPOSIT_REVIEW_REQUIRED: String
    ENABLE_ITC_REWRITE: String
    ENABLE_PIN_REVEAL: String
    ENFORCE_ACHO_DAILY_TRANSFER_LIMIT: String
    ENQUEUE_EVENTS: String
    EVENTS_USE_OLD_PAYLOAD: String
    EXPIRED_CARD_TRANSITION_JOB_LIMIT: String
    FUNDING_GATEWAY_MERCHANT_ID: String
    GL_CHART: String
    GL_ISSUERS_ACCT: String
    GL_JOURNAL: String
    HSM_GATEWAY_ENABLED: String
    INTERNATIONAL_RESPONSE_FORMAT_VERSION: String
    ISSUER_COUNTRY: String
    KYC_BUSINESS_MERCHANT_ID: String
    KYC_MERCHANT_ID: String
    LEGACY_CARDTRANSITION_EVENTS: String
    LOCAL_BALANCE_FEATURE_SWITCH: String
    MAX_ACTIVE_CARDS_PER_USER: String
    MAX_CARD_ORDERS_PER_DAY: String
    MAX_CARDS_ON_AUTO_RELOAD: String
    MC_SMS_FILE_ENABLED: String
    PROGRAM_CURRENCIES: String
    PROGRAM_RESERVE_LOAD_RESTRICTION_ENABLED: String
    PROGRAM_MT_FUND_SOURCE_SWITCH: String
    PTC_FETCH_PENDING_TRANSACTION_DURATION: String
    PTC_MERCHANT_ID: String
    PTC_SUPPORT_PENDING_TRANSACTION: String
    PUSH_TO_CARD_BYPASS_VERIFICATION_FOR_MC: String
    PUSHTOCARD_TABAPAY_SETTLEMENT_ACCOUNT: String
    PUSHTOCARD_TABAPAY_SUBCLIENT_ID: String
    REAL_TIME_FEES_ENABLED: String
    REL_19_11_DWT_ENHANCED_FINDORIGINAL_FEATURE_FLAG: String
    REST_CHECK_METHOD: String
    SAME_DAY_AMOUNT_LIMIT: String
    SCHEMA_REVISION: String
    SHOW_ISSUER_FEE: String
    SLAVE_DB_ENABLED: String
    STANDARD_AMOUNT_LIMIT: String
    STIP_DECLINE_WEBHOOKS_REASONCODE_LIST: String
    TERMINATE_ACTIVE_CARDS_ON_NEW_CARD_ACTIVATION: String
    TRANSACTION_MODEL_VERSION: String
    TRANSITION_EXPIRED_CARDS_JOB_ENABLED: String
    TZ: String
    USE_LOCAL_TRANCACHE: String
    USE_TXN_MICRO_SERVICE: String
    USER_CARD_STATE_VERSION: String
    USER_MT_FUND_SOURCE_SWITCH: String
    VISA_SMS_FILE_ENABLED: String
    WEBHOOKS_SERVICE: String
    MARQETA_JS_ENABLED: String
    featureFlags: FeatureFlag
  }

  type ProgramCurrencies {
    DEFAULT_CURRENCY: String
    PROGRAM_CURRENCIES: String
  }

  type FeatureFlag {
    KYB_VERSION: String
    KYC_MICROSERVICE_ENABLED: String
    ENABLE_CONTROLPLANE_DASHBOARD: String
    ENABLE_CONTROLPLANE_DECISION_REPORTS: String
    TXN_ACCT_MONITORING_ENABLED: String
  }
`, ST = Qt`
  programConfigs: ProgramConfigs
  programCurrencies(shortCode: String): ProgramCurrencies
  internationalResponseFormatVersion: String
  kybVersion: String,
  kycMicroserviceEnabled: String,
  controlPlaneDecisionReportsEnabled: String
  controlPlaneDashboardEnabled: String
  featureFlagsForProgram(shortCode: String!): FeatureFlag
`, yT = Qt`
  updateProgramConfigs(
    ENABLE_PIN_REVEAL: String
    MAX_ACTIVE_CARDS_PER_USER: String
    TERMINATE_ACTIVE_CARDS_ON_NEW_CARD_ACTIVATION: String
  ): ProgramConfigs
`;
var CT = { types: mT, queries: ST, mutations: yT };
const { gql: Ir } = e, { paginationParams: TT, generateCollectionType: IT } = r, fT = Ir`
  type ProgramFundingSource implements AbstractFundingSource {
    name: String
    active: Boolean
    token: ID!
    created_time: String
    last_modified_time: String
    account: String
  }
  ${IT("ProgramFundingSource")}
`, DT = Ir`
  programFundingSources(${TT}): ProgramFundingSourceCollection
`;
var AT = { types: fT, queries: DT };
const { gql: fr } = e, { paginationParams: kT, generateCollectionType: hT } = r, ET = fr`
  type ProgramGatewayFundingSource implements AbstractFundingSource {
    name: String
    url: String
    version: String
    active: Boolean
    token: ID!
    created_time: String
    last_modified_time: String
    account: String
    timeout_millis: Int
    basic_auth_username: String
    basic_auth_password: String
  }
  ${hT("ProgramGatewayFundingSource")}
`, $T = fr`
  programGatewayFundingSources(${kT}): ProgramGatewayFundingSourceCollection
`;
var PT = { types: ET, queries: $T };
const { gql: Jt } = e, { paginationParams: Hn, generateCollectionType: Vn } = r, vT = Jt`
  enum ProgramReserveTransactionType {
    CREDIT
    DEBIT
    PENDING_CREDIT
    PENDING_DEBIT
  }

  enum ProgramReserveTransactionState {
    COMPLETE
    PENDING
  }

  enum TemporaryTransactionStatus {
    PENDING
    SUCCEEDED
    FAILED
  }

  # Response type from the transactions Core API
  type ProgramReserveTransaction {
    token: String!
    transaction_token: String!
    amount: Float!
    is_collateral: Boolean
    currency_code: CurrencyCode!
    type: ProgramReserveTransactionType!
    state: ProgramReserveTransactionState!
    created_time: String!
    last_modified_time: String!
    memo: String
    tags: String
  }

  ${Vn("ProgramReserveTransaction")}

  # Response type from the Cache DB
  type ProgramReserveTemporaryTransaction {
    token: String
    program: String!
    amount: Float!
    is_collateral: Boolean
    currency_code: CurrencyCode!
    type: ProgramReserveTransactionType!
    hash: String!
    status: TemporaryTransactionStatus!
    memo: String
    bank_file: String
    failure_reason: String
    created_at: String!
    updated_at: String!
  }

  ${Vn("ProgramReserveTemporaryTransaction")}

  input TransactionInput {
    program: String!
    token: String!
    amount: Float!
    is_collateral: Boolean
    currency_code: CurrencyCode!
    type: ProgramReserveTransactionType!
    memo: String
    bank_file: String
  }

  type ProgramReserveCurrency {
    id: ID!
    program: String!
    currency_code: CurrencyCode!
    created_at: String!
    updated_at: String!
  }
`, RT = Jt`
  programReserveTransactions(
    ${Hn}
    program: String
    type: ProgramReserveTransactionType
    amount: Float
    is_collateral: Boolean
    token: String
    status: TemporaryTransactionStatus
    currency_code: CurrencyCode
    dateRange: [String!]
  ): ProgramReserveTemporaryTransactionCollection!

  programReserveAllTransactions: ProgramReserveTemporaryTransactionCollection!

  programReserveSpecificTransactions(
    program: String!
    ${Hn}
  ): ProgramReserveTransactionCollection!

  programReserveCurrencies: [ProgramReserveCurrency!]!
`, bT = Jt`
  createProgramReserveTransactions(
    date: String!
    transactions: [TransactionInput!]!
  ): Boolean!

  updateProgramReserveCurrencies: Boolean!
`;
var NT = { types: vT, queries: RT, mutations: bT };
const { gql: Dr } = e, BT = Dr`
  enum ProgramType {
    PROCESSOR_ONLY
    PROCESSOR_PLUS
    PROGRAM_MANAGED
    UNKNOWN
  }
`, OT = Dr`
  programTypes: [ProgramType]!
`;
var FT = { types: BT, queries: OT };
const { gql: Ar } = e, { paginationParams: Dv, generateCollectionType: wT } = r, qT = Ar`
  type PublicSandboxCard {
    cardholder_token: String
    cardholder: PublicSandboxCardholder
    created_time: String
    last_four: String
    state: String
    instrument_type: String
    token: ID!
  }

  input PublicSandboxCredsInput {
    access_token: String
    application_token: String
  }

  ${wT("PublicSandboxCard")}
`, MT = Ar`
  publicSandboxCard(token: ID!
    sandbox_creds: PublicSandboxCredsInput
  ): PublicSandboxCard
  publicSandboxCards(
    cardholder_token: ID
    sort_by: String
    count: Int
    start_index: Int
    limit: Int
  ): PublicSandboxCardCollection
`;
var UT = { types: qT, queries: MT };
const { gql: kr } = e, { paginationParams: hr, generateCollectionType: LT } = r, xT = kr`
  type PublicSandboxCardholder {
    cards(${hr}): PublicSandboxCardCollection
    first_name: String
    last_name: String
    token: ID!
  }

  input PublicSandboxCardholderInput {
    first_name: String
    last_name: String
    email: String
    notes: String
  }

  ${LT("PublicSandboxCardholder")}
`, GT = kr`
  publicSandboxCardholders(
    ${hr},
    first_name: String,
    last_name: String,
    phone: String,
    email: String,
    sandbox_creds: PublicSandboxCredsInput
  ): PublicSandboxCardholderCollection
`;
var HT = { types: xT, queries: GT };
const { gql: Er } = e, { generateCollectionType: VT, paginationParams: YT } = r, WT = Er`
  type PublicSandboxTransaction {
    amount: Float
    created_time: String
    gpa: GpaObject
    gpa_order: GpaOrder
    identifier: String
    preceding_related_transaction_token: String
    request_amount: Float
    response: Response
    state: String
    token: ID!
    type: String
  }

  ${VT("PublicSandboxTransaction")}
`, KT = Er`
  publicSandboxTransactions(
    ${YT}
    cardholder_token: ID
    sandbox_creds: PublicSandboxCredsInput
    business_token: ID
    acting_cardholder_token: ID
    card_token: ID
    merchant_token: ID
    campaign_token: ID
    type: String
    state: String
    sort_by: String
    start_date: String
    user_token: String
    end_date: String
  ): PublicSandboxTransactionCollection
`;
var zT = { types: WT, queries: KT };
const { gql: $r } = e, { paginationParams: jT, generateCollectionType: Av } = r, QT = $r`
  publicSandboxWebhook(
    token: ID!
    sandbox_creds: PublicSandboxCredsInput
  ): Webhook
  publicSandboxWebhooks(
    ${jT}
    sandbox_creds: PublicSandboxCredsInput
  ): WebhookCollection
  publicSandboxPingWebhook(
    token: ID!
    sandbox_creds: PublicSandboxCredsInput
  ): WebhookPing
`, JT = $r`
  publicSandboxCreateWebhook(
    name: String!
    active: Boolean!
    config: WebhookConfigInput!
    sandbox_creds: PublicSandboxCredsInput
    events: [String]
  ): Webhook
  publicSandboxUpdateWebhook(
    token: ID!
    name: String!
    active: Boolean
    config: WebhookConfigInput!
    sandbox_creds: PublicSandboxCredsInput
    active: Boolean
    events: [String]
  ): Webhook
`;
var ZT = { mutations: JT, queries: QT };
const { gql: Pr } = e, { paginationParams: XT, generateCollectionType: eI } = r, tI = Pr`
  type SourceCard {
    user_token: String
    token: String
    is_default: Boolean
    last_four: String
    issuing_bank: String
    expiration: String
    network: String
    status: String
    created_time: String
    last_modified_time: String
  }

  type PullFromCard {
    token: String
    card_token: String
    transfer_token: String
    amount: String
    currency: String
    statement_descriptor: String
    status: String
    created_time: String
    last_modified_time: String

    sourceCard: SourceCard
  }

  ${eI("PullFromCard")}
`, nI = Pr`
  sourceCard(
    card_token: String!
  ): SourceCard
  pullFromCardTransfers(
    user_token: String
    card_token: String
    start_date: String
    end_date: String
    ${XT}
  ): PullFromCardCollection
`;
var iI = { types: tI, queries: nI };
const { gql: rI } = e, aI = rI`
  enum RestMethodEnum {
    DELETE
    GET
    PATCH
    POST
    PUT
  }
`;
var oI = { types: aI };
const { gql: Zt } = e, sI = Zt`
  type ReviewDetails {
    token: ID!
    type: String
    unit: String
    status: String
    available_values: ReviewAvailableValues
    available_actions: [String]
    history: [ReviewHistoryItem]
    notes: [ReviewNoteItem]
    alert: [ReviewAlert]
  }

  type ReviewAvailableValues {
    statuses: [String]
    dispositions: [String]
    teams: [String]
    disposition_reason_codes: [String]
  }

  type ReviewHistoryItem {
    token: ID!
    review_token: String
    user_token: String
    user_channel: String
    event_type: String
    event_description: String
    date_created: String
  }

  type ReviewNoteItem {
    token: ID!
    review_token: String
    user_token: String
    user_channel: String
    body: String
    date_created: String
    last_updated: String
  }

  type ReviewAlert {
    type: String
    unit_details: UnitDetails
  }

  type UnitDetails {
    status: String
    user_details: UserDetails
  }

  type UserDetails {
    token: ID!
    gender: String
    first_name: String
    last_name: String
    email: String
    address1: String
    city: String
    state: String
    postal_code: String
    country: String
    phone: String
    birth_date: String
  }

  type ReviewDisposition {
    disposition_value: String
    disposition_reason_codes: [String]
    disposition_note: String
    review_token: ID!
  }

  type AssignedReview {
    review_token: ID!
    transition_note: String
  }

  type AssignedAgent {
    email_addr: String
    first_name: String
    last_name: String
  }

  type AddedNote {
    token: String
    text: String
  }
`, cI = Zt`
  reviewDetails(
    reviewToken: ID!
  ): ReviewDetails
`, _I = Zt`
  updateReviewDisposition(
    reviewToken: ID!,
    disposition_value: String
    disposition_note: String
    disposition_reason_codes: [String]
  ): ReviewDisposition
  assignReviewToAgent(
   agent_token: String,
   transition_note: String,
   reviewTokens: [ID],
  ): [AssignedReview]
  addNoteToReview(
   reviewToken: ID!,
   text: String
  ): AddedNote 
`;
var dI = { types: sI, queries: cI, mutations: _I };
const { gql: vr } = e, { paginationParams: lI, generateCollectionType: Yn } = r, uI = vr`
  type Review {
    token: ID!
    type: String
    unit: String
    unit_token: String
    program_short_code: String
    business_token: String
    status: String
    disposition: String
    team: String
    external_token: String
    created_time: String
    last_modified_time: String
    date_closed: String
    alert: Alert
    assignment: Assignment
    programs: [Program]
  }

  type Program {
    short_code: String
    name: String
  }

  type Alert {
    kyc_status: String
    user_token: String
  }

  type UnitDetail {
    status: String
    identity_checks: [IdentityCheck]
  }

  type IdentityCheck {
    token: String
    check_name: String
    check_type: String
    user_token: String
    check_value: String
    check_status: String
    business_token: String
    prg_short_code: String
    component_status: String
    datetime_created: String
    datetime_modified: String
  }

  type Assignment {
    team: String
    customer_agent: Agent
    marqeta_agent: Agent
  }

  type Agent {
    token: String
    email: String
  }

  ${Yn("Review", "reviews")}
  ${Yn("Agent", "agents")}
`, gI = vr`
  reviews(
    ${lI},
    token: String,
    unit: String,
    status: String, 
    team: String,
    customer_agent_token: String,
    marqeta_agent_token: String,
    last_modified_time: String, 
    created_time: String,
    program_short_code: String,
    user_token: String
  ): ReviewCollection
  agents(reviewToken: ID!): AgentCollection
  allAgents: AgentCollection
`;
var pI = { types: uI, queries: gI };
const { gql: Xt } = e, { paginationParams: mI, generateCollectionType: SI } = r, yI = Xt`
  input RewardRuleAmountInput {
    greaterThan: Int
    lessThan: Int
  }

  input RewardRuleMccDynamicInput {
    includes: [RewardRuleMccDynamicIncludes]
  }

  input RewardRuleFiltersInput {
    amount: RewardRuleAmountInput
    mccDynamic: RewardRuleMccDynamicInput
  }

  input RewardRuleOutcomeInput {
    percentage: Int
    maxAmount: Int
  }

  input RewardRuleInput {
    type: RewardRuleType
    filters: RewardRuleFiltersInput
    outcome: RewardRuleOutcomeInput
  }

  enum RewardRuleType {
    CASHBACK
  }

  enum RewardRuleMccDynamicIncludes {
    HIGHEST_SPEND
  }

  type RewardRuleAmount {
    greaterThan: Int
    lessThan: Int
  }

  type RewardRuleMccDynamic {
    includes: [RewardRuleMccDynamicIncludes]
  }

  type RewardRuleFilters {
    amount: RewardRuleAmount
    mccDynamic: RewardRuleMccDynamic
  }

  type RewardRuleOutcome {
    percentage: Int
    maxAmount: Int
  }

  type RewardRule {
    type: RewardRuleType
    filters: RewardRuleFilters
    outcome: RewardRuleOutcome
  }

  type RewardPolicy {
    token: String
    name: String
    description: String
    rules: [RewardRule]
    createdTime: String
    updatedTime: String
  }

  ${SI("RewardPolicy")}
`, CI = Xt`
  rewardPolicy(token: ID!): RewardPolicy
  rewardPolicies(${mI}): RewardPolicyCollection
`, TI = `
  token: ID
  name: String!
  description: String
  rules: [RewardRuleInput]!
`, II = Xt`
  rewardPolicyCreate(${TI}): RewardPolicy
`;
var fI = { types: yI, queries: CI, mutations: II };
const { gql: Rr } = e, { paginationParams: DI, generateCollectionType: AI } = r, kI = Rr`
  type Role {
    token: ID!
    primary: Boolean
    name: String
    description: String
    created_time: String
    last_modified_time: String
  }

  ${AI("Role")}
`, hI = Rr`
  roles(
    ${DI}
    name: String
  ): RoleCollection
`;
var EI = { types: kI, queries: hI };
const { gql: br } = e, { generateCollectionType: $I } = r, PI = br`
  type S3BatchObject implements S3Object {
    signedUrl: String
    Bucket: String
    Key: String
    LastModified: String
    Metadata: S3BatchMetadata
    ContentType: String
  }

  type S3BatchMetadata {
    program: String
    uploadedBy: String
    description: String
    response: S3BatchMetadataResponse
  }

  type S3BatchMetadataResponse {
    code: String
    description: String
    total: Int
    success: Int
    failure: Int
    users_processed: Int
    cards_processed: Int
    funds_processed: Int
  }

  input S3BatchMetadataInput {
    program: String
    uploadedBy: String
    description: String
  }

  ${$I("S3BatchObject")}
`, vI = br`
  uploadBFPSignedUrl(
    Key: String!
    description: String
  ): String
  bfpTemplate: String
  bfpInstructions: String
  getBFPUploadHistory: S3BatchObjectCollection
  getMetadata: S3BatchMetadata
`;
var RI = { types: PI, queries: vI };
const { gql: Nr } = e, bI = Nr`
  interface S3Object {
    signedUrl: String
    Bucket: String
    Key: String
    LastModified: String
    ContentType: String
  }
`, NI = Nr`
  getSignedUrl(
    method: String
    Bucket: String
    Key: String
    ContentDisposition: String
    ContentType: String
  ): String
`;
var BI = { types: bI, queries: NI };
const { gql: en } = e, OI = en`
  type createSalesforceTicketResult {
    id: String
    case_number: String
    success: Boolean
  }
  type createNMISalesforceTicketResult {
    id: String
    case_number: String
    success: Boolean
  }
  type sendEmailResult {
    id: String
    success: Boolean
  }
  type Contact {
    Id: ID!
    Name: String!
    Email: String
    Contact_Role__c: String
    AccountId: String
    Program_Short_Code__c: String
  }
  type salesforceCase {
    Id: ID!
    CaseNumber: String!
    Subject: String
    Description: String
    RecordTypeId: String
    AccountId: String
  }
  type EmailMessage {
    Id: ID!
    Subject: String
    HtmlBody: String
    FromAddress: String
    ToAddress: String
    CcAddress: String
  }
`, FI = en`
  getSalesforceCase(CaseNumber: String!): salesforceCase
  getEmailMessagesByCaseId(salesforceCaseId: ID!): [EmailMessage]
  getContactByProgramShortCode(programShortCode: String! , contactRole : String!): [Contact]
`, wI = en`
  createSalesforceTicket(
    email: String!
    firstName: String
    lastName: String!
    subject: String
    description: String
    recordTypeName: String
    accountName: String
    isNMI: Boolean!
  ): createSalesforceTicketResult
  createNMISalesforceTicket(
    email: String!
    firstName: String
    lastName: String!
    subject: String
    description: String
    recordTypeName: String
    accountId: String
    isNMI: Boolean!
  ): createNMISalesforceTicketResult
  sendEmail(
    caseId: ID!
    toEmailAddress: String
    ccEmailAddress: String
    emailSubject: String
    emailBody: String!
    emailBodyType: String!
  ): sendEmailResult
`;
var qI = { types: OI, mutations: wI, queries: FI };
const { gql: tn } = e, { paginationParams: MI, generateCollectionType: UI } = r, LI = tn`
  type Sandbox {
    token: ID!
    display_name: String
    short_code: String
    owner: SandboxOwner
    created_time: String
    version: String
    internal_state: String
    last_modified_time: String
    credentials: SandboxCredentialCollection
    jobs: SandboxJobCollection
  }

  type SandboxOwner {
    token: String
    first_name: String
    last_name: String
    email: String
  }

  ${UI("Sandbox")}
`, xI = tn`
  sandboxes(${MI}): SandboxCollection
  sandbox(token: ID!): Sandbox
`, GI = tn`
  createCustomSandbox(
    issuing_region: String!,
    transaction_regions: [String]!,
    transaction_approver: String!,
    end_user: String!,
    card_usages: [String]!,
  ): Sandbox
  createSandbox: Sandbox
`;
var HI = { types: LI, queries: xI, mutations: GI };
const { gql: VI } = e, { generateCollectionType: YI } = r, WI = VI`
  type SandboxCredential {
    application_token: String
    access_token: String
    created_time: String
    last_modified_time: String
  }

  ${YI("SandboxCredential")}
`;
var KI = { types: WI };
const { gql: Br } = e, { generateCollectionType: zI } = r, jI = Br`
  type SandboxJob {
    token: ID!
    sandbox_token: String
    sandbox: Sandbox
    state: String
    estimated_completion_time: String
    created_time: String
    last_modified_time: String
    remaining_retry_attempts: Int
    retry_delay_timeout_in_minutes: Int
  }

  ${zI("SandboxJob")}
`, QI = Br`
  restartSandboxJob(token: String): SandboxJob
`;
var JI = { types: jI, mutations: QI };
const { gql: ZI } = e, XI = ZI`
  type ScaledDecimal {
    units: String!
    scale: Int!
  }
  input ScaledDecimalInput {
    units: String!
    scale: Int!
  }
`;
var ef = { types: XI };
const { gql: Or } = e, tf = Or`
  type GlobalSearchResult {
    business: Business
    cardholder: Cardholder
    card: Card
    dispute: Case
  }
`, nf = Or`
globalTokenAndAccountSearch(
    value: String
  ): GlobalSearchResult
globalTokenAndAccountSearchByCardProduct(
    value: String
  ): GlobalSearchResult
`;
var rf = { types: tf, queries: nf };
const { gql: Fr } = e, af = Fr`
  type ServerInfo {
    version: String
    commit_hash: String
    deploy_time: String
  }
`, of = Fr`
  serverInfo: ServerInfo
`;
var sf = { types: af, queries: of };
const { gql: cf } = e, _f = cf`
  type AccountingGroupAmount {
    accounting_group: AccountingGroupEnum!
    amount: ScaledDecimal!
  }

  input AccountingGroupAmountInput {
    accounting_group: AccountingGroupEnum!
    amount: ScaledDecimalInput!
  }
`;
var df = { types: _f };
const { gql: lf } = e, uf = lf`
  type AccountingGroupCategoryAmount {
    accounting_group_category: AccountingGroupCategoryEnum
    amount: ScaledDecimal
  }

  enum AccountingGroupCategoryEnum {
    FEE
    INTERCHANGE
    PURCHASE
    DRAWDOWN
    UNKNOWN
  }
`;
var gf = { types: uf };
const { gql: pf } = e, mf = pf`
  enum AccountingGroupEnum {
    ACQUIRER_FEE
    CROSS_BORDER_ISSUER_FEE
    CUR_CONV_CARDHOLDER_FEE
    CUR_CONV_ISSUER_FEE
    DRAWDOWN
    INTEGRITY_FEE
    INTERCHANGE_PAYABLES
    IRF_BASE_AMOUNT
    ISSUER_FEE
    PINDEBIT_ASSOC_FEE
    PURCHASE_PAYABLES
    SWITCH_FEE
    UNKNOWN
  }
`;
var Sf = { types: mf };
const { gql: wr } = e, yf = wr`
  type SettlementDateApprovalQueuePage {
    page_number: Int!
    page_size: Int!
    has_next_page: Boolean!
    settlement_date_lines: [SettlementDateApprovalQueueLine!]!
  }

  type SettlementDateApprovalQueueLine {
    settlement_date: String!
    counts_and_amounts: ApprovalQueueCountsAndAmounts!
    exception_count: String
    settled_total: String
    adjustment_fees: String
    adjustment_total: String
  }
`, Cf = wr`
  approvalExceptionTypeQueuePage(
    subnetwork: Subnetwork!
    type: ExceptionTypeEnum!
    page: Int = 0
    size: Int = 20
    start_settlement_date: String
    end_settlement_date: String
    dna_bank_tokens: [ID]
    program_short_codes: [String]
    program_types: [String]
    originator: String
  ): SettlementDateApprovalQueuePage
`;
var Tf = { types: yf, queries: Cf };
const { gql: If } = e, ff = If`
  type ApprovalQueueCountsAndAmounts {
    adjustment_amounts: [AccountingGroupCategoryAmount!]!
    credit_amount: ScaledDecimal
    credit_variance: ScaledDecimal
    debit_amount: ScaledDecimal
    debit_variance: ScaledDecimal
    exception_count: Int!
    settled_amounts: [AccountingGroupCategoryAmount!]!
  }
`;
var Df = { types: ff };
const { gql: qr } = e, Af = qr`
  type ApprovalQueueSummary {
    network: Network!
    subnetworks: [SubnetworkApprovalQueueSummary!]!
  }

  type SubnetworkApprovalQueueSummary {
    subnetwork: Subnetwork!
    lines: [SubnetworkApprovalQueueSummaryLine!]!
  }

  type SubnetworkApprovalQueueSummaryLine {
    type: ExceptionTypeEnum!
    exception_count: String
    settled_total: String
    adjustment_fees: String
    adjustment_total: String
    counts_and_amounts: ApprovalQueueCountsAndAmounts!
  }
`, kf = qr`
  approvalQueueSummary(
    network: Network!
  ): ApprovalQueueSummary
`;
var hf = { types: Af, queries: kf };
const { gql: Ef } = e, $f = Ef`
  bulkRejectAdjustments(
    adjustment_ids: [TransactionAdjustmentInfoInput!]
    reason: String!
    notes: String
  ): SettlementsBulkActionResponse 
`;
var Pf = { mutations: $f };
const { gql: vf } = e, Rf = vf`
  bulkSubmitExceptions(
    subnetwork: String!
    tx_hash_internal_ids: [String!]
    adjustment_action: ExceptionTypeEnum!
    reason: String!
    note: String
  ): SettlementsBulkActionResponse
`;
var bf = { mutations: Rf };
const { gql: Nf } = e, Bf = Nf`
  createExceptionNote(
    note: String!
    tx_hash_internal_id: String!
  ): SettlementsPostResponse
`;
var Of = { mutations: Bf };
const { gql: Mr } = e, Ff = Mr`
  type ExceptionsSummaryPage {
    network: Network
    subnetwork_summaries: [ExceptionsSummary]
  }

  type ExceptionsSummary {
    subnetwork: Subnetwork
    status: ExceptionsSummaryStatuses
    summary_lines: [ExceptionSummaryLine]
  }

  type ExceptionSummaryLine {
    type: ExceptionTypeEnum
    exception_count: Int
    debit_amount: ScaledDecimal
    credit_amount: ScaledDecimal
    variance_amount: ScaledDecimal
  }

  enum ExceptionsSummaryStatuses {
    WAITING
    READY
    IN_PROGRESS
    COMPLETE
    PARTIALLY_RECONCILED
  }
`, wf = Mr`
  exceptionsSummaryPage(network: Network!, from: String, to: String): ExceptionsSummaryPage
`;
var qf = { types: Ff, queries: wf };
const { gql: Mf } = e, Uf = Mf`
  enum ExceptionTypeEnum {
    OVERPOSTED
    FAILED_TO_POST
    OTHER
    WRITE_OFF
    MANUALLY_RECONCILE
    INVALID_EXCEPTION
    EXCLUDE_EXCEPTION
  }
`;
var Lf = { types: Uf };
const { gql: xf } = e, Gf = xf`
  type ExceptionTypeSummaryCounts {
    exception_type: ExceptionTypeEnum
    count: Int!
  }
`;
var Hf = { types: Gf };
const { gql: Vf } = e, Yf = Vf`
  type ExceptionTypeSummaryVariance {
    exception_type: ExceptionTypeSummaryVarianceTypes
    credit_amount: ScaledDecimal
    debit_amount: ScaledDecimal
    net_amount: ScaledDecimal
  }

  enum ExceptionTypeSummaryVarianceTypes {
    OVERPOSTED
    FAILED_TO_POST
    OTHER
  }
`;
var Wf = { types: Yf };
const { gql: Ur } = e, Kf = Ur`
  type ExportDataResponse {
    status_code: Int!
    status: ExportDataStatus
  }
`, zf = Ur`
  exportExceptionQueueBySubnetwork(
    subnetwork: Subnetwork!
    program_types: [ProgramType!]
    program_short_codes: [String!]
    dna_bank_tokens: [ID!]
    settlement_currencies: [CurrencyCode!]
    start_settlement_date: String
    end_settlement_date: String
    exception_type: ExceptionTypeEnum!
  ): ExportDataResponse
`;
var jf = { mutations: zf, types: Kf };
const { gql: Qf } = e, Jf = Qf`
  type FeeAmount {
    fee_type: FeeType!
    amount: ScaledDecimal!
  }

  input FeeAmountInput {
    fee_type: FeeType!
    amount: ScaledDecimalInput!
  }
`;
var Zf = { types: Jf };
const { gql: Xf } = e, eD = Xf`
  enum FeeType {
    NETWORK_FEE_UNKNOWN
    NETWORK_FEE_TYPE_ISSUER_FEE
    NETWORK_FEE_TYPE_SWITCH_FEE
    NETWORK_FEE_TYPE_PINDEBIT_ASSOC_FEE
    NETWORK_FEE_TYPE_ACQUIRER_FEE
    NETWORK_FEE_TYPE_INTERCHANGE_FEE
    NETWORK_FEE_TYPE_CUR_CONV_CARDHOLDER_FEE
    NETWORK_FEE_TYPE_CUR_CONV_ISSUER_FEE
    NETWORK_FEE_TYPE_CROSS_BORDER_ISSUER_FEE
    UNRECOGNIZED
  }
`;
var tD = { types: eD };
const { gql: Lr } = e, nD = Lr`
  type ExportDataStatus {
    status: ExportStatusType!
    filename: String!
    user_email: String!
    date_requested: String!
    export_type: ExportType!
    request_info: ExportRequestInfo
    temporary_download_url(download_name: String): String
  }
  type ExportRequestInfo {
    export_type: ExportType!
    subnetwork: Subnetwork!
    program_types: [ProgramType!]
    program_short_codes: [String!]
    dna_bank_tokens: [ID!]
    settlement_currencies: [CurrencyCode!]
    start_settlement_date: String
    end_settlement_date: String
    exception_type: ExceptionTypeEnum
  }
  enum ExportStatusType {
    COMPLETED
    IN_PROGRESS
    ERROR
  }
  enum ExportType {
    EXCEPTION_QUEUE
  }
`, iD = Lr`
  exportedDataStatuses(
    user_emails: [String!]
    export_types: [ExportType!]
  ): [ExportDataStatus!]
`;
var rD = { types: nD, queries: iD };
const { gql: aD } = e, oD = aD`
  exportDownloadUrl(
    filename: String!
    download_name: String
  ): String
`;
var sD = { queries: oD };
const { gql: xr } = e, cD = xr`
  type SettledDateQueue {
    prev_page_token: String
    next_page_token: String
    exceptions: [TransactionHashExceptionSummary]
  }
`, _D = xr`
  settledDateQueue(
    adjustment_action: ExceptionTypeEnum!
    dna_bank_tokens: [ID]
    end_submitted_date: String
    page_size: Int!
    page_token: String
    program_short_codes: [String]
    program_types: [String]
    settlement_date: String!
    start_submitted_date: String
    subnetwork: Subnetwork!
    originator: String
  ): SettledDateQueue
`;
var dD = { types: cD, queries: _D };
const { gql: lD } = e, uD = lD`
  type SettlementNote {
    createdTime: String
    email: String
    note: String
    user_name: String
  }
`;
var gD = { types: uD };
const { gql: pD } = e, mD = pD`
  type SettlementTransaction {
    accounting_group_and_amounts: [AccountingGroupAmount!]
    acquirer_reference_id: String
    additional_information: String
    batch_number: String
    billing_amount: ScaledDecimal
    business_activity: String
    conversion_fee_amount: ScaledDecimal
    conversion_fee_currency: String
    created_date: String
    cycle: String
    fee_program_indicator: String
    ft_sre: String
    function_code: String
    ica: String
    itc: String
    local_transaction_date_time: String
    masked_pan: String
    merchant_category_code: String
    merchant_country: String
    merchant_id: String
    merchant_name: String
    message_reason_code: String
    message_type_indicator: String
    original_id: String
    originator: String
    processing_code: String
    reason_code: String
    retrieval_reference_number: String
    settlement_currency: String
    source: TransactionHashExceptionDetailEnum
    sre: String
    system_trace_audit_number: String
    transaction_code: String
    transaction_function: String
    transaction_summary: SettlementTransactionSummary
    transaction_token: ID!
    transaction_type: String
  }

  enum TransactionHashExceptionDetailEnum {
    MQ
    NETWORK
  }
`;
var SD = { types: mD };
const { gql: yD } = e, CD = yD`
  type SettlementTransactionSummary {
    cross_border_fee: ScaledDecimal
    fees: ScaledDecimal
    interchange_fee: ScaledDecimal
    settled_total: ScaledDecimal
    surcharge_atm_pin_debit_fee: ScaledDecimal
    switch_fee: ScaledDecimal
    transactions: ScaledDecimal
  }
`;
var TD = { types: CD };
const { gql: ID } = e, fD = ID`
  type SettlementsBulkActionResponse {
    status: Int
    statusText: String
    message: String
    unsuccessful_tx_hash_internal_ids: [String]
  }
`;
var DD = { types: fD };
const { gql: AD } = e, kD = AD`
  type SettlementsPostResponse {
    status: Int
    ok: Boolean
    statusText: String
    message: String
  }
`;
var hD = { types: kD };
const { gql: ED } = e, $D = ED`
  type SettlementsPutResponse {
    status: Int
    statusText: String
  }
`;
var PD = { types: $D };
const { gql: Gr } = e, vD = Gr`
  type SubnetworkExceptionQueuePage {
    prev_page_token: String
    next_page_token: String
    exceptions: [TransactionHashExceptionSummary]
  }
`, RD = Gr`
  exceptionQueueBySubnetwork(
    dna_bank_tokens: [ID]
    end_settlement_date: String
    originator: String
    ica_values: [String]
    page_size: Int!
    page_token: String
    program_short_codes: [String]
    program_types: [ProgramType]
    settlement_currencies: [CurrencyCode]
    start_settlement_date: String
    subnetwork: Subnetwork!
    exception_type: ExceptionTypeEnum!
  ): SubnetworkExceptionQueuePage
`;
var bD = { types: vD, queries: RD };
const { gql: Hr } = e, ND = Hr`
  input TransactionAdjustmentInfoInput {
    adjustment_idx: Int!
    tx_hash_internal_id: String!
  }

  type TransactionAdjustmentInfo {
    adjustment_type: ExceptionTypeEnum
    amounts: [AccountingGroupAmount]
    created_by: String
    created_date: String
    cross_border_fee: ScaledDecimal
    fees_total: ScaledDecimal
    idx: Int
    integrity_fee: ScaledDecimal
    interchange_payable: ScaledDecimal
    irf_base_fee: ScaledDecimal
    submitted_total: ScaledDecimal
    surcharge_atm_pin_debit_fee: ScaledDecimal
    transactions_total: ScaledDecimal
  }
`, BD = Hr`
  approveTransactionAdjustment(
    transactionApprovalIds: [TransactionAdjustmentInfoInput!]
  ): SettlementsBulkActionResponse
`;
var OD = { types: ND, mutations: BD };
const { gql: FD } = e, wD = FD`
  type TransactionAdjustmentInfoWithAccountingCategory {
    idx: Int
    created_date: String
    amounts: [AccountingGroupCategoryAmount]
  }
`;
var qD = { types: wD };
const { gql: MD } = e, UD = MD`
  enum TransactionCompositeSourceEnum {
    NETWORK
    MQ
    BOTH
  }
`;
var LD = { types: UD };
const { gql: Vr } = e, xD = Vr`
  enum TransactionHashAdjustmentRejectionReasonEnum {
    DUPLICATE_ACTION_SUBMITTED
    INCORRECT_ACTION_SUBMITTED
    INCORRECT_AMOUNT_SUBMITTED
    INCORRECT_CATEGORY_SUBMITTED
    PAST_SLA
    POTENTIAL_PROCESSING_ERROR
  }
`, GD = Vr`
  rejectTransactionAdjustment(
    tx_hash_internal_id: String!,
    reason: TransactionHashAdjustmentRejectionReasonEnum!,
    adjustment_idx: Int!
  ): SettlementsPostResponse
`;
var HD = { types: xD, mutations: GD };
const { gql: Yr } = e, VD = Yr`
  input TransactionHashExceptionCommandInput {
    lines: [AccountingGroupAmountInput]
    reason: TransactionTokenAdjustmentCommandReasonEnum!
  }
  type TransactionHashExceptionCommand {
    status: String
    status_code: Int
  }
`, YD = Yr`
  createTransactionHashExceptionCommand(
    action: TransactionTokenAdjustmentCommandActionEnum!,
    reference_id: String
    transaction_hash_exception_adjustment: TransactionHashExceptionCommandInput!
    tx_hash_internal_id: String!,
  ): SettlementsPostResponse
`;
var WD = { types: VD, mutations: YD };
const { gql: Wr } = e, KD = Wr`
  type TransactionHashExceptionDetail {
    activity: [SettlementNote]
    adjustment: TransactionAdjustmentInfo
    common_data: TransactionHashExceptionDetailCommonData
    exception_type: ExceptionTypeEnum
    exception_variance_amounts: [AccountingGroupAmount]
    hash_id: String!
    settled_amounts: [AccountingGroupAmount]
    settled_details: TransactionHashExceptionSettlementDetails
    settlement_date: String
    transactions: [SettlementTransaction]
    tx_hash_internal_id: String!
    user_name: String
  }
`, zD = Wr`
  transactionHashExceptionDetail(tx_hash_internal_id: String!): TransactionHashExceptionDetail
`;
var jD = { types: KD, queries: zD };
const { gql: QD } = e, JD = QD`
  type TransactionHashExceptionDetailCommonData {
    acquirer_reference_id: String
    bank: DNABank
    currency_code: String
    ica: String
    masked_pan: String
    merchant: SettlementMerchant
    net_ref_id: String
    network: String
    program_short_code: String
    program_type: String
    reference_id: String
    settlement_service_number: String
    source: TransactionCompositeSourceEnum
    state: String
    subnetwork: String
  }

  type SettlementMerchant {
    name: String
    mid: String
    country: String
  }
`;
var ZD = { types: JD };
const { gql: Kr } = e, XD = Kr`
  type TransactionHashExceptionPan {
    pan: String!
  }
`, eA = Kr`
  transactionHashExceptionPan(tx_hash_internal_id: String!): TransactionHashExceptionPan
`;
var tA = { types: XD, queries: eA };
const { gql: nA } = e, iA = nA`
  enum TransactionHashExceptionStateEnum {
    AWAITING_ACTION
    ADJUSTMENT_FAILED_RECONCILIATION
    ADJUSTMENT_REJECTED
    ADJUSTMENT_PENDING_APPROVAL
    FAILED_BATCH_SUBMISSION
    FAILED_BATCH_APPROVAL
  }
`;
var rA = { types: iA };
const { gql: aA } = e, oA = aA`
  type TransactionHashExceptionSummary {
    adjustment: TransactionAdjustmentInfoWithAccountingCategory
    bank: DNABank
    hash_id: String
    ica: String
    latest_jcard_error_response: String
    local_transaction_date_time: String
    masked_pan: String
    message_reason_code: String
    network_reference_id: String
    program_short_code: String
    program_type: String
    reason: String
    rrn: String
    settled_amounts: [AccountingGroupCategoryAmount]
    settlement_date: String
    settlement_currency: String
    source: String
    stan: String
    state: TransactionHashExceptionStateEnum
    tx_hash_internal_id: String!
    variance_amount: ScaledDecimal
  }
`;
var sA = { types: oA };
const { gql: cA } = e, _A = cA`
  input TransactionSettlementAmountAndFeesInput {
    settlement_amount: ScaledDecimalInput
    fee_amounts: [FeeAmountInput]
  }

  type TransactionSettlementAmountAndFees {
    settlement_amount: ScaledDecimal
    fee_amounts: [FeeAmount]
  }
`;
var dA = { types: _A };
const { gql: lA } = e, uA = lA`
  enum TransactionTokenAdjustmentCommandActionEnum {
    ADJUST_TRANSACTION
    SUSPEND_TRANSACTION
    WRITE_OFF_TRANSACTION
    MANUAL_TRANSACTION
    INVALID_EXCEPTION
    EXCLUDE_TRANSACTION
  }
`;
var gA = { types: uA };
const { gql: pA } = e, mA = pA`
  enum TransactionTokenAdjustmentCommandReasonEnum {
    FAILED_TO_POST
    OVERPOSTED
    CHARGEBACK_INITIATED
    RESEARCH_REQUIRED
    WAITING_TO_OFFSET_TRANSACTION
    CUSTOMER_APPEASEMENT
    NON_MARQETA_CARDHOLDER
    PAST_SLA
    POTENTIAL_FRAUD
    PROGRAM_ENABLED_LATE
    PROD_SUPPORT_ACTION
    CHARGEBACK_PRESENT
    LATE_JCARD_TRANSACTIONS
    ROUNDING_ERROR
    NRID_IN_DIFFERENT_SUBNETWORKS
    MISSING_SURCHARGE_AMOUNT_IN_FDS
    MISSING_TRANSACTION_IN_JCARD
    SETTLEMENT_DATE_MISMATCH
    OPPOSITE_SURCHARGE_AMOUNT_SIGNAGE_IN_FDS
    TX_NOT_REQUIRED_FOR_RECON
    REPRESENTMENT_PRESENT
    CHARGEBACK_IN_JCARD
    CHARGEBACK_IN_TXM
    CHARGEBACK_IN_TXM_AND_JCARD
    ATM_ALREADY_PRESENT
    OTHER
  }
`;
var SA = { types: mA };
const { gql: yA } = e, CA = yA`
  type TransactionHashExceptionSettlementDetails {
    cross_border_fee: ScaledDecimal
    days: String
    fees: ScaledDecimal
    integrity_fee: ScaledDecimal
    interchange_fee: ScaledDecimal
    irf_base_fee: ScaledDecimal
    settled_total: ScaledDecimal
    submitted_total: ScaledDecimal
    surcharge_atm_pin_debit_fee: ScaledDecimal
    switch_fee: ScaledDecimal
    transactions: ScaledDecimal
    variance: ScaledDecimal
  }
`;
var TA = { types: CA };
const IA = df, fA = gf, DA = Sf, AA = Tf, kA = Df, hA = hf, EA = Pf, $A = bf, PA = Of, vA = qf, RA = Lf, bA = Hf, NA = Wf, BA = jf, OA = Zf, FA = tD, wA = rD, qA = sD, MA = dD, UA = gD, LA = SD, xA = TD, GA = DD, HA = hD, VA = PD, YA = bD, WA = OD, KA = qD, zA = LD, jA = HD, QA = WD, JA = jD, ZA = ZD, XA = tA, ek = rA, tk = sA, nk = dA, ik = gA, rk = SA, ak = TA;
var ok = [
  IA,
  fA,
  DA,
  AA,
  kA,
  hA,
  EA,
  $A,
  PA,
  vA,
  RA,
  bA,
  NA,
  qA,
  BA,
  wA,
  OA,
  FA,
  MA,
  UA,
  LA,
  xA,
  GA,
  HA,
  VA,
  YA,
  WA,
  KA,
  zA,
  jA,
  QA,
  JA,
  ZA,
  XA,
  ek,
  tk,
  nk,
  ik,
  rk,
  ak
];
const { gql: nn } = e, { paginationParams: sk, generateCollectionType: ck } = r, _k = nn`
  type Sku {
    token: ID!
    active: Boolean
    description: String
    image_url: String
    program: String
    provider: FulfillmentProvider
    name: String
    sku_id: String
    type: String
    created_time: String
    last_modified_time: String
  }

  ${ck("Sku")}
`, dk = nn`
  sku(token: ID!): Sku
  skus(
    ${sk},
    token: ID,
    active: Boolean,
    name: String,
    program: String,
    provider_name: String,
    provider_token: String,
    sku_id: String,
    type: String,
  ): SkuCollection
`, lk = nn`
  createSku(
    name: String!,
    program: String!,
    provider_token: String!,
    sku_id: String!,
    type: String!,
    active: Boolean,
    description: String,
    image_url: String,
    token: ID,
  ): Sku
  updateSku(
    token: ID!,
    active: Boolean,
    description: String,
    image_url: String,
    name: String,
    sku_id: String,
    type: String,
  ): Sku
`;
var uk = { types: _k, queries: dk, mutations: lk };
const { gql: zr } = e, gk = zr`
  type SmartbotQuery {
    responseText: String
    queryId: String
    sessionId: String
    query: String
    model_name: String
    url_list: [String]
    metadata: String
    user_feedback: Int
  }
`, pk = zr`
  createSmartbotQuery(
    query: String!
    applicationName: String!
    indexName: String!
  ): SmartbotQuery
`;
var mk = { types: gk, mutations: pk };
const { gql: jr } = e, { paginationParams: Wn, generateCollectionType: Sk } = r, yk = jr`
  enum VelocityControlService {
    ACHO
  }

  enum VelocityControlAssociation {
    ACCOUNT
    PROGRAM
  }

  enum VelocityControlDirection {
    PUSH
    PULL
  }

  enum VelocityControlSpeed {
    STANDARD
    SAME_DAY
  }

  enum VelocityControlType {
    AMOUNT
    USAGE
  }

  enum VelocityControlVelocityWindow {
    TRANSACTION
    DAY
    MONTH
  }

  type SsvcVelocityControl {
    token: String
    service: VelocityControlService
    association: VelocityControlAssociation
    direction: VelocityControlDirection
    speed: VelocityControlSpeed
    currency_code: String
    type: VelocityControlType
    limit: Int
    velocity_window: VelocityControlVelocityWindow
    active: Boolean
  }

  ${Sk("SsvcVelocityControl")}
`, Ck = jr`
  ssvcVelocityControls(
    ${Wn},
  ): SsvcVelocityControlCollection
  ssvcVelocityControlsGranular(
    ${Wn},
  ): SsvcVelocityControlCollection
`;
var Tk = { types: yk, queries: Ck };
const { gql: Qr } = e, Ik = Qr`
  type StateCode {
    state: String
    stusab: String
    state_name: String
    statens: String
  }
`, fk = Qr`
  stateCodes: [StateCode]!
`;
var Dk = { types: Ik, queries: fk };
const { gql: Ak } = e, kk = Ak`
  enum Subnetwork {
    SUBNETWORK_CIRRUS
    SUBNETWORK_DISCOVER
    SUBNETWORK_GATEWAY_JIT
    SUBNETWORK_MAESTRO
    SUBNETWORK_MANAGED_JIT
    SUBNETWORK_MASTERCARD_SIG
    SUBNETWORK_PULSE
    SUBNETWORK_VISAINTERLINK
    SUBNETWORK_VISANET
    SUBNETWORK_VISANETDEBIT
    SUBNETWORK_VISAPLUS
    UNRECOGNIZED
  }
`;
var hk = { types: kk };
const { gql: Jr } = e, Ek = Jr`
  input TokenizationCardActionExpiryDate {
    month: String
    year: String
  }

  type TokenizationCardActionSuccessResponse {
    success: Boolean
  }

  type TokenizationCardActionErrorResponse {
    error_code: String
    error_message: String
  }

  union TokenizationCardActionResponse =
      TokenizationCardActionSuccessResponse
    | TokenizationCardActionErrorResponse
`, $k = Jr`
  updateTokenizationExpirationCard(
    primary_account_number: String!
    old_card_token: String
    old_pan_expiry: TokenizationCardActionExpiryDate!
    new_card_token: String
    new_pan_expiry: TokenizationCardActionExpiryDate!
  ): TokenizationCardActionResponse
  
  updateTokenizationSwapCard(
    old_primary_account_number: String!
    old_pan_expiry: TokenizationCardActionExpiryDate!
    old_card_token: String
    new_primary_account_number: String!
    new_pan_expiry: TokenizationCardActionExpiryDate!
    new_card_token: String
  ): TokenizationCardActionResponse
`;
var Pk = { types: Ek, mutations: $k };
const { gql: Zr } = e, { paginationParams: vk, generateCollectionType: Rk } = r, bk = Zr`
  type TokenizationTokenServiceProvider {
    token_reference_id: String
    pan_reference_id: String
    correlation_id: String
    token_requestor_id: String
    token_requestor_name: String
    token_type: String
    token_pan: String
    token_expiration: String
    token_score: String
    token_assurance_level: String
    token_eligibility_decision: String
  }

  type TokenizationDevice {
    token: String
    type: String
    language_code: String
    device_id: String
    phone_number: String
    name: String
    location: String
    ip_address: String
  }

  type TokenizationDigitalWalletProviderProfile {
    account: WalletAccount
    risk_assessment: RiskAssessment
    device_score: String
    pan_source: String
    reason_code: String
  }

  type TokenizationDigitalWalletAddressVerification {
    name: String
    street_address: String
    postal_code: String
  }

  type TokenizationEncryptedData {
    token_service_provider: TokenizationTokenServiceProvider
    device: TokenizationDevice
    address_verification: TokenizationDigitalWalletAddressVerification
  }

  type TokenizationDigitalWalletToken {
    token: String
    card_token: String
    state: String
    state_reason: String
    fulfillment_status: String
    issuer_eligibility_decision: String
    wallet_provider_profile: WalletProviderProfile
    created_time: String
    last_modified_time: String
    encrypted_data: TokenizationEncryptedData
    token_service_provider: TokenizationTokenServiceProvider
    device: TokenizationDevice
    address_verification: TokenizationDigitalWalletAddressVerification
  }

  enum TokenizationTokenType {
    DEVICE_SECURE_ELEMENT
    MERCHANT_CARD_ON_FILE
    DEVICE_CLOUD_BASED
    ECOMMERCE_DIGITAL_WALLET
    PSEUDO_ACCOUNT
  }

  enum TokenizationRequestorName {
    APPLE_PAY
    ANDROID_PAY
    SAMSUNG_PAY
    MICROSOFT_PAY
    VISA_CHECKOUT
    FACEBOOK
    NETFLIX
    UNKNOWN
  }

  input InputTokenizationDigitalWalletFilter {
    correlation_id: String
    device_id: String
    end_date: String
    pan_reference_id: String
    start_date: String
    state: String
    token_reference_id: String
    token_requestor_name: String
    token_type: String
  }

  ${Rk("TokenizationDigitalWalletToken")}
`, Nk = Zr`
  tokenizationDigitalWalletTokens(
    filter_params: InputTokenizationDigitalWalletFilter
    ${vk}
  ): TokenizationDigitalWalletTokenCollection
    
  tokenizationDigitalWalletToken(token: ID!): TokenizationDigitalWalletToken
  tokenizationDigitalWalletTokenShowTokenPan(token: ID!): TokenizationDigitalWalletToken
  tokenizationDigitalWalletTokensCard(token: ID!): TokenizationDigitalWalletToken
`;
var Bk = { types: bk, queries: Nk };
const { gql: rn } = e, { paginationParams: Ok, generateCollectionType: Fk } = r, wk = rn`
  enum TokenizationChannel {
    API
    TOKEN_SERVICE_PROVIDER
    TOKEN_SERVICE_PROVIDER_API
    DIGITAL_WALLET
    IVR
    FRAUD
    ADMIN
    SYSTEM
  }
  enum TokenizationState {
    REQUESTED
    ACTIVE
    TERMINATED
    SUSPENDED
    REQUEST_DECLINED
  }
  enum TokenizationFullfilmentStatus {
    DECISION_RED
    DECISION_YELLOW
    DECISION_GREEN
    REJECTED
    PROVISIONED
  }

  type TokenizationDigitalWalletTokenHash {
    description: String
    token: String
  }

  type TokenizationTransitionCardSwapHash {
    previousCardToken: String
    newCardToken: String
  }

  type TokenizationDigitalWalletTransition {
    token: String
    digital_wallet_token: TokenizationDigitalWalletTokenHash
    card_swap: TokenizationTransitionCardSwapHash
    type: String
    channel: TokenizationChannel
    state: TokenizationState
    fulfillment_status: TokenizationFullfilmentStatus
    reason: String
    reason_code: String
    created_time: String
  }

  input InputTokenizationDigitalWalletTokenHash {
    token: String!
  }

  ${Fk("TokenizationDigitalWalletTransition")}
`, qk = rn`
  tokenizationDigitalWalletTransitions(
    token: ID!
    ${Ok}
  ): TokenizationDigitalWalletTransitionCollection
`, Mk = rn`
  createTokenizationDigitalWalletTransition(
    reason_code: String!
    channel: String!
    state: String
    digital_wallet_token: InputTokenizationDigitalWalletTokenHash!
    reason: String
  ): TokenizationDigitalWalletTransition
`;
var Uk = { types: wk, queries: qk, mutations: Mk };
const { gql: Xr } = e, { paginationParams: Kn, generateCollectionType: Lk } = r, xk = Xr`
  type TokenizationVerificationMethod {
    enabled: Boolean
    phone_number: String
    bank_app_data: String
  }
  type TokenizationProgram {
    long_code: String
    external_program_name: String
    sms_sender_id: String
  }

  type TokenizationVerificationMethods {
    sms: TokenizationVerificationMethod
    email: TokenizationVerificationMethod
    customer_service: TokenizationVerificationMethod
    bank_app: TokenizationVerificationMethod
  }
  type TokenizationProgramIdvMethods {
    token: String
    program: TokenizationProgram
    network: String
    active: Boolean
    verification_methods: TokenizationVerificationMethods
    created_time: String
    last_modified_time: String
  }

  ${Lk("TokenizationProgramIdvMethods")}
`, Gk = Xr`
  tokenizationProgramIdvMethods(${Kn}): TokenizationProgramIdvMethodsCollection
  tokenizationProgramIdvMethodsGranular(${Kn}): TokenizationProgramIdvMethodsCollection
`;
var Hk = { types: xk, queries: Gk };
const { gql: ea } = e, { generateCollectionType: Vk, paginationParams: Y } = r, Yk = ea`
  type TransactionAddressVerificationRequest {
    street_address: String
    zip: String
    postal_code: String
  }

  type TransactionAddressVerificationOnFile {
    street_address: String
    zip: String
    postal_code: String
  }

  type TransactionAddressVerificationResponse {
    code: String
    memo: String
    additional_information: String
  }

  type TransactionAddressVerification {
    request: TransactionAddressVerificationRequest
    on_file: TransactionAddressVerificationOnFile
    response: TransactionAddressVerificationResponse
  }

  type TransactionFee {
    type: String
    amount: Float
    credit_debit: String
  }

  type SettlementData {
    amount: Float
    conversion_rate: Float
    currency_code: String
  }

  type Fraud {
    network: TransactionScores
  }

  type TransactionScores {
    transaction_risk_score: String
  }
  
  type Transaction {
    acquirer_exemption: [String]
    acquirer_fee_amount: Float
    acquirer_reference_data: String
    acquirer: Acquirer
    acting_cardholder_token: String
    acting_user_token: String
    address_verification: TransactionAddressVerification
    amount: Float
    approval_code: String
    atm_subnetwork: String
    auto_reload: AutoReload
    avs: String
    bank_transfer_token: ID
    bankTransfer: AchBankTransfer
    batch_number: String
    business_token: String
    business: Business
    name: String
    card_acceptor: CardAcceptor
    card_security_code_verification: String
    card_token: String
    card: Card
    card_metadata: String
    cardholder_authentication_data: CardholderAuthenticationData
    cardholder_authentication_data_v2: CardholderAuthenticationData
    cardholder_token: String
    cardholder_transaction_time: String
    cardholder: Cardholder
    chargeback: Chargeback
    clearing_record_sequence_number: String
    created_time: String
    currency_code: String
    currencyConversionNetworkOriginalAmount: String
    currencyConversionNetworkOriginalCurrencyCode: String
    currencyConversionNetworkConversionRate: Float
    currencyConversionNetworkSettlementData: SettlementData
    digital_wallet_token: DigitalWalletToken
    direct_deposit: DirectDepositRecord
    duration: Int
    electronic_commerce_indicator: String
    fee_transfer: String
    fee: Fee
    fees: [TransactionFee]
    fraud: Fraud
    gpa_order_unload: GpaOrderUnload
    gpa_order: GpaOrder
    gpa: GpaObject
    identifier: String
    incremental_authorization_transaction_tokens: String
    is_installment: Boolean
    is_recurring: Boolean
    issuer_interchange_amount: Float
    issuer_payment_node: String
    issuer_received_time: String
    issuing_country: String
    merchant: Merchant
    msa_orders(${Y}): MsaOrderCollection
    multi_clearing_sequence_number: String
    network_fees(${Y}): FeeCollection
    network: String
    network_reference_id: String
    offer_orders: String
    peer_transfer: String
    polarity: String
    pos: Pos
    preceding_related_transaction_token: String
    preceding_related_transaction: Transaction
    program_transfer: String
    pull_from_card: PullFromCard
    pullFromCard: PullFromCard
    real_time_fee_group: String
    related_authorization: Transaction
    request_amount: Float
    response: Response
    rewards: [String]
    risk_assessment: RiskAssessment
    settlement_date: String
    standin_approved_by: String
    state: String
    store: Store
    subnetwork: String
    token: ID!
    transaction_metadata: String
    type: String
    user_metadata: String
    user_token: String
    user_transaction_time: String
    verification_result: String
    verification_value_created_by: String
  }

  ${Vk("Transaction")}
`, Wk = ea`
  relatedTransactions(
    end_date: String,
    start_date: String,
    state: String,
    token: ID!,
    type: String,
    ${Y}
  ): TransactionCollection
  relatedTransactions_v2(
    end_date: String,
    start_date: String,
    state: String,
    token: ID!,
    type: String,
    ${Y}
  ): TransactionCollection
  transaction(token: ID!): Transaction
  transaction_v2(token: ID!): Transaction
  transactions(
    ${Y}
    cardholder_token: ID
    business_token: ID
    acting_cardholder_token: ID
    card_token: ID
    merchant_token: ID
    campaign_token: ID
    type: String
    state: String
    sort_by: String
    start_date: String
    user_token: String
    end_date: String
  ): TransactionCollection
`;
var Kk = { types: Yk, queries: Wk };
const { gql: an } = e, { paginationParams: zk, generateCollectionType: jk } = r, Qk = an`
  type User {
    token: ID!
    first_name: String
    last_name: String
    phone: String
    email: String
    customer_token: String
    ttl_in_seconds: Int
    active: Boolean
    password_updated_time: String
    failed_login_attempts: Int
    last_failed_login_attempt_time: String
    last_signed_in_time: String
    last_signed_in_ip_address: String
    email_verified_time: String
    email_opt_in: Boolean
    terms_of_service: Boolean
    hub_spot_sync_id: String
    mfa_enabled: Boolean
    mfa_totp_enabled: Boolean
    mfa_totp_revealed: Boolean
    mfa_last_challenge_time: String
    has_additional_auth_factor: Boolean
    device_token: ID
    sandboxes: SandboxCollection
    scopes: [String]
    roles: [UserRole]
    created_time: String
    last_modified_time: String
  }

  type UserRole {
    domain_type: String
    domain_id: String
    role_token: String
    environment: String
  }

  input UserRoleInput {
    domain_type: String
    domain_id: String
    role_token: String
    environment: String
  }

  input ProgramInput {
    program: String
    short_name: String
  }

  input RedseaRolesInput {
    domain_type: String
    domain_id: String
    role_token: String
    environment: String
  }

  type JanusUser {
    id: String
  }

  ${jk("User")}
`, Jk = an`
  currentUser: User
  user(
    token: String
  ): User
  users(
    ${zk},
    customer_token: String
    email: String
    first_name: String
    last_name: String
    phone: String
    token: String
  ): UserCollection
  userLookup(
    email: String
    first_name: String
    last_name: String
    phone: String
    webToken: String!
  ): User
`, Zk = an`
  updateUser(
    token: String
    first_name: String
    last_name: String
    active: Boolean
    mfa_totp_enabled: Boolean
    mfa_enabled: Boolean
    mfa_totp_revealed: Boolean
    roles: [UserRoleInput]
    webToken: String!
    phone: String
  ): User
  updateCurrentUser(
    first_name: String
    last_name: String
    phone: String
    active: Boolean
    mfa_totp_enabled: Boolean
    mfa_totp_revealed: Boolean
    mfa_enabled: Boolean
  ): User
  updateUserPassword(
    new_password: String!
    old_password: String!
  ): Boolean
  createUser(
    first_name: String!
    last_name: String!
    email: String!
    mfa_enabled: Boolean
    mfa_totp_enabled: Boolean
    roles: [UserRoleInput]
  ): User
`;
var Xk = { types: Qk, queries: Jk, mutations: Zk };
const { gql: on } = e, { generateCollectionType: eh } = r, th = on`
  type UserProgram {
    ach: DnaAch
    active: Boolean
    auth_control_default: String
    auth_expiration_days: Int
    bank: DNABank
    created_time: String
    customer: DNACustomer
    direct_deposit: DnaDirectDeposit
    last_modified_time: String
    long_code: String
    marqeta_js_enabled: Boolean
    name: String
    parent_max_children: Int
    pin_create_reject_weak: Boolean
    plaid: DnaPlaid
    processor_only: Boolean
    ptc: DnaPtc
    program_id: ID
    short_code: String
    solution: String
    token: ID!
    uai_prefix: String
    regime: String
    bill_pay: DnaBillPay
  }

  ${eh("UserProgram")}
`, nh = on`
  programsByUser: UserProgramCollection
`, ih = on`
  
`;
var rh = { types: th, queries: nh, mutations: ih };
const { gql: sn } = e, { paginationParams: ah, generateCollectionType: oh } = r, sh = sn`
  type VelocityControl {
    token: ID!
    name: String
    association: Association
    merchant_scope: MerchantScope
    usage_limit: Int
    approvals_only: Boolean
    include_purchases: Boolean
    include_withdrawals: Boolean
    include_transfers: Boolean
    include_cashback: Boolean
    include_credits: Boolean
    currency_code: String
    amount_limit: Float
    velocity_window: String
    active: Boolean
    number_of_days: Int # Deprecated but still in use
  }

  input VelocityControlInput {
    token: ID
    name: String
    association: AssociationInput
    merchant_scope: MerchantScopeInput
    usage_limit: Int
    approvals_only: Boolean
    include_purchases: Boolean
    include_withdrawals: Boolean
    include_transfers: Boolean
    include_cashback: Boolean
    include_credits: Boolean
    currency_code: String!
    amount_limit: Float!
    velocity_window: String
    number_of_days: Int
    active: Boolean
  }

  ${oh("VelocityControl")}
`, ch = sn`
  velocityControl(token: ID!): VelocityControl
  velocityControls(
    business_token: String
    cardholder_token: String
    card_product_token: String
    ${ah}
  ): VelocityControlCollection
`, _h = sn`
  createVelocityControl(
    token: ID
    name: String
    association: AssociationInput
    merchant_scope: MerchantScopeInput
    usage_limit: Int
    approvals_only: Boolean
    include_purchases: Boolean
    include_withdrawals: Boolean
    include_transfers: Boolean
    include_cashback: Boolean
    include_credits: Boolean
    currency_code: String
    amount_limit: Float
    velocity_window: String
    number_of_days: Int
    active: Boolean
  ): VelocityControl

  updateVelocityControl(
    token: ID!
    name: String
    association: AssociationInput
    merchant_scope: MerchantScopeInput
    usage_limit: Int
    approvals_only: Boolean
    include_purchases: Boolean
    include_withdrawals: Boolean
    include_transfers: Boolean
    include_cashback: Boolean
    include_credits: Boolean
    currency_code: String
    amount_limit: Float
    velocity_window: String
    number_of_days: Int
    active: Boolean
  ): VelocityControl
`;
var dh = { types: sh, queries: ch, mutations: _h };
const { gql: cn } = e, { paginationParams: lh, generateCollectionType: uh } = r, gh = cn`
  type Webhook {
    token: ID!
    name: String!
    active: Boolean!
    created_time: String!
    last_modified_time: String!
    config: WebhookConfig
    events: [String]
  }

  type WebhookConfig {
    url: String
    basic_auth_username: String
    basic_auth_password: String
    custom_header: String
  }

  input WebhookConfigInput {
    url: String!
    basic_auth_username: String!
    basic_auth_password: String!
    custom_header: String
  }

  type WebhookPing {
    _: Boolean
  }

  ${uh("Webhook")}
`, ph = cn`
  webhook(
    token: ID!
  ): Webhook
  webhooks(
    ${lh}
  ): WebhookCollection
  pingWebhook(
    token: ID!
  ): WebhookPing
`, mh = cn`
  createWebhook(
    name: String!
    active: Boolean!
    config: WebhookConfigInput!
    events: [String]
  ): Webhook
  updateWebhook(
    token: ID!
    name: String!
    active: Boolean
    config: WebhookConfigInput!
    active: Boolean
    events: [String]
  ): Webhook
`;
var Sh = { types: gh, mutations: mh, queries: ph };
const { gql: ta } = e, yh = ta`
  type ZendeskTicketContainer {
    ticket: ZendeskTicket
  }
  type ZendeskTicket {
    id: String
    requester_id: String
    submitter_id: String
    url: String
    subject: String
    comment: ZendeskComment
    priority: String
  }
  type ZendeskComment {
    body: String
  }
  input ZendeskCommentInput {
    body: String
  }
  input ZendeskSubmitterInput {
    email: String
    firstName: String
    lastName: String
    phone: String
  }
`, Ch = ta`
  createZendeskTicket(
    attachments: [FileInput]
    comment: ZendeskCommentInput!
    priority: String
    subject: String!
    submitter: ZendeskSubmitterInput!
  ): ZendeskTicketContainer
`;
var Th = { types: yh, mutations: Ch };
const { gql: _n } = e, { paginationParams: zn, generateCollectionType: jn } = r, Ih = _n`
  type ZionApplicationToken {
    accessTokens: ZionAccessTokenCollection
    active: Boolean
    application_id: String
    application_type: String
    assets_url: String
    client_api_base_url: String
    consuming_applications: [String]
    created: String
    modified: String
    payments_api_base_url: String
    program_short_code: String
    program: String
    token: ID
  }

  type ZionAccessToken {
    accessed: String
    accesstoken_id: String
    applicationToken: ZionApplicationToken
    created: String
    hashed: Boolean
    last_four: String
    master_roles: [String]
    token_type: String
    token: ID
    user_token: String
  }

  type ZionAppAccessToken {
    applicationToken: ZionApplicationToken
    accessToken: ZionAccessToken
  }

  input ZionApplicationInput {
    active: Boolean!
    application_type: String!
    assets_url: String
    client_api_base_url: String
    payments_api_base_url: String
    token: ID
  }

  input ZionAccessInput {
    application_token: String
    master_roles: [String]
    one_time: Boolean
    token_type: String!
    token: String
    user_token: String
  }

  ${jn("ZionApplicationToken")}
  ${jn("ZionAccessToken")}
`, fh = _n`
  zionApplicationToken(
    token: ID!
  ): ZionApplicationToken
	zionApplicationTokens(
		${zn}
	): ZionApplicationTokenCollection
	zionAccessTokens(
    application_token: ID!
		${zn}
	): ZionAccessTokenCollection
`, Dh = _n`
  createZionAppAndAccessToken(
    applicationToken: ZionApplicationInput!
    accessToken: ZionAccessInput!
  ): ZionAppAccessToken
  updateZionAppToken(
    active: Boolean!
    application_type: String!
    assets_url: String
    client_api_base_url: String
    payments_api_base_url: String!
    token: ID!
  ): ZionApplicationToken
  createZionAccessToken(
    application_token: String!
    master_roles: [String]
    one_time: Boolean
    token_type: String!
    token: String
    user_token: String
  ): ZionAccessToken
  deleteZionAccessToken(
    accesstoken_id: String!
    application_token: ID!
  ): ZionAccessToken
`;
var Ah = { types: Ih, queries: fh, mutations: Dh };
const { gql: dn } = e, { generateCollectionType: kh } = r, hh = dn`
  type ExternalAccount {
    token: ID!
    alias: String
    business_token: String
    business_name: String
    user_token: String
    first_name: String
    last_name: String
    account_number: String
    sort_code: String
    routing_number: String
    iban: String
    bic: String
    country: String!
    currency: String!
    status: String!
    verification_token: String
    override: Boolean
    created_time: String
    last_modified_time: String
  }

  input CreateExternalAccountInput {
    verification_token: String!
    token: String
    alias: String
    override_verification: Boolean
    business_token: String
    business_name: String
    user_token: String
    first_name: String
    last_name: String
    account_number: String
    routing_number: String
    sort_code: String
    iban: String
    bic: String
    country: String
    currency: String
  }

  input UpdateExternalAccountInput {
    alias: String
    status: String
  }

  input ExternalAccountFilters {
    business_token: String
    user_token: String
    country: String
    currency: String
    status: String
    start_index: Int
    count: Int
    sortBy: String
  }

  ${kh("ExternalAccount")}
`, Eh = dn`
  externalAccounts(user_token: ID): ExternalAccountCollection

  externalAccount(token: String!): ExternalAccount

  externalAccountVerification(verification_token: String!): ExternalAccount

  externalAccountVerify(
    verification_token: String!
    account_number: String
    sort_code: String
    routing_number: String
    iban: String
    bic: String
    country: String
    currency: String
    user_token: String
    business_token: String
    first_name: String
    last_name: String
  ): ExternalAccount
`, $h = dn`
  externalAccountCreate(input: CreateExternalAccountInput!): ExternalAccount
  externalAccountUpdate(token: String!, input: UpdateExternalAccountInput!): ExternalAccount
  externalAccountVerify(input: CreateExternalAccountInput!): ExternalAccount
`;
var Ph = { types: hh, queries: Eh, mutations: $h };
const vh = ss, { Day: Rh } = ps, bh = Cs, Nh = fs, Bh = ks, Oh = $s, Fh = Rs, wh = Ms, qh = Hs, Mh = Ks, Uh = Qs, Lh = Uc, xh = Hc, Gh = Kc, Hh = Zc, Vh = t_, Yh = a_, Wh = c_, Kh = V_, zh = J_, jh = td, Qh = od, Jh = ud, Zh = Sd, Xh = fd, eE = hd, tE = Rd, nE = wd, iE = Ld, rE = Hd, aE = jd, oE = nl, sE = sl, cE = ll, _E = ml, dE = Il, lE = El, uE = bl, gE = Ol, pE = ql, mE = xl, SE = Kl, yE = Zl, CE = du, TE = pu, IE = Cu, fE = fu, DE = hu, AE = bu, kE = Ou, hE = qu, EE = Gu, $E = Wu, PE = Ju, vE = ig, RE = sg, bE = ug, NE = yg, BE = Ag, OE = Eg, FE = vg, wE = Bg, qE = wg, ME = Gg, UE = Wg, LE = Jg, xE = ep, GE = op, HE = _p, VE = up, YE = mp, WE = fp, KE = vp, zE = Np, jE = qp, QE = Hp, JE = zp, ZE = Xp, XE = im, e$ = om, t$ = lm, n$ = pm, i$ = Cm, r$ = Dm, a$ = Pm, o$ = Om, s$ = Mm, c$ = Vm, _$ = Qm, d$ = tS, l$ = oS, u$ = lS, g$ = CS, p$ = AS, m$ = bS, S$ = wS, y$ = US, C$ = KS, T$ = XS, I$ = ny, f$ = cy, D$ = gy, A$ = Sy, k$ = Bi, h$ = Ty, E$ = Fi, $$ = ky, P$ = Py, v$ = by, R$ = wy, b$ = Gy, N$ = Ky, B$ = Jy, O$ = nC, F$ = oC, w$ = _C, q$ = uC, M$ = CC, na = fC, U$ = kC, L$ = RC, x$ = wC, G$ = GC, H$ = WC, V$ = jC, Y$ = oT, W$ = lT, K$ = pT, z$ = CT, j$ = AT, Q$ = PT, J$ = NT, Z$ = FT, X$ = UT, eP = HT, tP = zT, nP = ZT, iP = iI, rP = oI, aP = dI, oP = pI, sP = fI, cP = EI, _P = RI, dP = BI, lP = qI, uP = HI, gP = KI, pP = JI, mP = ef, SP = rf, yP = sf, CP = ok, TP = uk, IP = mk, fP = Tk, DP = Dk, AP = hk, kP = Pk, hP = Bk, EP = Uk, $P = Hk, PP = Kk, vP = Xk, RP = rh, bP = dh, NP = Sh, BP = Th, OP = Ah, FP = Ph, wP = [
  ...CP,
  ...Kh,
  ...Y$,
  bh,
  Nh,
  Bh,
  Oh,
  Fh,
  wh,
  qh,
  Mh,
  Lh,
  xh,
  Gh,
  Hh,
  Vh,
  Yh,
  Wh,
  zh,
  jh,
  Qh,
  Jh,
  Zh,
  Xh,
  eE,
  tE,
  nE,
  iE,
  rE,
  aE,
  oE,
  sE,
  cE,
  _E,
  dE,
  lE,
  uE,
  gE,
  pE,
  mE,
  SE,
  yE,
  CE,
  TE,
  IE,
  fE,
  DE,
  AE,
  kE,
  hE,
  EE,
  $E,
  PE,
  vE,
  RE,
  bE,
  NE,
  BE,
  OE,
  FE,
  wE,
  qE,
  ME,
  UE,
  LE,
  xE,
  GE,
  HE,
  VE,
  YE,
  WE,
  KE,
  zE,
  jE,
  QE,
  JE,
  ZE,
  XE,
  e$,
  t$,
  n$,
  i$,
  r$,
  a$,
  o$,
  s$,
  c$,
  d$,
  _$,
  l$,
  u$,
  g$,
  p$,
  m$,
  S$,
  y$,
  C$,
  T$,
  I$,
  f$,
  D$,
  A$,
  k$,
  h$,
  E$,
  $$,
  Uh,
  P$,
  v$,
  R$,
  b$,
  N$,
  B$,
  O$,
  F$,
  w$,
  q$,
  M$,
  na,
  U$,
  L$,
  x$,
  G$,
  H$,
  V$,
  W$,
  K$,
  z$,
  j$,
  Q$,
  J$,
  Z$,
  X$,
  eP,
  tP,
  nP,
  iP,
  rP,
  aP,
  oP,
  sP,
  cP,
  _P,
  dP,
  lP,
  uP,
  gP,
  pP,
  mP,
  SP,
  yP,
  TP,
  IP,
  fP,
  DP,
  AP,
  kP,
  hP,
  EP,
  $P,
  PP,
  vP,
  RP,
  bP,
  NP,
  BP,
  OP,
  FP
], ia = [], ra = [], aa = [], oa = [];
wP.forEach((t) => {
  t.types && ia.push(t.types), t.queries && ra.push(t.queries), t.mutations && aa.push(t.mutations), t.scalars && oa.push(t.scalars);
});
const qP = vh`
  ${oa.join(`
`)}

  ${ia.join(`
`)}

  ${na}

  type Query {
    ${ra.join(`
`)}
  }

  type Mutation {
    ${aa.join(`
`)}
  }
`;
var sa = { typeDefs: qP, Day: Rh };
const MP = /* @__PURE__ */ B(pa), UP = /* @__PURE__ */ B(ma), LP = /* @__PURE__ */ B(Sa), xP = /* @__PURE__ */ B(ya), { ApolloClient: GP } = MP, { InMemoryCache: HP } = UP, { SchemaLink: VP } = LP, { makeExecutableSchema: YP } = xP, { typeDefs: WP } = sa, KP = di, zP = YP({
  typeDefs: WP,
  resolvers: KP,
  resolverValidationOptions: {
    requireResolversForResolveType: !1
  }
}), jP = new VP({
  schema: zP
}), QP = new HP(), JP = new GP({
  link: jP,
  cache: QP,
  credentials: "include"
});
var ZP = JP;
const XP = /* @__PURE__ */ B(Ca), { APPROVAL_QUEUE: N, UAM_GRANULAR_PERMISSIONS: ca } = XP, Te = [
  N.REQUEST_TYPES.PROGRAM_CONFIGURATION,
  N.REQUEST_TYPES.BULKISSUANCE,
  N.REQUEST_TYPES.MCC,
  N.REQUEST_TYPES.ACCEPTED_COUNTRIES,
  N.REQUEST_TYPES.CARD_PRODUCT,
  N.REQUEST_TYPES.APPLICATION_TOKEN,
  N.REQUEST_TYPES.ASSIGN_BIN_RANGES
];
function _a(t, n) {
  const a = t.flatMap(n);
  return Array.from(new Set(a));
}
function ev(t) {
  switch (t) {
    case "delivery-internal":
    case "production-support-internal":
      return Te;
    case ca.PROGRAM_CONFIGURATION_VIEW_AND_EDIT:
      return Te;
    case "manage-bin-data-internal":
      return [N.REQUEST_TYPES.ASSIGN_BIN_RANGES];
    default:
      return [];
  }
}
function tv(t) {
  return _a(t, ev);
}
function nv(t) {
  switch (t) {
    case "delivery-internal":
    case "production-support-internal":
      return Te;
    case ca.PROGRAM_CONFIGURATION_VIEW_AND_EDIT:
      return Te;
    case "review-bin-data-internal":
      return [N.REQUEST_TYPES.ASSIGN_BIN_RANGES];
    default:
      return [];
  }
}
function iv(t) {
  return _a(t, nv);
}
var rv = {
  getAllowedToManagePermissionTypesByRoles: tv,
  getAllowedToReviewPermissionTypesByRoles: iv
}, av = {
  approvalQueue: rv
};
const ov = Qn, sv = di, { typeDefs: cv } = sa, _v = ZP, { gql: dv } = e, lv = Ci, uv = av;
var gv = { fragments: ov, mockResolvers: sv, typeDefs: cv, mockClient: _v, gql: dv, templates: lv, utils: uv };
const kv = /* @__PURE__ */ Ta(gv);
export {
  kv as default
};
